module.exports = {
  "mentors": [
    {
      "mentorName": "Juan F. Mena",
      "mentorTitle": "Designer",
      "mentorMessage": "Seattle-based Senior Interaction Designer contracting at Disney. Willing to mentor on prototyping Framer, design+code.",
      "mentorTwitter": "https://www.twitter.com/72mena",
      "mentorEmail": "by72mena@gmail.com"
    },
    {
      "mentorName": "Zach Krasner",
      "mentorTitle": "Lead design team at Doorman",
      "mentorMessage": "Would love to offer any help to mentor others.",
      "mentorTwitter": "https://twitter.com/zachkrasner",
      "mentorEmail": "zach@doorman.co"
    },
    {
      "mentorName": "Daniel Fosco",
      "mentorTitle": "Lead design team at Doorman",
      "mentorMessage": "Product Designer at VTEX. DMs open, but I can also be reached through email",
      "mentorTwitter": "https://twitter.com/dfosco",
      "mentorEmail": "danielfosco@gmail.com"
    },
    {
      "mentorName": "Tyler Wain",
      "mentorTitle": "Senior UX Designer at @Dell",
      "mentorMessage": "",
      "mentorTwitter": "https://twitter.com/tyler_WAIN",
      "mentorEmail": ""
    },
    {
      "mentorName": "Jim Toepel",
      "mentorTitle": "Designer",
      "mentorMessage": "UX focused Design Lead for playful, body controlled interfaces and VR/AR. Also loves organizational behavior.",
      "mentorTwitter": "https://twitter.com/jimtoepel",
      "mentorEmail": "jim.toepel@gmail.com"
    },
    {
      "mentorName": "Zach Cole",
      "mentorTitle": "Product design @Lyft",
      "mentorMessage": "Systems, css, and js.",
      "mentorTwitter": "https://twitter.com/ZachACole",
      "mentorEmail": ""
    },
    {
      "mentorName": "Donny Wilson",
      "mentorTitle": "Designer",
      "mentorMessage": "I'm happy to offer any advice I can. Boston > New Hampshire product designer turned agency designer framer / js / css",
      "mentorTwitter": "https://twitter.com/DonnyWilson",
      "mentorEmail": ""
    },
    {
      "mentorName": "Tom Nazarian‏",
      "mentorTitle": "Designer",
      "mentorMessage": "Happy to be added -  15 years experience - Originally from Paris but now living in Sydney, Australia - running a digital company.",
      "mentorTwitter": "https://twitter.com/TomNazarian",
      "mentorEmail": ""
    },
    {
      "mentorName": "Thai Truong Lam",
      "mentorTitle": "Sr. Designer at Lazada.",
      "mentorMessage": "This will be a great chance to connect to awesome designers.",
      "mentorTwitter": "https://twitter.com/soundCreativ",
      "mentorEmail": "thaitruonglam@gmail.com"
    },
    {
      "mentorName": "Ryan Smith",
      "mentorTitle": "Designer",
      "mentorMessage": "Mobile IxD, at Providence Health & Services. Previously at Disney and Black Pixel.",
      "mentorTwitter": "https://twitter.com/byryan",
      "mentorEmail": "ryan@smithx.net "
    },
    {
      "mentorName": "Alex Evans",
      "mentorTitle": "Co-Founder and Programmer at Media Molecule",
      "mentorMessage": "i think your dm mentoring idea is cool. count me in; when time & skill permits, I'll do my best to help.",
      "mentorTwitter": "https://twitter.com/mmalex"
    },
    {
      "mentorName": "Hugo Moraleida",
      "mentorTitle": "Game Programmer at Klei",
      "mentorMessage": "Can mentor in games programming (works on indie games now), open DMs.",
      "mentorTwitter": "https://twitter.com/codenamehugs"
    },
    {
      "mentorName": "Ike",
      "mentorTitle": "Programmer",
      "mentorMessage": "I am also open to be asked questions about C/C++ and modern OpenGL graphics. I also speak Spanish.",
      "mentorTwitter": "https://twitter.com/Ikeruga"
    },
    {
      "mentorName": "Alan Wolfe",
      "mentorTitle": "Graphics Programmer at Blizzard",
      "mentorMessage": "with a toddler I don't have a ton of time, but can answer specific questions and have conversations about things.",
      "mentorTwitter": "https://twitter.com/Atrix256"
    },
    {
      "mentorName": "Toby Tremayne",
      "mentorTitle": "Founder at Magic Industries",
      "mentorMessage": "For what it’s worth, I’ll add to ’s initiative and say I’m open to fielding dev questions. 20 yrs enterprise app dev. Ask me architecture, javascript, webvr, hololens, etc.",
      "mentorTwitter": "https://twitter.com/magicindustries"
    },
    {
      "mentorName": "Jeff Rames",
      "mentorTitle": "iOS Developer at AirStrip Health",
      "mentorMessage": "Can mentor in iOS programming, open DMs.",
      "mentorTwitter": "https://twitter.com/jefframes"
    },
    {
      "mentorName": "Ali Helmy",
      "mentorTitle": "Animation Programmer at Crytek",
      "mentorMessage": "great idea! Let me offer my help for animation programming and procedural animation then :)",
      "mentorTwitter": "https://twitter.com/alihelmy"
    },
    {
      "mentorName": "Peter Abrahamsen",
      "mentorTitle": "Programmer",
      "mentorMessage": "& audience: I've got some grey hair, experience mentoring, and open DMs. Web code, IxD, product, startups, Amazon, contracting.",
      "mentorTwitter": "https://twitter.com/peidran"
    },
    {
      "mentorName": "Tom Forsyth",
      "mentorTitle": "VR Programmer at Oculus",
      "mentorMessage": "So I have no idea how to \"mentor\" people, but I can make your ears hurt with advice on low-level coding now and then. If that's a thing that sounds interesting then DM me. Obviously I reserve the right to (a) answer your questions in public and (b) not answer them at all. I do also have http://ask.fm/tom_forsyth  . As well as the mentoring thing, if there's any minority coders who need a signal boost or advice or whatever, then DM me how I can help. Where \"minority\" means if the picture in the top left doesn't look 99.99% like you. This industry is abysmally homogenous.",
      "mentorTwitter": "https://twitter.com/tom_forsyth"
    },
    {
      "mentorName": "Sean Parsons",
      "mentorTitle": "Programmer at Momentum",
      "mentorMessage": "I'm by no means a low level coder, but if anyone wants any guidance with functional programming or services I'm happy to help.",
      "mentorTwitter": "https://twitter.com/seanparsons"
    },
    {
      "mentorName": "Omer Shapira",
      "mentorTitle": "Senior VR Artist at NVIDIA",
      "mentorMessage": "Can mentor in solving design issues, code, theory, math, and how to run a project. DMs open.",
      "mentorTwitter": "https://twitter.com/omershapira"
    },
    {
      "mentorName": "Warren Moore",
      "mentorTitle": "Metal Ecosystem Development Engineer at Apple",
      "mentorMessage": "I’m looking for additional students and young professionals in the SF Bay Area to mentor in 3D graphics. Is that you? DMs open.",
      "mentorTwitter": "https://twitter.com/warrenm"
    },
    {
      "mentorName": "Andy Smith",
      "mentorTitle": "Game Programmer at Thelka",
      "mentorMessage": "I also have some spare time each week to do DM mentoring on graphics stuff wherever I can help!",
      "mentorTwitter": "https://twitter.com/anchsm"
    },
    {
      "mentorName": "Eric Engeström",
      "mentorTitle": "Software Engineer at Imagination Technologies",
      "mentorMessage": "I definitely don't consider myself an expert, but I like this trend is setting. Ask me any Linux graphics or driver questions",
      "mentorTwitter": "https://twitter.com/1ace"
    },
    {
      "mentorName": "Brandon Pomeroy",
      "mentorTitle": "3D Printing Engineer",
      "mentorMessage": "I'll throw my hat into 's ring. If you have any questions about any part of the 3D printing process, feel free to @ or dm me!",
      "mentorTwitter": "https://twitter.com/AchillePomeroy"
    },
    {
      "mentorName": "Patrick Monaghan",
      "mentorTitle": "Games Programmer",
      "mentorMessage": "I'm kinda into @sehurlburt's mentoring idea. If anyone's struggling or needs a hand with any general code stuff (mainly C++) I can help out",
      "mentorTwitter": "https://twitter.com/_manpat"
    },
    {
      "mentorName": "Joe",
      "mentorTitle": "Game Developer and Sound Designer",
      "mentorMessage": "I'm definitely up for helping out anyone with questions about sound design in games #mentor",
      "mentorTwitter": "https://twitter.com/makovalve"
    },
    {
      "mentorName": "Max Liani",
      "mentorTitle": "Senior Leading Engineer at Pixar",
      "mentorMessage": "@sehurlburt, adding to the chorus, DM me for Q&A about offline rendering, compact data structures and low level programming, or about becoming or improving as CG artist in films.",
      "mentorTwitter": "https://twitter.com/maxliani"
    },
    {
      "mentorName": "Mithun Hunsur",
      "mentorTitle": "Generalist Programmer",
      "mentorMessage": "I'll throw my hat in; I enjoy helping people with basic reverse engineering, game modding & low-level programming - DMs open!",
      "mentorTwitter": "https://twitter.com/Philpax_"
    },
    {
      "mentorName": "Omar Cornut",
      "mentorTitle": "Coder at LizardCube",
      "mentorMessage": "Also happy to help when I have time, DM always opened. Not sure what's my specialty!",
      "mentorTwitter": "https://twitter.com/ocornut"
    },
    {
      "mentorName": "R. Pavlik",
      "mentorTitle": "CTO at Sensics",
      "mentorMessage": "Thx for the push - low on spoons but feel a duty: \"modern C++\" and VR mentoring, with academic VR bg, for underrep. folks. DM me. also know a bunch of VR lit, willing to do quick mental/my papers database lit search to give folks a leg up and avoid wheel reinvention",
      "mentorTwitter": "https://twitter.com/rpavlik"
    },
    {
      "mentorName": "Jamie Hayes",
      "mentorTitle": "Engine/Graphics Programmer at Ready At Dawn",
      "mentorMessage": "I am willing to mentor 1 person at a time for 1-2mo stints (c++, game dev) via email n skype. Women/LGBT/POC strongly encouraged",
      "mentorTwitter": "https://twitter.com/jamiehayes81"
    },
    {
      "mentorName": "Krzysztof Kondrak",
      "mentorTitle": "Owner and Programmer at Code Magic",
      "mentorMessage": "Inspired by and few more people I admire, I have now opened my DM and am ready to help with programming, #gamedev math and VR!",
      "mentorTwitter": "https://twitter.com/k_kondrak"
    },
    {
      "mentorName": "kb",
      "mentorTitle": "Programmer at Ventuz",
      "mentorMessage": "count me in for audio stuff - DSP, audio engine architecture, compression, music, etc. Happy to help. :)",
      "mentorTwitter": "https://twitter.com/kebby"
    },
    {
      "mentorName": "Stephen Vanterpool",
      "mentorTitle": "iOS Programmer at Google",
      "mentorMessage": "I can mentor on iOS Programming.",
      "mentorTwitter": "https://twitter.com/sjvanterpool"
    },
    {
      "mentorName": "Xavier Ho",
      "mentorTitle": "Designer and Engineer at CSIRO",
      "mentorMessage": "Mentoring someone sounds like my jam! I do interaction design, graphics programming, and photography. Always happy to answer Qs.",
      "mentorTwitter": "https://twitter.com/Xavier_Ho"
    },
    {
      "mentorName": "Joel de Vahl",
      "mentorTitle": "Graphics Programmer at Unity",
      "mentorMessage": "I'll be glad to be on that list too. Graphics APIs, system/library design, general low level.",
      "mentorTwitter": "https://twitter.com/joeldevahl"
    },
    {
      "mentorName": "Simon Belak",
      "mentorTitle": "Data Scientist at GoOpti",
      "mentorMessage": "love the idea. Count me in. Can help with data science, machine learning, functional programming, architecture, startups",
      "mentorTwitter": "https://twitter.com/sbelak"
    },
    {
      "mentorName": "Arvid Gerstmann",
      "mentorTitle": "CTO at Voony Games",
      "mentorMessage": "You can add me, too. I'll try to help where I can. Mostly C / Engine, but also mobile iOS / Android.",
      "mentorTwitter": "https://twitter.com/ArvidGerstmann"
    },
    {
      "mentorName": "Hal Mueller",
      "mentorTitle": "iOS/Mac Developer",
      "mentorMessage": "Interests in geodata/maps, 3D graphics, SW engineering, Bluetooth LE.",
      "mentorTwitter": "https://twitter.com/halm"
    },
    {
      "mentorName": "Simon Barratt",
      "mentorTitle": "Game Developer and Startup Founder",
      "mentorMessage": "Great idea! Happy to help re biz, production, funding, code!",
      "mentorTwitter": "https://twitter.com/barog"
    },
    {
      "mentorName": "Arne Mertz",
      "mentorTitle": "C++ Software Developer",
      "mentorMessage": "here! General C++ and some clean code / Craftmanship stuff. DMs are open",
      "mentorTwitter": "https://twitter.com/arne_mertz"
    },
    {
      "mentorName": "aerique",
      "mentorTitle": "Enterprise Software Developer",
      "mentorMessage": "Hi Stephanie, you can add me for minorities in NL. I can help with introductions and basic (enterprise) dev. I'm near Delft.",
      "mentorTwitter": "https://twitter.com/aerique"
    },
    {
      "mentorName": "Monos",
      "mentorTitle": "Game Developer",
      "mentorMessage": "well, i'm somewhat capable with video/audio encoding and filtering with avi/vapour synth, also plugin \"author\" for the latter",
      "mentorTwitter": "https://twitter.com/MonoS94"
    },
    {
      "mentorName": "Dylan Nunns",
      "mentorTitle": "Software Developer",
      "mentorMessage": "I only have about 3 years experience and it's mostly been with PHP, and some C++ and iOS - but my DM is always open for anyone!",
      "mentorTwitter": "https://twitter.com/DylanNunns"
    },
    {
      "mentorName": "Adrian Hardjono",
      "mentorTitle": "Immersive Systems Architect",
      "mentorMessage": "Please add me Unity3D,C++, interactive installations, clustered rendering systems, VR, architecture and dev for above.",
      "mentorTwitter": "https://twitter.com/ardrian"
    },
    {
      "mentorName": "Roy Triesscheijn",
      "mentorTitle": "Game developer (serious games",
      "mentorMessage": "can you put me on the list as a C# dev from the Netherlands? :)",
      "mentorTwitter": "https://twitter.com/roytries"
    },
    {
      "mentorName": "Michael Quandt",
      "mentorTitle": "Software Developer at Animal Logic",
      "mentorMessage": "always happy to help anyone with an interest. Realtime gfx and film animation programming, engine dev and software engineering.",
      "mentorTwitter": "https://twitter.com/quandtm"
    },
    {
      "mentorName": "Kirill Dmitrenko",
      "mentorTitle": "Senior Frontend Developer at Yandex",
      "mentorMessage": "let's try :) I can help with WebGL and JavaScript",
      "mentorTwitter": "https://twitter.com/dmikis"
    },
    {
      "mentorName": "Bartlomiej Filipek",
      "mentorTitle": "C++ Software Engineer",
      "mentorMessage": "Happy to help! ask me about: C++, performance optimization, Windows native apps, OpenGL, Graphics",
      "mentorTwitter": "https://twitter.com/fenbf"
    },
    {
      "mentorName": "Balázs Török",
      "mentorTitle": "Engine Programmer",
      "mentorMessage": "I'm happy to talk anything including general engine programming, graphics, overlay dev, leading a team, working in gamedev, photography",
      "mentorTwitter": "https://twitter.com/m0radin"
    },
    {
      "mentorName": "David Tse",
      "mentorTitle": "Independent Game Developer",
      "mentorMessage": "I love talking about Vulkan/Engine stuff! DM or Skype: subsurfacegames",
      "mentorTwitter": "https://twitter.com/SubsurfaceGames"
    },
    {
      "mentorName": "Philip Dunstan",
      "mentorTitle": "Lead AI Programmer at Massive Entertainment",
      "mentorMessage": "Awesome idea! I'd be happy to help out. Particularly general gamedev, C++ and AI.",
      "mentorTwitter": "https://twitter.com/phildunstan"
    },
    {
      "mentorName": "Guy Hershenbaum",
      "mentorTitle": "Software Engineering Manager at Microsoft",
      "mentorMessage": "Can help with design/architecture,C++,C#,interviewing,systems programming, perf",
      "mentorTwitter": "https://twitter.com/GuyHershi"
    },
    {
      "mentorName": "Omar Mohamed Ali",
      "mentorTitle": "UE4 VR Developer at Framestore VRS",
      "mentorMessage": "I'm in with low level C++ VR for non mainstream devs :D",
      "mentorTwitter": "https://twitter.com/omigamedev"
    },
    {
      "mentorName": "Samuel Gosselin",
      "mentorTitle": "Systems Engineer",
      "mentorMessage": "I could definitely answer questions related to low level & embedded systems! :-)",
      "mentorTwitter": "https://twitter.com/voxelgrid"
    },
    {
      "mentorName": "Conor Stokes",
      "mentorTitle": "Founder/Lead Consultant at Burning Candle Software",
      "mentorMessage": "I'm always happy to mentor; my experience is pretty varied so I guess you could call me a generalist.",
      "mentorTwitter": "https://twitter.com/xDirtyPunkx"
    },
    {
      "mentorName": "Larz Smith",
      "mentorTitle": "Gameplay Programmer",
      "mentorMessage": "Can talk about gameplay programming, MMO style combat and systems. DMs are open.",
      "mentorTwitter": "https://twitter.com/Larzhino"
    },
    {
      "mentorName": "Bryant Drew Jones",
      "mentorTitle": "Co-Founder and Technical Game Designer at ArtBit",
      "mentorMessage": "I would love to help anyone interested in gameplay programming & design, especially those in the LGBT community.",
      "mentorTwitter": "https://twitter.com/sprybry"
    },
    {
      "mentorName": "James Widman",
      "mentorTitle": "C++ Software Engineer",
      "mentorMessage": "I'm ready to answer most questions about the C++ core language (grammar, types, conversions, etc)",
      "mentorTwitter": "https://twitter.com/JamesWidman"
    },
    {
      "mentorName": "JF St-Amour",
      "mentorTitle": "Senior Software Engineer at Riot Games",
      "mentorMessage": "Open DM, feel free to reach out about graphics/engine stuff, getting into the industry, w/e",
      "mentorTwitter": "https://twitter.com/JFStAmour"
    },
    {
      "mentorName": "Joseph Simons",
      "mentorTitle": "Senior Software Engineer at Iron Galaxy Studios",
      "mentorMessage": "I'm always willing to answer/mentor when I have the time: game dev, graphics, performance, c/c++, backend servers, team lead",
      "mentorTwitter": "https://twitter.com/sigmel"
    },
    {
      "mentorName": "Dave Elder",
      "mentorTitle": "Senior Graphics Programmer at Tripwire Interactive",
      "mentorMessage": "C++, graphics, DX11/12, multithreading, optimization, industry guidance, whatever. Hit me up!",
      "mentorTwitter": "https://twitter.com/DrGr4f1x"
    },
    {
      "mentorName": "Rajiv Puvvada",
      "mentorTitle": "Game Engineer at Amazon Game Studios",
      "mentorMessage": "I'll do what I can! Open DMs for generalist game engineering in mobile/AAA.",
      "mentorTwitter": "https://twitter.com/PyraRP"
    },
    {
      "mentorName": "Paul Evans",
      "mentorTitle": "Game Developer",
      "mentorMessage": "I'm more tools & infrastructure focused than others on that list. I will chat with people & reply as time & skill allow though.",
      "mentorTwitter": "https://twitter.com/paulecoyote"
    },
    {
      "mentorName": "Justin Liew",
      "mentorTitle": "Software Developer for The Coalition (Microsoft)",
      "mentorMessage": "I'm definitely in. C++ and general games experience. Now trying to be an ally to level the playing field for all.",
      "mentorTwitter": "https://twitter.com/justin_liew"
    },
    {
      "mentorName": "Aaron Gutierrez",
      "mentorTitle": "Associate Software Engineer at Blizzard",
      "mentorMessage": "I'd especially love to help out students since I'm new to the industry :)",
      "mentorTwitter": "https://twitter.com/argutierrez92"
    },
    {
      "mentorName": "Richard Sim",
      "mentorTitle": "Chief Engineer at PROXXI",
      "mentorMessage": "Hey yeah count me in! The list of what I do is kinda stupid long, but let’s narrow it down to hardware dev/prototyping/startups",
      "mentorTwitter": "https://twitter.com/richard_a_sim"
    },
    {
      "mentorName": "Cédric Bonnier",
      "mentorTitle": "C++/Qt Software Developer at FXHOME",
      "mentorMessage": "Still a junior C++ dev here but if I can help anyone I'd be more than happy :-D DMs are open.",
      "mentorTwitter": "https://twitter.com/cedricbonnier"
    },
    {
      "mentorName": "Jaymin Kessler",
      "mentorTitle": "Senior Optimization Engineer at InsightfulVR",
      "mentorMessage": "I'm always willing to answer some questions!",
      "mentorTwitter": "https://twitter.com/okonomiyonda"
    },
    {
      "mentorName": "Neil Forbes-Richardson",
      "mentorTitle": "Rendering Engineer at Wargaming",
      "mentorMessage": "I occasionally help people out through other channels, but happy for people to reach out to me.",
      "mentorTwitter": "https://twitter.com/neilogd"
    },
    {
      "mentorName": "Wessam Fathi",
      "mentorTitle": "Lead Console Programmer at YAGER",
      "mentorMessage": "I'd be happy to help!",
      "mentorTwitter": "https://twitter.com/NoXGameDev"
    },
    {
      "mentorName": "Innes MᶜKendrick",
      "mentorTitle": "Programmer at Hello Games",
      "mentorMessage": "I'm happy to talk code/proc gen/gamedev, esp with women and lgbtq+ folks",
      "mentorTwitter": "https://twitter.com/innesmck"
    },
    {
      "mentorName": "Dimitri Diakopoulos",
      "mentorTitle": "Lead VR Engineer at Intel",
      "mentorMessage": "Would love to mentor on c++/engines/rendering and especially low-level VR dev",
      "mentorTwitter": "https://twitter.com/ddiakopoulos"
    },
    {
      "mentorName": "Jon Olick",
      "mentorTitle": "Software Engineer at RAD Game Tools",
      "mentorMessage": "Can mentor in low-level programming, C++, optimization, compression. DMs open.",
      "mentorTwitter": "https://twitter.com/JonOlick"
    },
    {
      "mentorName": "Colin Riley",
      "mentorTitle": "Software Engineer at AMD RTG",
      "mentorMessage": "Happy to help folks in general optimization, low level coding, and FPGA tinkering!",
      "mentorTwitter": "https://twitter.com/domipheus"
    },
    {
      "mentorName": "Max Power",
      "mentorTitle": "Game Developer",
      "mentorMessage": "Can mentor in game development.",
      "mentorTwitter": "https://twitter.com/xewlupus"
    },
    {
      "mentorName": "Nathan Reed",
      "mentorTitle": "Freelance Graphics/Engine Programmer",
      "mentorMessage": "Can mentor in game, engine, and low-level graphics programming",
      "mentorTwitter": "https://twitter.com/Reedbeta"
    },
    {
      "mentorName": "Chris Wade",
      "mentorTitle": "Indie Game Developer",
      "mentorMessage": "I'm up for mentoring and answering specific questions on C#/Unity/Game Programming/Linear Algebra/Shaders",
      "mentorTwitter": "https://twitter.com/chriswade__"
    },
    {
      "mentorName": "Jasmin Patry",
      "mentorTitle": "Rendering Software Engineer at Sucker Punch Studios",
      "mentorMessage": "DMs are open, please add me! Will do my best to help with game graphics stuff :)",
      "mentorTwitter": "https://twitter.com/jasminpatry"
    },
    {
      "mentorName": "Charles Aylward",
      "mentorTitle": "Software Developer",
      "mentorMessage": "Great initiative! Opened my DMs. Distributed/real-time/embedded systems, firmware, functional programming, general/architecture",
      "mentorTwitter": "https://twitter.com/cdaylward"
    },
    {
      "mentorName": "Joe Kelly",
      "mentorTitle": "Audio Director at Microsoft HoloLens",
      "mentorMessage": "I'm more than happy to help anyone with audio engineering and game dev",
      "mentorTwitter": "https://twitter.com/udonengineering"
    },
    {
      "mentorName": "Troy Haran",
      "mentorTitle": "Software Engineer in Test at EA",
      "mentorMessage": "Feel free to count me in as a mentor too. Anyone wanting help with Angular, NodeJS, or almost anything web related, please DM :)",
      "mentorTwitter": "https://twitter.com/_Shoh"
    },
    {
      "mentorName": "Tamás Deme",
      "mentorTitle": "VR/AR/MR Developer",
      "mentorMessage": "happy to help with C#, UWP and some Unity stuff regarding Windows Holographic (eg. HoloLens). DMs open",
      "mentorTwitter": "https://twitter.com/tomzorz_"
    },
    {
      "mentorName": "John van der Burg",
      "mentorTitle": "Animation Programmer at EmotionFX",
      "mentorMessage": "Happy to help with animation system related questions :) and topics including 3d engine, qt for tools, api design and c++",
      "mentorTwitter": "https://twitter.com/JohnEMotionFX"
    },
    {
      "mentorName": "Dale Kim",
      "mentorTitle": "Associate Engine Programmer at Insomniac Games",
      "mentorMessage": "I have some experience which might be illuminating for those who want to get into game engine programming, especially students. I've done SIMD, pathfinding, palettized texture compression, game pack file formats, rudimentary spatial querying in 2D.",
      "mentorTwitter": "https://twitter.com/Roflraging"
    },
    {
      "mentorName": "Gijs Richard Kaerts",
      "mentorTitle": "Rendering Engineer at Skybox Labs",
      "mentorMessage": "Don't have lots of time, but always down to chat about shader programming, DirectX, Gfx engine architecture, ...",
      "mentorTwitter": "https://twitter.com/BelgianRenderer"
    },
    {
      "mentorName": "Nicholas Westby",
      "mentorTitle": "Web Developer",
      "mentorMessage": "Can mentor web tech: Umbraco, C#, Grunt, Angular 1, Sass, ASP .NET MVC, production optimization, architecture, tools, general...",
      "mentorTwitter": "https://twitter.com/MrMarsRed"
    },
    {
      "mentorName": "Adam Goodrich",
      "mentorTitle": "Author of Gaia/Gena on Unity Asset Store",
      "mentorMessage": "Happy to help with procedural generation and environmental design.",
      "mentorTwitter": "https://twitter.com/AdamGoodrich"
    },
    {
      "mentorName": "Stephen Whitmore",
      "mentorTitle": "Game Developer and Web Programmer",
      "mentorMessage": "Happy to help! I'm an open source programmer with exp in back-end and also 2d game development.",
      "mentorTwitter": "https://twitter.com/noffle"
    },
    {
      "mentorName": "Morgan McGuire",
      "mentorTitle": "Professor and Game Developer",
      "mentorMessage": "I'm happy to answer any technical question from anybody...but only in the open so that others can benefit. That's my price :)",
      "mentorTwitter": "https://twitter.com/CasualEffects"
    },
    {
      "mentorName": "Cort Stratton",
      "mentorTitle": "VR Graphics Programmer (Vulkan) at Google",
      "mentorMessage": "I had to give up teaching earlier this year; this would scratch that itch nicely. What I'm most qualified to help people with at this point is moving from GL to Vulkan. I'm also happy to offer advice on general low-level programming.",
      "mentorTwitter": "https://twitter.com/postgoodism"
    },
    {
      "mentorName": "Branimir Karadžić",
      "mentorTitle": "Graphics Programmer",
      "mentorMessage": "Can help with graphics and engine programming, author of bgfx (open source cross-platform graphics library).",
      "mentorTwitter": "https://twitter.com/bkaradzic"
    },
    {
      "mentorName": "Leo Benaducci",
      "mentorTitle": "Lead Programmer at ACE Team",
      "mentorMessage": "I'm a C++ engine/graphics programmer with several years of experience in UE3 and UE4. I also speak Spanish.",
      "mentorTwitter": "https://twitter.com/leobenaducci"
    },
    {
      "mentorName": "Rolando Caloca",
      "mentorTitle": "Senior Engine Programmer at Epic Games",
      "mentorMessage": "You can add me to the mentoring list, would love helping on low level coding, optimizations, Vulkan, etc",
      "mentorTwitter": "https://twitter.com/RCalocaO"
    },
    {
      "mentorName": "Nick Porcino",
      "mentorTitle": "Senior Engineer at Apple",
      "mentorMessage": "Open to questions on engines, game dev, and film/tv/vfx pipeline",
      "mentorTwitter": "https://twitter.com/meshula"
    },
    {
      "mentorName": "Angelo Pesce",
      "mentorTitle": "Rendering Technical Director at Activision",
      "mentorMessage": "Can mentor in graphics and engine programming.",
      "mentorTwitter": "https://twitter.com/kenpex"
    },
    {
      "mentorName": "Mike Nicolella",
      "mentorTitle": "Engineer at Bungie",
      "mentorMessage": "I'm happy to help folks via DM. I'm a generalist with interests in networking, graphics, multithreaded systems, reverse engineering, compilers, and all things low-level!",
      "mentorTwitter": "https://twitter.com/MikeNicolella"
    },
    {
      "mentorName": "Brett Douville",
      "mentorTitle": "Programmer",
      "mentorMessage": "Generalist video game programmer, mostly C++, did a lot of leading, too, on Skyrim, etc.",
      "mentorTwitter": "https://twitter.com/brett_douville"
    },
    {
      "mentorName": "Stoyan Nikolov",
      "mentorTitle": "Co-Founder and Lead Tech at Coherent Labs",
      "mentorMessage": "I'd be happy to help as well. I dig core engine architecture, parallelism and VR graphics.",
      "mentorTwitter": "https://twitter.com/stoyannk"
    },
    {
      "mentorName": "Nico Galoppo",
      "mentorTitle": "Software Engineer at Intel",
      "mentorMessage": "Graphics, compute APIs, computer vision, GPUs & low level programming.",
      "mentorTwitter": "https://twitter.com/ngaloppo"
    },
    {
      "mentorName": "Kirk Shaw",
      "mentorTitle": "IT Engineer at Media Molecule",
      "mentorMessage": "Feel free to add me to the list if anyone wants advice on IT related things. I'm a generalist in IT but been doing Games/IT 12y+",
      "mentorTwitter": "https://twitter.com/KShaw_"
    },
    {
      "mentorName": "Stephen Keefer",
      "mentorTitle": "Senior Software Developer at AccuWeather",
      "mentorMessage": "add me into the list of peeps to hit up for mentoring, advice, questions",
      "mentorTwitter": "https://twitter.com/StephenKeefer"
    },
    {
      "mentorName": "Shaun Peoples",
      "mentorTitle": "Owner and Programmer at Durham Games",
      "mentorMessage": "Can ask about game development and general programming questions",
      "mentorTwitter": "https://twitter.com/ShaunPeoples"
    },
    {
      "mentorName": "Felix Bytow",
      "mentorTitle": "C/C++/Perl Programmer",
      "mentorMessage": "Great idea, I think I can help out with C++ and Perl (also XS).",
      "mentorTwitter": "https://twitter.com/structFooBar"
    },
    {
      "mentorName": "Christopher Najewicz",
      "mentorTitle": "Senior DevOps Engineer at nearForm",
      "mentorMessage": "always willing to answer questions re: devops, software dev etc.",
      "mentorTwitter": "https://twitter.com/tehsuck"
    },
    {
      "mentorName": "argontus",
      "mentorTitle": "Programmer",
      "mentorMessage": "oh and I guess I can help gaining perspective on systems/archi etc. I'm a generalist:) @/DM",
      "mentorTwitter": "https://twitter.com/argontus_"
    },
    {
      "mentorName": "Stewart Henderson",
      "mentorTitle": "Programmer at Uptake",
      "mentorMessage": "I am game for helping out. In-person in the Chicagoland area or digitally otherwise.",
      "mentorTwitter": "https://twitter.com/__shenderson__"
    },
    {
      "mentorName": "Frank Pinto",
      "mentorTitle": "VP of Engineering",
      "mentorMessage": "I'd love to help. VP of Eng. at a FinTech startup. Former startup founder / CTO. Webapp full stack dev (Ruby, Node, React, etc.)",
      "mentorTwitter": "https://twitter.com/frankjpinto"
    },
    {
      "mentorName": "Mike Kelly",
      "mentorTitle": "Senior Developer at Reaktiv Studios",
      "mentorMessage": "I'd love to be added... Full Stack Web Developer at Reaktiv Studios",
      "mentorTwitter": "https://twitter.com/grumpdevpodcast"
    },
    {
      "mentorName": "Mariusz Pasiński",
      "mentorTitle": "Game Developer and Ableton Live user",
      "mentorMessage": "not sure if it counts but I'm ready to help with C++ gamedev, GL, scripting and basic low-level stuff. Windows, Linux & Android",
      "mentorTwitter": "https://twitter.com/mani3xis"
    },
    {
      "mentorName": "Aleš Mlakar",
      "mentorTitle": "Principal Software Engineer at Outfit7",
      "mentorMessage": "you can add me too - C++ & C#, Unity, mobile, optimization,...",
      "mentorTwitter": "https://twitter.com/amjazzbre"
    },
    {
      "mentorName": "Sven Hesse",
      "mentorTitle": "Programmer",
      "mentorMessage": "I am willing to answer questions about low-level C/C++, AVR, disassembly/reversing of DOS adventures, as my time permits :)",
      "mentorTwitter": "https://twitter.com/TheRealDrMcCoy"
    },
    {
      "mentorName": "Indy Ray",
      "mentorTitle": "Senior Graphics Engineer",
      "mentorMessage": "you can add me to the list! Many years of experience in graphics, engine and tools development.",
      "mentorTwitter": "https://twitter.com/ScatteredRay"
    },
    {
      "mentorName": "waddlesplash",
      "mentorTitle": "Programmer at Haiku",
      "mentorMessage": "Userspace OS development, OS ports & packaging, multiprocess architectures, parsers of any kind, jQuery/Bootstrap web dev, x-platform dev w/ & w/o 3rd-party libs, server-side web dev, literally anything build systems related (esp. CMake), domain-specific languages, UX design & implementation, end-user & API documentation. C, C++, JS, Python, PHP, Bash. I work on @haikuOS doing just about everything; professionally, on web apps & microservices mostly.",
      "mentorTwitter": "https://twitter.com/waddlesplash"
    },
    {
      "mentorName": "Keith Kaisershot",
      "mentorTitle": "Programmer",
      "mentorMessage": "15+ years of asm/C/C++ coding from classic Mac to latest console/PC.",
      "mentorTwitter": "https://twitter.com/ablitter"
    },
    {
      "mentorName": "Ben Goldstein",
      "mentorTitle": "Technical Director at Sony Santa Monica",
      "mentorMessage": "Just left a tech lead job @UbisoftMTL to join the team at @SonySantaMonica. About to start year #17 in console dev. Happy 2 help",
      "mentorTwitter": "https://twitter.com/mindfeedsf"
    },
    {
      "mentorName": "El Marcel",
      "mentorTitle": "Engineer on LLVM",
      "mentorMessage": "I'm game! C++, low-level, graphics, how to survive as an expat :) DMs open.",
      "mentorTwitter": "https://twitter.com/ElMarcel"
    },
    {
      "mentorName": "yse",
      "mentorTitle": "Data Scientist at Tapad",
      "mentorMessage": "I can answer questions about the leap from academia to data science and gender diversity in tech.",
      "mentorTwitter": "https://twitter.com/y_s_e"
    },
    {
      "mentorName": "AL",
      "mentorTitle": "Programmer",
      "mentorMessage": "I can definitely help more junior coders about C, C++, Rust, systems and programming in general.",
      "mentorTwitter": "https://twitter.com/TheEpsylon"
    },
    {
      "mentorName": "Steven Seeley",
      "mentorTitle": "Security Researcher",
      "mentorMessage": "feel free to add me, although I focus on security.",
      "mentorTwitter": "https://twitter.com/steventseeley"
    },
    {
      "mentorName": "Oli",
      "mentorTitle": "Programmer and Game Developer",
      "mentorMessage": "feel like I'd like to help, I'm a generalist with a background in data and cloud. AMA.",
      "mentorTwitter": "https://twitter.com/evolutionalgd"
    },
    {
      "mentorName": "Jay Patel",
      "mentorTitle": "COO at Varmora Infotech Pvt ltd",
      "mentorMessage": "Add me up if newbie wants to start in OpenBSD I can help out. I am COO at Varmora Infotech Pvt ltd, India.",
      "mentorTwitter": "https://twitter.com/jaypatelvipl"
    },
    {
      "mentorName": "Davide Faconti",
      "mentorTitle": "Robotics Researcher",
      "mentorMessage": "Count me in for this mentoring initiative. I can help with c++ and robotics",
      "mentorTwitter": "https://twitter.com/facontidavide"
    },
    {
      "mentorName": "James Golding",
      "mentorTitle": "Lead Programmer at Epic Games",
      "mentorMessage": "Happy to answer questions on gameplay, animation, physics, collision, scripting, tools, and general career stuff!",
      "mentorTwitter": "https://twitter.com/EpicJamesG"
    },
    {
      "mentorName": "Trent Polack",
      "mentorTitle": "Founder of Joy Machine Games",
      "mentorMessage": "Toss me into the mix! Gameplay/engine/graphics programmer, systems designer, level designer, tech artist, creative director.",
      "mentorTwitter": "https://twitter.com/mittense"
    },
    {
      "mentorName": "Isaac Besora",
      "mentorTitle": "Engineer",
      "mentorMessage": "add one more to the list. IOS, Android, web programming, geodata/maps, 3D maths and SW engineering. Going to open my DM!",
      "mentorTwitter": "https://twitter.com/ibesora"
    },
    {
      "mentorName": "Marek Krajewski",
      "mentorTitle": "C++ Programmer",
      "mentorMessage": "you can add me as well, but I only know some C++, no game progr.",
      "mentorTwitter": "https://twitter.com/mrkkrj"
    },
    {
      "mentorName": "Tim Chavalier",
      "mentorTitle": "SRE at Google",
      "mentorMessage": "I'd like to be on the list -- Tim Chevalier, SRE at Google with background in compilers and functional programming. Priority to people marginalized based on race, transness, disability, and/or mental illness. DMs open.",
      "mentorTwitter": "https://twitter.com/fatneckbeardguy"
    },
    {
      "mentorName": "Lindsay Kay",
      "mentorTitle": "3D Visualization App/Engine Developer",
      "mentorMessage": "Put me down for WebGL engine dev, architecture and perf.",
      "mentorTwitter": "https://twitter.com/xeographics"
    },
    {
      "mentorName": "Eric Smolikowski",
      "mentorTitle": "Principal Imagineer at Disney",
      "mentorMessage": "You can add me to the list as well. Always happy to share my experience with the younger generation.",
      "mentorTwitter": "https://twitter.com/esmolikowski"
    },
    {
      "mentorName": "David Neubelt",
      "mentorTitle": "Graphics Programmer at Ready at Dawn",
      "mentorMessage": "Can mentor in C++, graphics, engine, and game programming.",
      "mentorTwitter": "https://twitter.com/daveneubelt"
    },
    {
      "mentorName": "Rebecca Heineman",
      "mentorTitle": "Game Programmer",
      "mentorMessage": "I am available to mentor on C, C++ and the deep dark dismal realm of assembly language, like ARM, ARM64, AMD64, x86, PPC etc...",
      "mentorTwitter": "https://twitter.com/burgerbecky"
    },
    {
      "mentorName": "Matthieu Delaere",
      "mentorTitle": "Lecturer on Graphics and Gameplay Programming",
      "mentorMessage": "As a teacher I am always willing to help people out (c++, directx, unity/c#) on all levels in my spare time!",
      "mentorTwitter": "https://twitter.com/TheGoozah"
    },
    {
      "mentorName": "Stuart Blackler",
      "mentorTitle": "C# Engineer at Redweb",
      "mentorMessage": "Happy to help with C# things",
      "mentorTwitter": "https://twitter.com/Im5tu"
    },
    {
      "mentorName": "Francis Boivin",
      "mentorTitle": "3D Programmer at Ubisoft Montreal",
      "mentorMessage": "Late to the party, but will do my best to answer questions. 15y @UbisoftMTL, 3D console programming, team lead, debugging",
      "mentorTwitter": "https://twitter.com/francisboivin"
    },
    {
      "mentorName": "Dimitar Mirchev",
      "mentorTitle": "C++ Developer",
      "mentorMessage": "C++ Enthusiast from Bulgaria also one of C++ User Group Sofia organizers. Glad to help anyone",
      "mentorTwitter": "https://twitter.com/DVMirchev"
    },
    {
      "mentorName": "Mathias Wahlin",
      "mentorTitle": "Indie Game Developer and Graphics Programmer",
      "mentorMessage": "I can help out with game engine, gameplay and graphics programming.",
      "mentorTwitter": "https://twitter.com/fohx"
    },
    {
      "mentorName": "Dave Wood",
      "mentorTitle": "Indie Developer at roboheadz",
      "mentorMessage": "happy to help people with getting started with data analysis ! 14 years experience in that type of stuff for a big corp, happy to help newbies if I can",
      "mentorTwitter": "https://twitter.com/dwroboheadz"
    },
    {
      "mentorName": "Adabelle Leirum",
      "mentorTitle": "Game Programmer at Massive Entertainment",
      "mentorMessage": "I'd love to be a part of this! Anything about working with games, c++, Sweden etc",
      "mentorTwitter": "https://twitter.com/theelderbelle"
    },
    {
      "mentorName": "Sven Adersson",
      "mentorTitle": "Engine Programmer at King Games on the Defold Engine",
      "mentorMessage": "always happy to help.",
      "mentorTwitter": "https://twitter.com/andsve"
    },
    {
      "mentorName": "Amandine Coget",
      "mentorTitle": "Engine Programmer",
      "mentorMessage": "You can add me, I'm happy to answer questions on GFX / games / UI but ONLY from people who are marginalized on some axis.",
      "mentorTwitter": "https://twitter.com/LiaSae"
    },
    {
      "mentorName": "Garry Johanson",
      "mentorTitle": "Engine Programming Student",
      "mentorMessage": "im a student willing to mentor other students. i study independently on various handmade network streams.",
      "mentorTwitter": "https://twitter.com/garryjohanson"
    },
    {
      "mentorName": "Mustafa Toroman",
      "mentorTitle": "Systems Engineer",
      "mentorMessage": "count me in on this, if anyone wants some help with infrastructure and Azure, I'm more then happy to help",
      "mentorTwitter": "https://twitter.com/toromust"
    },
    {
      "mentorName": "Sam Littlewood",
      "mentorTitle": "Graphics Programmer",
      "mentorMessage": "C, C++, Python, Graphics. Games, Embedded, Servers/back end, AWS. UK times.",
      "mentorTwitter": "https://twitter.com/samlittlewood"
    },
    {
      "mentorName": "Jigar Doshi",
      "mentorTitle": "PhD Student at Georgia Tech",
      "mentorMessage": "I can share my experience in AI/Deep Learning, Robotics, Computer Vision. Feel free to DM. Happy to help!",
      "mentorTwitter": "https://twitter.com/jigarkdoshi"
    },
    {
      "mentorName": "Alice Ching",
      "mentorTitle": "Engine Programmer at Funomena",
      "mentorMessage": "Can mentor in game, engine, and C++ programming. Currently at Funomena, previously at Google.",
      "mentorTwitter": "https://twitter.com/oilaisee"
    },
    {
      "mentorName": "Jeremy Tregunna",
      "mentorTitle": "iOS Engineer",
      "mentorMessage": "C/Swift/Elixir covering areas around games",
      "mentorTwitter": "https://twitter.com/jtregunna"
    },
    {
      "mentorName": "Dan Luria",
      "mentorTitle": "Lead Software Engineer",
      "mentorMessage": "Definitely interested! I can help with career advice, mentoring new or aspiring Leads/Managers, and fullstack dev (esp. JS/ES6)",
      "mentorTwitter": "https://twitter.com/whichdan"
    },
    {
      "mentorName": "Samuel Maskell",
      "mentorTitle": "Android Engineer at Twitter",
      "mentorMessage": "I'm happy to help if needed. Android engineer @ Twitter. DM's open. also interested in functional programming (scala, lisp, Haskell) and introductory ML",
      "mentorTwitter": "https://twitter.com/samuelmaskell"
    },
    {
      "mentorName": "David Koontz",
      "mentorTitle": "Game Developer",
      "mentorMessage": "Gamedev (C#, Unity), Javascript, Functional Programming (Haskell, Elm, Purescript)",
      "mentorTwitter": "https://twitter.com/dkoontz"
    },
    {
      "mentorName": "Matthew Bell",
      "mentorTitle": "Lead Game Programmer at WayForward",
      "mentorMessage": "Tend to be on small teams so touch many areas. Hoping to do my part to encourage diversity in our field. open to just being asked questions without askers committing to being mentored, too. C++/Unity/Shaders",
      "mentorTwitter": "https://twitter.com/MatthewDBell"
    },
    {
      "mentorName": "Roberto",
      "mentorTitle": "Programmer",
      "mentorMessage": "Have about 3 yrs of pro experience + 3 yrs self taught. I can mentor anyone in core Java + basic Scala, Android",
      "mentorTwitter": "https://twitter.com/rburgosnavas"
    },
    {
      "mentorName": "william j. moner",
      "mentorTitle": "Assistant Professor, Interactive Media & Communication Design, Elon U. @eloncomm @EloniMedia. UT Austin alum. Pittsburgh-born. All things web/design.",
      "mentorMessage": "If your followers want someone versed in media studies, critical theory, and web/interactive production, I’m that w… ",
      "mentorTwitter": "https://twitter.com/williamj"
    },
    {
      "mentorName": "Jaime Woo",
      "mentorTitle": "Hopeless nerd. Shade machine. My book on Grindr lost to Hilton Als for an award. Tweets self-destruct after 14 days.",
      "mentorMessage": "If anyone is interested in technical or engineering communications (which is actually separate from technical writi… ",
      "mentorTwitter": "https://twitter.com/jaimewoo"
    },
    {
      "mentorName": "Nick Doiron",
      "mentorTitle": "world-traveling open source dev & mapmaker @SVB_Financial. Formerly @MuseumModernArt, @OLPC edu tech, civic tech @codeforamerica, Boston, &  @Asia_Foundation",
      "mentorMessage": "I welcome questions about tech and travel as long as it doesn’t violate an NDA ",
      "mentorTwitter": "https://twitter.com/mapmeld"
    },
    {
      "mentorName": "Nikose",
      "mentorTitle": "Too Old [29] • Married • Apparently a real live adult",
      "mentorMessage": "Hey, I know a lot of bullshit about money, credit and mortgages. I’m always open to talk. ",
      "mentorTwitter": "https://twitter.com/Nikose_Tyris"
    },
    {
      "mentorName": "mr. waddlesplash",
      "mentorTitle": "@haikuOS developer & @mGBA_emu contributor. Serial software tinkerer. Slowly being succumbed into the infosec hivemind.",
      "mentorMessage": "Hey! Stuff I’m good at that’s less talked about: build tooling, software packaging/distribution, systems design. As… ",
      "mentorTwitter": "https://twitter.com/waddlesplash"
    },
    {
      "mentorName": "Dustin Land",
      "mentorTitle": "[Personal Account] I may or may not work at id software.  Also, light is too slow.",
      "mentorMessage": "12 years coding. Seen the underbelly of many things. General Tech, C++, and currently Vulkan. #HurlburtHelps ",
      "mentorTwitter": "https://twitter.com/DustinHLand"
    },
    {
      "mentorName": "Kris Siegel",
      "mentorTitle": "I create things by typing nonsense into a computer. Some call this programming. Senior Engineer @PlayStation (tweets are my own). Created msngr.js (https://t.co/jwRVOqvUOB)",
      "mentorMessage": "@sehurlburt is one I see trying to make Twitter a place for finding mentors so this may help w/ question… ",
      "mentorTwitter": "https://twitter.com/KrisSiegel"
    },
    {
      "mentorName": "Chris Oldwood",
      "mentorTitle": "tweet = reinterpret_cast(life)",
      "mentorMessage": "Looking for some advice about writing dreadful programming related puns? I’m always here for you…  ",
      "mentorTwitter": "https://twitter.com/chrisoldwood"
    },
    {
      "mentorName": "Corey Quinn",
      "mentorTitle": "Public Speaker, Cloud Economist, and snappy dresser. Father to @QuinnyPiglet. Writes https://t.co/EPbRRMqxAp.",
      "mentorMessage": "I don’t know what’s next for me– so let’s talk about what’s next for you. I can talk ops, careers, strategy, cloud… ",
      "mentorTwitter": "https://twitter.com/QuinnyPig"
    },
    {
      "mentorName": "Alex Nobert",
      "mentorTitle": "Post-macho feminist, renowned overeater, stay at home dog dad. Leader, advisor, board member, investor. Really into 🍽️⭐🏈🐕🛫🌍📷☀️🔋🚘🎮🛍️👔👞 He/hmm",
      "mentorMessage": "I help (mostly ops) people with career advice, e.g. CVs, salary negotiations, interviewing, growth and advancement,… ",
      "mentorTwitter": "https://twitter.com/nobert"
    },
    {
      "mentorName": "Miranda VanHorn",
      "mentorTitle": "Communications Assistant @CopperPointMu  Blizzard fan with no chill and often told to use my inside voice.",
      "mentorMessage": "This looks like a really great resource if you are an engineer looking for some support ",
      "mentorTwitter": "https://twitter.com/mlvanhorn"
    },
    {
      "mentorName": "Old Man Marsh",
      "mentorTitle": "Likes games(both video and tabletop), coffee, music and more stuff. Also generally boring.  If you see this username on other sites, it’s not necessarily me.",
      "mentorMessage": "Lots of people offering a hand for different programming related things in @sehurlburt’s timeline right now! ",
      "mentorTwitter": "https://twitter.com/OldManMarsh"
    },
    {
      "mentorName": "Brian P. Hogan",
      "mentorTitle": "Web developer, author, PragProg editor, teacher, student, musician. I create things on the Internet and craft words at @digitalocean.  My opinions are my own.",
      "mentorMessage": "I’m open to questions about Ruby, JS, interviewing, teaching people to code, and technical writing/speaking. ",
      "mentorTwitter": "https://twitter.com/bphogan"
    },
    {
      "mentorName": "Noel Rappin",
      "mentorTitle": "Noel Rappin is a developer at Table XI. He is the author of Take My Money: Accepting Payment on the Web and Rails 4 Test Prescriptions",
      "mentorMessage": "Okay, this: I’m open to questions about Ruby, Testing, Web apps with money, hiring and interviews, agile, go ahead… ",
      "mentorTwitter": "https://twitter.com/noelrap"
    },
    {
      "mentorName": "Brian P. Hogan",
      "mentorTitle": "Web developer, author, PragProg editor, teacher, student, musician. I create things on the Internet and craft words at @digitalocean.  My opinions are my own.",
      "mentorMessage": "Always open to questions. ",
      "mentorTwitter": "https://twitter.com/bphogan"
    },
    {
      "mentorName": "Tarek Sherif",
      "mentorTitle": "I colour pixels for the @biodigitalhuman",
      "mentorMessage": "Happy to help with WebGL, 3D graphics. ",
      "mentorTwitter": "https://twitter.com/thsherif"
    },
    {
      "mentorName": "Bill Tribble",
      "mentorTitle": "UX Designer at @Toptal. Instructor at @GA. Also make music: @getspudboy / https://t.co/cmWBJAcYwo",
      "mentorMessage": "Ask me anything about UX, digital product design, drawing, or audio engineering. Always happy to help if I can! ",
      "mentorTwitter": "https://twitter.com/bill_tribble"
    },
    {
      "mentorName": "Eric Blomquist",
      "mentorTitle": "Art Director and Animator for Enlightened Games and Rocketcat Studios! /////////// Mostly flawed. Fully ridiculous. Flails often. Obnoxiously happy. :)",
      "mentorMessage": "Always available for questions about animation, modeling, game dev!! Oh and I’m a nutrition/exercise nut! ",
      "mentorTwitter": "https://twitter.com/thewillofb"
    },
    {
      "mentorName": "Christopher Kruse",
      "mentorTitle": "AWS Engineer, Puzzle addict, Chorus singer, and a teller of terrible puns.",
      "mentorMessage": "Anyone who needs it, feel free to reach out about app deployment, automation, CI/CD and cloud best practices. Alway… ",
      "mentorTwitter": "https://twitter.com/ballpointcarrot"
    },
    {
      "mentorName": "Tomasz Łakomy",
      "mentorTitle": "Software Engineer at Egnyte. Passionate about React, Haribo bears and making cheesiest jokes known to mankind.",
      "mentorMessage": "If you have any questions about React, I’d love to help! ",
      "mentorTwitter": "https://twitter.com/tlakomy"
    },
    {
      "mentorName": "Roger Steve Ruiz ☁️",
      "mentorTitle": "web engineer/sre at @18F maintaining concourse-aged non-artisanal BOSH deployments for https://t.co/4o1Ka7OdcH; feminist. Speaks/bespoke only for themselves.",
      "mentorMessage": "HMU if you’ve ever struggled with JavaScript, Rust, Git, Vim, Tmux, Linux, web development,  or general troubleshoo… ",
      "mentorTwitter": "https://twitter.com/rogeruiz"
    },
    {
      "mentorName": "Gedalia Pasternak",
      "mentorTitle": "Software developer by night, avenging super hero by day… maybe I’ve got that wrong. C++ graphics and Game Dev.",
      "mentorMessage": "I’m feeling shamed, 20 yrs of C++, OpenGL, game dev, mil vizsim, tools dev, Lua, robotics, Occasionally I know thin… ",
      "mentorTwitter": "https://twitter.com/gedaliap"
    },
    {
      "mentorName": "Bill Broughton",
      "mentorTitle": "I make stuff for humans. Full-stack developer, creator of https://t.co/dHkHUYCmTb, family man, car and motorcycle enthusiast",
      "mentorMessage": "Open to any and all questions on JavaScript, Angular, etc… Just getting into ML, so probably not useful source of… ",
      "mentorTwitter": "https://twitter.com/billtechspring"
    },
    {
      "mentorName": "David Amador",
      "mentorTitle": "Indie game developer (like that movie) running @UpfallStudios. Maker of Quest of Dungeons, currently working on new stuff. https://t.co/CXDwUnaHnC",
      "mentorMessage": "I know some stuff about gamedev, C++, custom engines, shipping on several platforms, etc. DM’s are open. Don’t know… ",
      "mentorTwitter": "https://twitter.com/DJ_Link"
    },
    {
      "mentorName": "Sophie Robbins ♥ ✍️",
      "mentorTitle": "✍️Author 🖌️Artist 💜 Queer 💞  I spend 90% of my life in Blender/Zbrush/Unreal Engine. I do game dev and stuff.",
      "mentorMessage": "I know lots of things about #Blender3d, some things about #UnrealEngine4 and a few things about #Zbrush! And I don’… ",
      "mentorTwitter": "https://twitter.com/SophieRTweeting"
    },
    {
      "mentorName": "Stan",
      "mentorTitle": "I write ruby code and technical debt (aka javascript). CTO @Drawbotics",
      "mentorMessage": "Young CTO, building the role and the company everyday. if I can be of any help. Office in Brussels, always open for… ",
      "mentorTwitter": "https://twitter.com/StanBoyet"
    },
    {
      "mentorName": "Alexandros Gouvatsos",
      "mentorTitle": "Almost #EngD. Software research & development in #AI. Avid gamer. Into #animation by day, into #gamedev by night. #STEM Ambassador and devourer of good food.",
      "mentorMessage": "Ask me anything about global optimisation algorithms, evolutionary algorithms and #computervision and hopefully I’m… ",
      "mentorTwitter": "https://twitter.com/alexgouv"
    },
    {
      "mentorName": "Alexandros Gouvatsos",
      "mentorTitle": "Almost #EngD. Software research & development in #AI. Avid gamer. Into #animation by day, into #gamedev by night. #STEM Ambassador and devourer of good food.",
      "mentorMessage": "Ask me anything about global optimisation algorithms, evolutionary algorithms and #computervision and hopefully I’m… ",
      "mentorTwitter": "https://twitter.com/alexgouv"
    },
    {
      "mentorName": "Derek Arndt",
      "mentorTitle": "Mobile Game Developer, Backpacking Traveler, Guitar Player",
      "mentorMessage": "I run a mobile gaming company with seven years of Unity experience, app stores, UX, and programming. Ping me Qs and… ",
      "mentorTwitter": "https://twitter.com/derekarndt"
    },
    {
      "mentorName": "Cinnamon Jaceface",
      "mentorTitle": "game dev - poops professionally at @Coffee_Stain Studios - bi - my body belongs to @uzu51_ - tea drinker - love it when @jonathan_blow calls things “bananas”",
      "mentorMessage": "I can mentor on how to get coffee from the machine downstairs whilst also avoiding responsibility of filling it up… ",
      "mentorTwitter": "https://twitter.com/jembawls"
    },
    {
      "mentorName": "Jaseem Abid",
      "mentorTitle": "One of those programmers. Co-host @papersweloveblr. Perpetually learning Haskell. Proud Atheist. Tolkien. Not a patriot. @recursecenter S1 ‘17.",
      "mentorMessage": "I’m happy to help anyone learn Haskell. Please ask :) ",
      "mentorTwitter": "https://twitter.com/jaseemabid"
    },
    {
      "mentorName": "Lasse Diercks",
      "mentorTitle": "Freelance DesignOps right now helping @diginights, worked for @xing_de & @jimdo, looking for gigs in Q3&Q4/2017, #a11y #css #ux #agile #designsystems",
      "mentorMessage": "Ask me Anything regarding the product design process / pattern libraries & enterprise Css  ",
      "mentorTwitter": "https://twitter.com/lassediercks"
    },
    {
      "mentorName": "Jess Eddy ™",
      "mentorTitle": "Mover/shaker+product maker, hacker at ♥ User Experience and I make stuff: https://t.co/xt92rGIOY1 https://t.co/stUVGSk825 https://t.co/qY98beBbNx",
      "mentorMessage": "Open to answering questions about UX, Product, Strategy, Building a Food Company and how to make bad puns.  ",
      "mentorTwitter": "https://twitter.com/jesseddy"
    },
    {
      "mentorName": "Bryan, Dr. For Life",
      "mentorTitle": "I am the interplay of my intellectual focus and emotional aperture. Queer poly atheist. Dev Evangelist at @Microsoft, but tweets are my own.",
      "mentorMessage": "I love answering questions! If anyone wants to chat Node.js, React, or general open source contributions please ask… ",
      "mentorTwitter": "https://twitter.com/nebrius"
    },
    {
      "mentorName": "Conor Stokes",
      "mentorTitle": "Owner/Founder Burning Candle Software (available for contract/freelance work); Graphics, distributed systems, machine learning, optimization and compression.",
      "mentorMessage": "Always open to questions! Graphics, compression, general computer science, code optimization, C/C++/.NET, distribut… ",
      "mentorTwitter": "https://twitter.com/xDirtyPunkx"
    },
    {
      "mentorName": "Jouella Fabe",
      "mentorTitle": "I like hard hikes and long distance running. Currently I do infra + reliability stuff @utilityapi. always learning",
      "mentorMessage": "Woah… the world is too small, someone just mentioned about this in this women in tech mentorship panel @figma… ",
      "mentorTwitter": "https://twitter.com/jmfabe"
    },
    {
      "mentorName": "CalixJumi",
      "mentorTitle": "iOS dev, no prof gamedev, ‘games that inspire creativity’ and stuff 💫",
      "mentorMessage": "Feel free to ask me any iOS app dev related question \\o\\ ",
      "mentorTwitter": "https://twitter.com/calixjumio"
    },
    {
      "mentorName": "arm-linux-gnueabihf-",
      "mentorTitle": "Blue Meow | I spend all day moving electrons around",
      "mentorMessage": "HMU if any of you fuzzy nerds have questions. Embedded Linux, bare-metal C, Python, Bash, Makefiles, Git, Vim , and… ",
      "mentorTwitter": "https://twitter.com/AlkentaWildcat"
    },
    {
      "mentorName": "Mathias Wahlin",
      "mentorTitle": "Indie game developer working on an unannounced game, part-time rendering programmer. Musician. Previously programmer in the AAA games industry, ex-demoscene.",
      "mentorMessage": "I’m happy to help, DMs are open. I’m an ex-AAA indie gamedev. Graphics programming, game engine dev, gameplay, AI,… ",
      "mentorTwitter": "https://twitter.com/fohx"
    },
    {
      "mentorName": "⎛⚆_⚆⎠Olivier Lafleur",
      "mentorTitle": "Papa de 2, enseignant au Cégep Lévis-Lauzon et développeur chez @Vooban. Open source, web ouvert et bonnes pratiques.",
      "mentorMessage": "Feel free to ask a question related to maths or computer science. I’ll be glad to help ! ",
      "mentorTwitter": "https://twitter.com/olilafleur"
    },
    {
      "mentorName": "Chris Harrold",
      "mentorTitle": "The Wolf of Analytics. #Transformation and #BigData evangelist and leader. #RoadWarrior, outdoorsman, foodie, EPL fan and PS4 gamer. #GTFOTB",
      "mentorMessage": "I am always happy to answer questions about analytics, data science, IoT, and just being in IT in general from anyo… ",
      "mentorTwitter": "https://twitter.com/CHarrold303"
    },
    {
      "mentorName": "Mario Durán",
      "mentorTitle": "Sr Developer/Consultant @ Orinoco Systems. JavaScript is a thing for me. I have a crush on what I do. Soon to become a Bot, soon soooon",
      "mentorMessage": "Hello I’m a senior front end developer (love JavaScript) Happy to help ",
      "mentorTwitter": "https://twitter.com/MrMaux"
    },
    {
      "mentorName": "Cherp 🍾🌌💻 📐🎶",
      "mentorTitle": "PNW+SoCal. Javascript Artisan Scientist. 👩‍💻 @blizzard_ent, @usatoday, @teamtespa. Wine, @redsox, space, engineering, MKBs, & music. INTJ-t BPD | all IMO 🏳️‍🌈🎗",
      "mentorMessage": "I’m a web development veteran, expert in scss(sass), javascript, html, and a senior level python and ruby developer… ",
      "mentorTwitter": "https://twitter.com/codehitchhiker"
    },
    {
      "mentorName": "Nicholas Weaver",
      "mentorTitle": "If you want to contact me, use email/phone.  Make it secure: use Signal/iMessage.",
      "mentorMessage": "I’m open for questions.  Also, if in Berkeley, feel free to drop by my office. ",
      "mentorTwitter": "https://twitter.com/ncweaver"
    },
    {
      "mentorName": "Jonatan Crafoord",
      "mentorTitle": "Freelance Audio Director and Indie Game Developer. Bane of Norms, Instantiator of Virtuals, Flake of Swedish Snow.",
      "mentorMessage": "Ask me about audio for games, C# and Unity, or recruitment / human resource management! ",
      "mentorTwitter": "https://twitter.com/JonatanCrafoord"
    },
    {
      "mentorName": "TrashGirl",
      "mentorTitle": "Self-perpetuating garbage. Ask me stuff or whatever: https://t.co/iA8W1tFEqO",
      "mentorMessage": "I’m a loser who’s never shipped a single meaningful work, AMA. ",
      "mentorTwitter": "https://twitter.com/wizwagalot"
    },
    {
      "mentorName": "vinz",
      "mentorTitle": "level 2 sysadmin",
      "mentorMessage": "Basic Ubuntu Server setup, Webservers, Firewalls, bash Python, C#, PowerShell, git, https. Not much, but love to he… ",
      "mentorTwitter": "https://twitter.com/vinzBad"
    },
    {
      "mentorName": "furiOHsa not furioSA",
      "mentorTitle": "A hard Skeleton Queen living in a soft Meat Palace. One day I will escape. Don’t cross me. (ง’̀-‘́)ง",
      "mentorMessage": "I’m a white female animator/boarder who’s navigated a lot of different jobs in 2D TV pipelines. This is my personal… ",
      "mentorTwitter": "https://twitter.com/dag_the_hag"
    },
    {
      "mentorName": "Nils Hitze",
      "mentorTitle": "Gentleman Nerd, Father*7, ❤️@souffleurlos, Evangelist for rent, Community Manager @CalliopeMini, @toms3dp & Founder #makemunich, Dev @pharma4u_de",
      "mentorMessage": "I’m open to occasional #eventplanning #networking #growthhacking #edtech questions ",
      "mentorTwitter": "https://twitter.com/kojote"
    },
    {
      "mentorName": "Nils Hitze",
      "mentorTitle": "Gentleman Nerd, Father*7, ❤️@souffleurlos, Evangelist for rent, Community Manager @CalliopeMini, @toms3dp & Founder #makemunich, Dev @pharma4u_de",
      "mentorMessage": "I’m open to occasional #eventplanning #networking #growthhacking #edtech questions ",
      "mentorTwitter": "https://twitter.com/kojote"
    },
    {
      "mentorName": "Jeremiah Page👾",
      "mentorTitle": "The next statement is false. The first statement is true. Dad + PuterN3rd + 80s born 90s kid + sqrt (awesome) + single + coder = m3.",
      "mentorMessage": "Freelance Web/Soft Dev 14+ Yrs HTML 5, CSS, PHP, Apache, mySQL, Javascript, jQuery, MVC Paradigm 3 Yrs Amateur 2D G… ",
      "mentorTwitter": "https://twitter.com/jpagedesigns"
    },
    {
      "mentorName": "Didier Sampaolo",
      "mentorTitle": "CTO @soumettrefr. #marseille #teamMauresque",
      "mentorMessage": "I’m open to #Laravel -related questions :) ",
      "mentorTwitter": "https://twitter.com/dsampaolo"
    },
    {
      "mentorName": "Manny C. 🐨",
      "mentorTitle": "i’m all that and then some; short dark and handsome / infrastructure junkie / 💑👨‍❤️‍👨 / sports: lakers, raiders, doyers/ he, him, his / futurist in residence",
      "mentorMessage": "product and engineering manager with over 15 years of experience, open to mentoring or answering questions. ",
      "mentorTwitter": "https://twitter.com/whodamanny"
    },
    {
      "mentorName": "Attacks of Thirst",
      "mentorTitle": "Polyamorous atheist, drummer, gamer. A recurring synthesis of cynicism and optimism. Anti-bullshit. Web dev. RTs ≠ endorsements. Snapchat: thecrimsonking8",
      "mentorMessage": "Here for web dev advice. Most proficient in JS and JS frameworks, but also competent in Java, C#, and basic game de… ",
      "mentorTwitter": "https://twitter.com/TheDecentTech"
    },
    {
      "mentorName": "Matthew🌸Automata",
      "mentorTitle": "Mary’s husband. Games, comics, and pop culture critic. Game dev. Editor. Contact: matthew (at) shindig (dot) nz. 日本語OK",
      "mentorMessage": "Feel free to ask me anything about writing, games, mental health, whatever, any time. I’m no expert but always happ… ",
      "mentorTwitter": "https://twitter.com/MC_Odd"
    },
    {
      "mentorName": "Matt @ DDNet",
      "mentorTitle": "Author of Game Art, a book about games as art. Aussie that cares about Aussie games. True story; the world’s #1 expert for serious analysis of Hatsune Miku.",
      "mentorMessage": "This is a good idea. If anyone ever has questions about journalism or writing, let me know. I’ll answer them. ",
      "mentorTwitter": "https://twitter.com/DigitallyDownld"
    },
    {
      "mentorName": "Guy ‘Yug’ Blomberg",
      "mentorTitle": "Global PAX Content Director at @Reed_POP. I also have crazy hair.",
      "mentorMessage": "I’ll always answer queries for help or advice, it’s the least I can do to pay back all the help and advice I’ve rec… ",
      "mentorTwitter": "https://twitter.com/YugSTAR"
    },
    {
      "mentorName": "Jason Imms",
      "mentorTitle": "Host of the Game Hugs podcast | Managing director of @TheMachineQA | Recovering Games Journo | Tas GameDev Society Founder.",
      "mentorMessage": "Always happy to answer questions on being a freelance games journo, pitching, angles, giving/receiving feedback, et… ",
      "mentorTwitter": "https://twitter.com/jasonimms"
    },
    {
      "mentorName": "Talen Lee",
      "mentorTitle": "• Hollerer at Clouds • Cis♂, White, He/Him • I make board games, card games, and game words •",
      "mentorMessage": "I don’t do software but I’m happy to help talk about how to approach making your first tabletop games! ",
      "mentorTwitter": "https://twitter.com/Talen_Lee"
    },
    {
      "mentorName": "Juan",
      "mentorTitle": "INFP-A. EN/ES. Hapkido. Front-end en Opileak. En busca del sitio donde los principios no sean la virtud del mes. Each one teach one.",
      "mentorMessage": "You can ask me about web development anytime. Also basic game development. Just @ me ",
      "mentorTwitter": "https://twitter.com/FukenElTuerto"
    },
    {
      "mentorName": "saffalore",
      "mentorTitle": "narrative designer, podcaster, photog | network director @nsfwpodcasts | co-hosts @western_reaches, @roguepodron & @Blastercanonpod | HATES ART",
      "mentorMessage": "i am always ready and willing to give advice about writing, narrative, and/or podcasting <3 ",
      "mentorTwitter": "https://twitter.com/Wanderlustin"
    },
    {
      "mentorName": "lucy @ stugan🇸🇪🐧",
      "mentorTitle": "30u30 develop/mcv 🌸 @playbyplayfest co-director 🌸 senior ui designer @pikpokgames, indie @starcolthq 🌸 also @asylumjam & @agamediary 🌸 all views are my own.",
      "mentorMessage": "Happy to answer questions about game UI/UX! (probably by far the most useful thing I could help with) ",
      "mentorTwitter": "https://twitter.com/lucyamorris"
    },
    {
      "mentorName": "Déborah Mesquita",
      "mentorTitle": "I believe that the search for the right problem is a key factor to build something great! I talk about life, Data Science, writing, programming, and memes ✨",
      "mentorMessage": "Eu vim nessa thread meio triste achando que não ia ter ninguém pra perguntar um negócio de NLProc e acabou que EU A… ",
      "mentorTwitter": "https://twitter.com/dehhmesquita"
    },
    {
      "mentorName": "DcTurner ༼ಠ益ಠ༽",
      "mentorTitle": "Multimedia Artist  __ Illustration / Animation / Code / Music",
      "mentorMessage": "DMs open to any animation, coding, music, art questions. Always happy to recommend software, learning resources etc. ",
      "mentorTwitter": "https://twitter.com/dcturner"
    },
    {
      "mentorName": "Hugh Cole-Baker",
      "mentorTitle": " ",
      "mentorMessage": "I missed the first wave of these posts while I was on holiday, but I’m always keen to answer any questions about Py… ",
      "mentorTwitter": "https://twitter.com/hughcb"
    },
    {
      "mentorName": "Gordon Brown",
      "mentorTitle": "Staff Software Engineer, SYCL at Codeplay Software Ltd. Any opinions expressed are entirely my own.",
      "mentorMessage": "Always happy to help with C++, templates, GPGPU, OpenCL, SYCL. DMs open. ",
      "mentorTwitter": "https://twitter.com/AerialMantis"
    },
    {
      "mentorName": "Adrian Bentley",
      "mentorTitle": "Lead Engine Programmer at Sucker Punch Productions",
      "mentorMessage": "Willing to answer what I can about engine, graphics, data compilation, and other game programming. ",
      "mentorTwitter": "https://twitter.com/adrianb3000"
    },
    {
      "mentorName": "Matt Nydam",
      "mentorTitle": "I do iOS team things @xero in ‘straya.",
      "mentorMessage": "I am available to help out with anything iOS or to just share things I’ve learned managing people :) ",
      "mentorTwitter": "https://twitter.com/MattNydam"
    },
    {
      "mentorName": "OldManKris",
      "mentorTitle": "Valued customer",
      "mentorMessage": "I probably really can’t help you at all. But I am willing to try. ",
      "mentorTwitter": "https://twitter.com/OldManKris"
    },
    {
      "mentorName": "Doug 👨🏻‍🌾",
      "mentorTitle": "Official Spokesperson",
      "mentorMessage": "Always good for questions about accessibility on macOS, iOS, or the web ",
      "mentorTwitter": "https://twitter.com/dougrustle"
    },
    {
      "mentorName": "Julio Protzek",
      "mentorTitle": "In love with @miprotzek, programming, art and education. Dreamer & cofounder at @labnomad and @studioflama. Before that, cofounder @StartaeTeam & @asuperquadra",
      "mentorMessage": "Always good to remind: I’m open to help people with UX, ruby and JavaScript. ",
      "mentorTwitter": "https://twitter.com/julioprotzek"
    },
    {
      "mentorName": "Adam Baxter ♿",
      "mentorTitle": "Once let the magic smoke out of a gameboy game.",
      "mentorMessage": "I’ve been doing a bit of asking but I’m happy to answer about C#, Python, Linux, scripting, Australian Public Servi… ",
      "mentorTwitter": "https://twitter.com/voltagex"
    },
    {
      "mentorName": "Christian Sparks",
      "mentorTitle": "Friendly devdad. UE4 Technical Artist. Developing Woodbound. Married to @michellesparks_ https://t.co/HyI3GxLxFJ",
      "mentorMessage": "I have #UE4 experience doing weather & time of day junk, as well as stylized graphics & shaders, hit me up. <3… ",
      "mentorTwitter": "https://twitter.com/hippowombat"
    },
    {
      "mentorName": "Ted M. Young",
      "mentorTitle": "Helping you create the best learning experience for your team. Trainer, coding coach, & writer. Specializing in Java, XP (TDD, Testing, Pairing), & Containers.",
      "mentorMessage": "Reminder: happy to answer questions, from Java, agile, and testing, to the software industry at large, to Bugs Bunn… ",
      "mentorTwitter": "https://twitter.com/jitterted"
    },
    {
      "mentorName": "Jeremy Tregunna",
      "mentorTitle": "VP of Engineering @metismachine. My bikeshed is blue. Elixir/Erlang, also iOS/macOS/tvOS. I also tweet about hockey. My opinions are my own and whatnot.",
      "mentorMessage": "I can answer questions on startups, iOS, macOS, Erlang, Elixir or even Ruby. Also if you have questions about your… ",
      "mentorTwitter": "https://twitter.com/jtregunna"
    },
    {
      "mentorName": "Randy Shoup",
      "mentorTitle": "VP Engineering at Stitch Fix (former eBay, Google)",
      "mentorMessage": "This is such a great way to give back. Followers, please volunteer yourselves … ",
      "mentorTwitter": "https://twitter.com/randyshoup"
    },
    {
      "mentorName": "PersonalTweezer",
      "mentorTitle": " ",
      "mentorMessage": "25 years development operations and infrastructure, happy to answer any questions on Azure, MEAN, CPP/CS, Unreal, U… ",
      "mentorTwitter": "https://twitter.com/PersonalTweezer"
    },
    {
      "mentorName": "PersonalTweezer",
      "mentorTitle": " ",
      "mentorMessage": "25 years development operations and infrastructure, happy to answer any questions on Azure, MEAN, CPP/CS, Unreal, U… ",
      "mentorTwitter": "https://twitter.com/PersonalTweezer"
    },
    {
      "mentorName": "Benjamin Borowski",
      "mentorTitle": "Building @doki_io, design/dev (rb/js/ember/ios/php), dj (https://t.co/dcfR7LutBB), tattoos, climbing, shibas, firefighter proby, INTJ/island/submarine.",
      "mentorMessage": "👋 Self-employed since ‘10 making apps/games/websites/saas. Happy to offer advice on jumpstarting an independent car… ",
      "mentorTwitter": "https://twitter.com/typeoneerror"
    },
    {
      "mentorName": "Kalyan 🔵 कल्याण",
      "mentorTitle": "Being what’s next!",
      "mentorMessage": "With whatever little I know in formal verification of hardware/software, I can help answer questions people have… ",
      "mentorTwitter": "https://twitter.com/mensch04"
    },
    {
      "mentorName": "Aaron",
      "mentorTitle": "Software developer. Standard nerd. Mostly retweeting space and programming. Opinions are personal.",
      "mentorMessage": "10 yrs .NET (VB/C#) industry software. Up for questions, bouncing ideas, weird bugs, etc. Looking forward to more i… ",
      "mentorTwitter": "https://twitter.com/lenoir_aaron"
    },
    {
      "mentorName": "Aidan",
      "mentorTitle": "Server #gamedev @DigitGaming. Former astrophysicist and #Python teacher. https://t.co/Zrz8Fb5BNK",
      "mentorMessage": "Happy to talk about learning a lot of astrophysics then starting a career in Nothing To Do With Astrophysics. ",
      "mentorTwitter": "https://twitter.com/itsjustaidan"
    },
    {
      "mentorName": "Lee Cash",
      "mentorTitle": "Game Dev Director @EA. Venal father. Bad runner. Arcane philologist. Japanophile. Minister of Pyramids. Renowned coffee smuggler. Space Elevator Operator.",
      "mentorMessage": "Happy to talk about how not to run a marathon in four hours. Twice. ",
      "mentorTwitter": "https://twitter.com/LeeCash"
    },
    {
      "mentorName": "Ben!",
      "mentorTitle": "Game developer with @Digitgaming, filmmaker, photographer and writer. Portfolios and work blog up at ben.ie Hi! :-)",
      "mentorMessage": "Happy to chat about game dev (Unity mostly), photography and filmmaking. ",
      "mentorTwitter": "https://twitter.com/bursaar"
    },
    {
      "mentorName": "Akash Thakkar",
      "mentorTitle": "Composer & Sound Designer for games & VR + AR. Sound Designer on Hyper Light Drifter & MIDI Mockups on Destiny. Watch my TEDx talk: https://t.co/gXzwMqjr1b",
      "mentorMessage": "Lots of music, sound, implementation, and freelancing experience in games. DMs are open! ",
      "mentorTwitter": "https://twitter.com/AkashThakkar"
    },
    {
      "mentorName": "Ross @ShipItCon🚢",
      "mentorTitle": "Dev Tools & Infrastructure Code Poet | Builds Games for @DigitGaming | Optimist | Adventurer | Philosopher | Technical Mentor | Run @Drinkaboutdub @ShipItCon",
      "mentorMessage": "Available for CI, CD, DevOps, Pipelines, Jenkins, Workflow, BuildEng and gradle chats! ✌️ ",
      "mentorTwitter": "https://twitter.com/wrossmck"
    },
    {
      "mentorName": "John Seymour",
      "mentorTitle": "Data Scientist in #InfoSec. PhD candidate. #Pythonista. #WomenInTech advocate. DMs open.",
      "mentorMessage": "I am open to questions! Message me if you need CFP help, you’re into Machine Learning, or need to find a person for… ",
      "mentorTwitter": "https://twitter.com/_delta_zero"
    },
    {
      "mentorName": "David Hart",
      "mentorTitle": "iOS programmer and game developer",
      "mentorMessage": "I’m available to help if anybody has questions regarding Swift, Objective-C, iOS and development in general. I don’… ",
      "mentorTwitter": "https://twitter.com/dhartbit"
    },
    {
      "mentorName": "Alex Hitchins",
      "mentorTitle": "Software person with hardware ambitions. Re-Tweets/Follows are not endorsements. All views subject to change. I don’t look anything like that photo any more.",
      "mentorMessage": "Anyone needing assistance with requirement capture and documentation can message me. ",
      "mentorTwitter": "https://twitter.com/alexhitchins"
    },
    {
      "mentorName": "Jake Hendy",
      "mentorTitle": "Developer at @MetOffice, Gym Instructor, Gamer. Tweets are in no way affiliated with my employer! https://t.co/8zwOSu4rWG is where I write things…",
      "mentorMessage": "AWS, microservices, monoliths, parsing‘n’publishing data in a variety of formats, some “bigger” data too, infrastru… ",
      "mentorTwitter": "https://twitter.com/JakeHendy"
    },
    {
      "mentorName": "Frederic Barthelemy",
      "mentorTitle": "Software Engineer, Tech Enthusiast, aspiring Entrepreneur, AR Dreamer",
      "mentorMessage": "I’m open to questions, iOS, with past js, c, c++, Java experience. Have tutored new coders, and experienced before! ",
      "mentorTwitter": "https://twitter.com/fbartho"
    },
    {
      "mentorName": "Gaming Dude",
      "mentorTitle": "► A phd-candidate without a clue.",
      "mentorMessage": "Eine Schar erfahrener Programmierer aller Arten bietet Hilfe/Mentoring an. Also, falls jemand von Euch coder ist: T… ",
      "mentorTwitter": "https://twitter.com/Gaming_Dude"
    },
    {
      "mentorName": "Joakim Bodin",
      "mentorTitle": "Builder of online services for Battlefield, Mirror’s Edge and Star Wars Battlefront at @EA_DICE Operations. Matchmaker of games.",
      "mentorMessage": "Ask me about functional programming, micro/macro services, matchmaking and integrating games into a large online se… ",
      "mentorTwitter": "https://twitter.com/jbripley"
    },
    {
      "mentorName": " Milan Stevanović",
      "mentorTitle": "iOS Developer at @Datlinq",
      "mentorMessage": "I’m open for iOS Development related questions/tutoring people who want to learn iOS Development, for free, ofc ",
      "mentorTwitter": "https://twitter.com/FathVader"
    },
    {
      "mentorName": "Joe Zulli",
      "mentorTitle": "Startup Founder / Scala  Coder / CrossFitter / Cat Enthusiast / ‘That Guy’ at your Company’s Christmas Party",
      "mentorMessage": "Happy to give advice on how to start companies, product design, and why technical debt is a good thing. ",
      "mentorTwitter": "https://twitter.com/JoeZulli"
    },
    {
      "mentorName": "Stas Kolenikov",
      "mentorTitle": "Survey statistician - views are solely mine and not my employer’s (@AbtAssociates @AbtDataScience). Looking forward to opportunities to collect data for you",
      "mentorMessage": "An amazing thread - whatever programming help you need, you’d probably find an expert among the replies. ",
      "mentorTwitter": "https://twitter.com/StatStas"
    },
    {
      "mentorName": "Brian Walsh",
      "mentorTitle": "Glamour shot.",
      "mentorMessage": "Available for iOS and macOS API questions. Can take 3D and shader q’s too but may be a bit rusty. ",
      "mentorTwitter": "https://twitter.com/mummey"
    },
    {
      "mentorName": "Stephanie Rewis",
      "mentorTitle": "Principal Developer, Design Systems, @ https://t.co/bfNVQ1VJsN. Co-catamaran captain with @garazi. Procrastinating workaholic—I put the URL in gurl. Tweets my own.",
      "mentorMessage": "Thank you Stephanie… I am ALWAYS open to questions, y’all. Oddly, tho I learned by asking, sometimes Twitter does… ",
      "mentorTwitter": "https://twitter.com/stefsull"
    },
    {
      "mentorName": "Marc McGinley",
      "mentorTitle": "Senior Game Designer at Ubisoft Montréal. Gamer / Tech Enthusiast / VR evangelist. My opinions are my own.",
      "mentorMessage": "Happy to answer anything Game Design related, career paths etc. ",
      "mentorTwitter": "https://twitter.com/marcmcg"
    },
    {
      "mentorName": "Marc McGinley",
      "mentorTitle": "Senior Game Designer at Ubisoft Montréal. Gamer / Tech Enthusiast / VR evangelist. My opinions are my own.",
      "mentorMessage": "Happy to answer anything Game Design related, career paths etc. ",
      "mentorTwitter": "https://twitter.com/marcmcg"
    },
    {
      "mentorName": "Brandon Pomeroy",
      "mentorTitle": "He/him. 3D printing engineer and VR/gamedev enthusiast. Often has trouble falling asleep.",
      "mentorMessage": "open to most questions about 3d printing! ",
      "mentorTwitter": "https://twitter.com/AchillePomeroy"
    },
    {
      "mentorName": "Jason Lengstorf",
      "mentorTitle": "Developer / Friendly Bear 🐻",
      "mentorMessage": "I can share my experience with remote work, front-end and middle-tier dev, freelance, and becoming a speaker. ",
      "mentorTwitter": "https://twitter.com/jlengstorf"
    },
    {
      "mentorName": "Justyn Howard",
      "mentorTitle": "CEO Sprout Social (@SproutSocial). New dad. Enjoy brainstorming ideas with smart people, solving hard problems. Glassdoor’s top-rated CEO 2017. DM’s open.",
      "mentorMessage": "Always happy to discuss software, SaaS, fundraising, team building, tech in general. Also insomnia, meat. ",
      "mentorTwitter": "https://twitter.com/Justyn"
    },
    {
      "mentorName": "Matt Apperson 📱👱🏻",
      "mentorTitle": "NodeJS, React, & Go fan. Available for hire. Created @gitfundme, founded @appersonlabs, ex @appcelerator & @avistarcomm. Doing my best as a Husband and Father",
      "mentorMessage": "Always happy to help answer questions about NodeJs, React, or digital product development 😊 DMs are open ",
      "mentorTwitter": "https://twitter.com/mattapperson"
    },
    {
      "mentorName": "Michael Bates",
      "mentorTitle": " ",
      "mentorMessage": "Love this. I’m totally open to any questions about Swift, Ruby, and Swing dancing 🕺 ",
      "mentorTwitter": "https://twitter.com/mklbtz"
    },
    {
      "mentorName": "Nolan O’Brien",
      "mentorTitle": "🇨🇦 | code wrangler | in Vegas | work @Twitter | husband | 3x daughters | ♥️ 80s movies & whisky",
      "mentorMessage": "Client Networking, 802.11, C, Objective-C, & media pipelines.  Happy to discuss anytime :) ",
      "mentorTwitter": "https://twitter.com/NolanOBrien"
    },
    {
      "mentorName": "Matt Klein",
      "mentorTitle": "Engineer @lyft. Creator of @envoyproxy.",
      "mentorMessage": "Love answering questions about c++, networking, performance, and why services in python are bad. 😉 ",
      "mentorTwitter": "https://twitter.com/mattklein123"
    },
    {
      "mentorName": "Greg Wilson",
      "mentorTitle": "I should be writing.",
      "mentorMessage": "Happy to chat about how to teach programming and how to build lessons collaboratively - DM me or mail gvwilson@thir… ",
      "mentorTwitter": "https://twitter.com/gvwilson"
    },
    {
      "mentorName": "Mark Funk",
      "mentorTitle": "Has never, not even once, made a mitsake. Builds, mentors, and does the cyber. enby they/them",
      "mentorMessage": "Been building web applications and services for the last decade, and infosec for the last few years. Open to questi… ",
      "mentorTwitter": "https://twitter.com/mgfunk"
    },
    {
      "mentorName": "Alexey Demedeckiy 🔭",
      "mentorTitle": "Swift enthusiast, unidirectional person, semantic oriented programmer. Mobile architecture consultant.",
      "mentorMessage": "redux / elm architectures on iOS, writing tests for mobile applications ",
      "mentorTwitter": "https://twitter.com/DAlooG"
    },
    {
      "mentorName": "Félix Fischer",
      "mentorTitle": "You know what’s better than color blending? Color BENDING 🌬🌈",
      "mentorMessage": "I guess I’m fairly decent at Complexity Analysis (O(n) stuff). If you’re struggling w/that, maybe I can lend a hand. ",
      "mentorTwitter": "https://twitter.com/FelixFischer91"
    },
    {
      "mentorName": "Graydon Hoare",
      "mentorTitle": " ",
      "mentorMessage": "Happy to answer questions about compilers, profilers, low level language tools, revision control, anything else I’v… ",
      "mentorTwitter": "https://twitter.com/graydon_pub"
    },
    {
      "mentorName": "Stefanus Du Toit",
      "mentorTitle": "XR at Google. Vintage computing at home. Life long coder – GPUs, compilers, firmware, langs, UX. Lived in .za, .de, .bn, .ca and now .sg. He/him|er/ihn|hy/hom.",
      "mentorMessage": "Ask me about: C++, VC backed startups, systems programming, Google, standards committees, VR/AR ",
      "mentorTwitter": "https://twitter.com/stefanusdutoit"
    },
    {
      "mentorName": "Ryan Wilson",
      "mentorTitle": "Software Engineer, Aspiring Verified Account",
      "mentorMessage": "Happy to help with iOS dev, Swift,  Obj-C, and Firebase where I can! ",
      "mentorTwitter": "https://twitter.com/ryanwils"
    },
    {
      "mentorName": "Doug Gregor",
      "mentorTitle": "Dad, husband, Swift language designer and Swift/C++/ObjC compiler implementor, Generic Programming aficionado.",
      "mentorMessage": "Swift, C++ templates, type checkers ",
      "mentorTwitter": "https://twitter.com/dgregor79"
    },
    {
      "mentorName": "edude03",
      "mentorTitle": "Full Stack Software Engineer and such",
      "mentorMessage": "I’m always open to help with whatever, especially #devops and #ruby DMs are open ",
      "mentorTwitter": "https://twitter.com/edude03"
    },
    {
      "mentorName": "Pat LaVarre",
      "mentorTitle": "Retweets, creative misquotes, and visions … Caught as we think by tweeting …",
      "mentorMessage": "The command-line stack:  Bash & Python & C ",
      "mentorTwitter": "https://twitter.com/pelavarre"
    },
    {
      "mentorName": "Wilbert Liu",
      "mentorTitle": "Detail minded product engineer and designer. Currently on Elixir and iOS. https://t.co/xNoq5QtGg0",
      "mentorMessage": "@JonathanZWhite Awesome! Btw, just in case you missed it ",
      "mentorTwitter": "https://twitter.com/wilbertliu"
    },
    {
      "mentorName": "Leon Bambrick",
      "mentorTitle": "Perpetual beginner. Unreliable narrator. Writing a book https://t.co/og2pOOU3Rh. Creator of https://t.co/i2lVnC04HE https://t.co/BeOMCecuE4",
      "mentorMessage": "I’m willing to give genuine (non-sarcastic) technical help to anyone at any time. My DMs are open. ",
      "mentorTwitter": "https://twitter.com/secretGeek"
    },
    {
      "mentorName": "Björn Fahller 🏞️",
      "mentorTitle": "I write code I do not drink coffe",
      "mentorMessage": "C++ in general and templates in particular (>= c++14.) Mostly embedded, but most tech’s are generic. More practitio… ",
      "mentorTwitter": "https://twitter.com/bjorn_fahller"
    },
    {
      "mentorName": "Dominik Picheta",
      "mentorTitle": "Core developer of @nim_lang, author of Nim in Action, Computer Science autodidact. Partner to the exceptionally creative @DiveAmyDive",
      "mentorMessage": "Happy to answer questions about Nim, book writing, Nimble, package managers and any other topic that pops into your… ",
      "mentorTwitter": "https://twitter.com/d0m96"
    },
    {
      "mentorName": "bobtfish",
      "mentorTitle": "I could be called a thought leader, as long as you’re expecting all of my thoughts to lead to the bar.",
      "mentorMessage": "Anyome: Feel free to hit me up abt DevOps/backend stuff, programming barely acceptably in any language & failing to… ",
      "mentorTwitter": "https://twitter.com/bobtfish"
    },
    {
      "mentorName": "edge lorde",
      "mentorTitle": "disappears after five seconds",
      "mentorMessage": "willing to answer questions about haskell, longform improv, or john cheever ",
      "mentorTwitter": "https://twitter.com/haoformayor"
    },
    {
      "mentorName": "Dave Mayo‽",
      "mentorTitle": "🚫YOU CANNOT SPEEDRUN SKY SHARKI🚫  I am a web developer who is also a human being. This is occasionally inconvenient.   Name: Dave Mayo‽ Pronouns: he/him",
      "mentorMessage": "I am 1000% always up for this (albeit sometimes on a delay bc life happens).  Helping/working to understand things… ",
      "mentorTwitter": "https://twitter.com/pobocks"
    },
    {
      "mentorName": "Prabhakar Ragde",
      "mentorTitle": "Food, wine, music, books, film, art, architecture, travel, feminism, and functional programming.",
      "mentorMessage": "Socialized as male so willing to answer questions about anything. Competent on some of the things listed in my bio. ",
      "mentorTwitter": "https://twitter.com/plragde"
    },
    {
      "mentorName": "brian 🅱 mock",
      "mentorTitle": "🤓 he/him 💻 computers 🎮 games 🐈 cats ✨ cute stuff 👷 always building",
      "mentorMessage": "Hit me up about JavaScript, CSS, parsing, or compilers, friends! I’m always happy to talk and teach. ",
      "mentorTwitter": "https://twitter.com/wavebeem"
    },
    {
      "mentorName": "Juan Sequeda",
      "mentorTitle": "Founder @Capsenta; Semantic Web, Database, Graph Researcher; BS & PhD @UTCompSci; NSF Graduate Research Fellow (2010-13); Salsa dancer; Frequent Flyer #avgeek",
      "mentorMessage": "Open to chat about CS research, grad school, startups, traveling, salsa music, beer ",
      "mentorTwitter": "https://twitter.com/juansequeda"
    },
    {
      "mentorName": "Juan Sequeda",
      "mentorTitle": "Founder @Capsenta; Semantic Web, Database, Graph Researcher; BS & PhD @UTCompSci; NSF Graduate Research Fellow (2010-13); Salsa dancer; Frequent Flyer #avgeek",
      "mentorMessage": "Open to chat about CS research, grad school, startups, traveling, salsa music, beer ",
      "mentorTwitter": "https://twitter.com/juansequeda"
    },
    {
      "mentorName": "Joe Groff",
      "mentorTitle": "🐶 ✖️ 🐻 ＝ ❓",
      "mentorMessage": "Willing to answer questions about Swift, compilers, C/C++, Factor, Pomeranian rescues ",
      "mentorTwitter": "https://twitter.com/jckarter"
    },
    {
      "mentorName": "Stephen Vanterpool",
      "mentorTitle": "Working @Google on Allo for iOS. Opinions are my own.",
      "mentorMessage": "I’ve been doing the iOS thing for a while now. Happy to answer questions. ",
      "mentorTwitter": "https://twitter.com/sjvanterpool"
    },
    {
      "mentorName": "desp ʅʕ•ᴥ•ʔʃ",
      "mentorTitle": "(NYC) Web Platform @Etsy @recursecenter alumn",
      "mentorMessage": "👋 I am always happy to chat about frontend systems & infrastructure, engineering practice, allyship or general care… ",
      "mentorTwitter": "https://twitter.com/danielespeset"
    },
    {
      "mentorName": "tweet debtor jail",
      "mentorTitle": "responsible for many sins of software and game dev but Alvis forgives all ::: off for the month of August - deal with it",
      "mentorMessage": "10+ years of rel eng, game dev (mmo/console), ops, way too much about OS’s (win/macos incl), and of course Chef  ca… ",
      "mentorTwitter": "https://twitter.com/cheeseplus"
    },
    {
      "mentorName": "Sam Devlin",
      "mentorTitle": "Research Fellow / Lecturer in Artificial Intelligence (AI), data mining and machine learning for digital games and interactive media",
      "mentorMessage": "I’m always happy to discuss how machine learning may be used in games with developers, designers, students & resear… ",
      "mentorTwitter": "https://twitter.com/Games4AI"
    },
    {
      "mentorName": "Peter Hilton",
      "mentorTitle": "Software developer, speaker, writer, musician • Pre-launch startup founder • Consults at https://t.co/ek3ona5ATZ • ‘Play for Scala’ book author - https://t.co/n0VXXgzWVF",
      "mentorMessage": "I’m open to programming questions about naming things. I can usually help. ",
      "mentorTwitter": "https://twitter.com/PeterHilton"
    },
    {
      "mentorName": "Kim Crayton",
      "mentorTitle": "Community Engineer & Advocate 4 #Diversity, #Inclusion, & Safe Spaces in #Tech | @CommEngReport | @JrDevMentoring | @TheSpectrumCode | https://t.co/4N5CbPDK5c",
      "mentorMessage": "I’ve worked w 3 ppl already, so I’m ready to do this. Decided 2 answer ur specific “how to get into #tech” question… ",
      "mentorTwitter": "https://twitter.com/KimCrayton1"
    },
    {
      "mentorName": "Just F 💪🏼",
      "mentorTitle": "Dad^3, open-source on @ParseIt. Tech Lead @AmpMe. My tweets are my own. Peace, Love and Bacon Strips",
      "mentorMessage": "I’m lead iOS/backend @AmpMe and maintainer of @ParsePlatform AMA abt Swift, Obj-C, node, #parse and open source mai… ",
      "mentorTwitter": "https://twitter.com/flovilmart"
    },
    {
      "mentorName": "☕ツ",
      "mentorTitle": "Self-aware mathematician hipster techie. He/they.",
      "mentorMessage": "I’ve had a few years of pro mobile dev on both Android and iOS, including low level Android and Objective-C runtime… ",
      "mentorTwitter": "https://twitter.com/CheshireSwift"
    },
    {
      "mentorName": "Demy (Elena) ✈ 🇮🇱",
      "mentorTitle": "Programmer, game developer, pen and paper rpg player. Active game jammer. Masa Oct 2017 participant 🇮🇱",
      "mentorMessage": "I think I can give some advises on Game Jams and Hackathons if you wish. ",
      "mentorTwitter": "https://twitter.com/DemyHallar"
    },
    {
      "mentorName": "Bryce Lelbach",
      "mentorTitle": "Militant C++ zealot. @CppNow and @CppCon program chair. ISO/IEC JTC1/SC22/WG21 language​ lawyer. Compiler whisperer. Parallel runtime architect. HPX developer.",
      "mentorMessage": "I’m happy to answer questions. Things I know: parallelism and C++ ",
      "mentorTwitter": "https://twitter.com/blelbach"
    },
    {
      "mentorName": "Oliver Davies",
      "mentorTitle": "Husband. Dad. Web Developer. System Administrator. Senior Developer at @MicroserveLtd. @drupalbristol, @phpsw and @DrupalCampBris co-organiser.",
      "mentorMessage": "I’m always happy to help people work with and contribute to #Drupal. ",
      "mentorTwitter": "https://twitter.com/opdavies"
    },
    {
      "mentorName": "Maisie Yang",
      "mentorTitle": "Concept Artist @ Riot Games. Foundations/Worldbuilding team. Mostly a lot of random rambling here. Magic eye lasers",
      "mentorMessage": "I don’t really know anything, but if anyone wants to ask Q’s about worldbuilding, I’m happy to give you my brains ",
      "mentorTwitter": "https://twitter.com/_whren"
    },
    {
      "mentorName": "Will ᕙ🇺🇸ᕗ",
      "mentorTitle": "ruthlessly pedantic engineer at @heyflywheel. | @is_this_that? @isthisnormalyet? | .αwǝƨomǝ(); | he/him/they",
      "mentorMessage": "I’ve done java, .net, php (laravel & WordPress) and ruby with a real big frontend focus. I’m trying to learn the va… ",
      "mentorTwitter": "https://twitter.com/splitinfinities"
    },
    {
      "mentorName": "Tom Carden",
      "mentorTitle": "Engineering Lead for @Square Point of Sale. Former designer/developer @stamen, cofounder @databloom, and early https://t.co/hSi0skH84V and https://t.co/PmUcLPFhvI person.",
      "mentorMessage": "Happy to answer questions about anything I know (technical leadership, management, visualization, Square, interview… ",
      "mentorTwitter": "https://twitter.com/RandomEtc"
    },
    {
      "mentorName": "🌱K Berkley",
      "mentorTitle": "Concept art demon. Houndmaster of the Betweenspace. Lead Concept Artist on Civ VI. All opinions are my own.",
      "mentorMessage": "I’m happy to answer questions about how to approach concept art ",
      "mentorTwitter": "https://twitter.com/KatNicoleB"
    },
    {
      "mentorName": "Chris Saunders",
      "mentorTitle": "Cloud Specialist at Red Hat. Tweets are my own.",
      "mentorMessage": "This is a great idea. If you have any questions about virtualization technologies, containers, cloudforms/manageiq… ",
      "mentorTwitter": "https://twitter.com/CanadianChris"
    },
    {
      "mentorName": "Scott Francis ن",
      "mentorTitle": "SRE/Principal Engineer @SpokenComm • previously @SDL @OpenX @Intuit et al. • AWS • solvitur ambulando • Internet ops & security since the 20th century",
      "mentorMessage": "Questions about ops, security, infrastructure, cloud, UNIX, and how to build and keep stuff running in the real wor… ",
      "mentorTwitter": "https://twitter.com/darkuncle"
    },
    {
      "mentorName": "Russell Borogove",
      "mentorTitle": "Programmer, Geek. Detoxifying post-male. Pronouns: he/him. Raised by a custom nitrogen cooled computer obelisk in the deep Silicon Valley.",
      "mentorMessage": "I’m open to questions about Game dev, Python, Unity/C#, and rocket science. ",
      "mentorTwitter": "https://twitter.com/mister_borogove"
    },
    {
      "mentorName": "Immanuel Soemaryono",
      "mentorTitle": "Underutilized Millenial. Warganet.",
      "mentorMessage": "Thread kayak gini versi Indonesia ada ngga ya? 😶 ",
      "mentorTwitter": "https://twitter.com/Nuelsitanggang"
    },
    {
      "mentorName": "Alex Fallenstedt",
      "mentorTitle": "I use a scoop of JavaScript and Elixir in my coffee every morning. I photograph weddings and nature too. Author of @LTC_pricebot and @elixirColorBot",
      "mentorMessage": "JavaScript and Elixir nerd always willing to help when I can. AMA! ",
      "mentorTwitter": "https://twitter.com/Fallenstedt"
    },
    {
      "mentorName": "Jake Hamby",
      "mentorTitle": "Mobile developer (ex-Google) specializing in Android devices & apps. Currently in LA. Interests: old computers, Linux, BSD, music, science, politics, sociology.",
      "mentorMessage": "I’m open to questions about #Android development, mobile apps, Java, wireless telephony, old computers, & anything… ",
      "mentorTwitter": "https://twitter.com/jhamby"
    },
    {
      "mentorName": "Steve Canon",
      "mentorTitle": "Friendly neighborhood math library author at Apple.",
      "mentorMessage": "Open to questions about numerical computation, from microarchitecture, assembly, details of floating-point and inte… ",
      "mentorTwitter": "https://twitter.com/stephentyrone"
    },
    {
      "mentorName": "(((Rachel Blum)))",
      "mentorTitle": "I do things. Many things. Also, I speak for nobody but myself.   she/her. SJW",
      "mentorMessage": "Spent 30+ years doing this thing, most in C/C++. Embedded, Games, Browsers, Networking.  AMA ",
      "mentorTwitter": "https://twitter.com/groby"
    },
    {
      "mentorName": "Matt Lee",
      "mentorTitle": "Free culture. Grumpy. British. He/Him. director @orangumovie. alt comedy oddball/TVs next worst nightmare. Hate Garfield. opinions belong to me and my monkey ❤️",
      "mentorMessage": "I’m able to help anyone who wants to talk GNU, Linux (espec. Debian&Ubuntu), licensing, history, multimedia DMs ope… ",
      "mentorTwitter": "https://twitter.com/mattl"
    },
    {
      "mentorName": "Kim Crayton",
      "mentorTitle": "Community Engineer & Advocate 4 #Diversity, #Inclusion, & Safe Spaces in #Tech | @CommEngReport | @JrDevMentoring | @TheSpectrumCode | https://t.co/4N5CbPDK5c",
      "mentorMessage": "Join @JrDevMentoring on Slack if you want to become a mentor. We could always use your expertise and support. ",
      "mentorTwitter": "https://twitter.com/KimCrayton1"
    },
    {
      "mentorName": "Jason Lowenthal🦁",
      "mentorTitle": "There are two kinds of people in this world. Those who can extrapolate.  Founder: https://t.co/QGhRZOKTt7",
      "mentorMessage": "I’m happy to help any way I can whenever I can. My DM’s are open and I love to chat anything web programming. ",
      "mentorTwitter": "https://twitter.com/lowenthal_jason"
    },
    {
      "mentorName": "Vijay Chidambaram",
      "mentorTitle": "Assistant Professor at UT Austin CS Dept @UTCompSci. Lead UT Systems and Storage Lab @UTSASLAB. Interested in all things systems and storage. Views my own.",
      "mentorMessage": "Open to questions about grad school, research, operating systems and storage. Just opened my DMs to everyone! ",
      "mentorTwitter": "https://twitter.com/vj_chidambaram"
    },
    {
      "mentorName": "Kim Crayton",
      "mentorTitle": "Community Engineer & Advocate 4 #Diversity, #Inclusion, & Safe Spaces in #Tech | @CommEngReport | @JrDevMentoring | @TheSpectrumCode | https://t.co/4N5CbPDK5c",
      "mentorMessage": "Hit me up if you wanna talk about how to successfully transition into a #tech #career 💻 ",
      "mentorTwitter": "https://twitter.com/KimCrayton1"
    },
    {
      "mentorName": "✨kf✨",
      "mentorTitle": "databae at @splice. ~ https://t.co/Ja0FTvK2pY",
      "mentorMessage": "wanna chat about functional programming, dist systems, data eng, remote work, or post-bootcamp interviews? hmu! ",
      "mentorTwitter": "https://twitter.com/kf"
    },
    {
      "mentorName": "✨kf✨",
      "mentorTitle": "databae at @splice. ~ https://t.co/Ja0FTvK2pY",
      "mentorMessage": "wanna chat about functional programming, dist systems, data eng, remote work, or post-bootcamp interviews? hmu! ",
      "mentorTwitter": "https://twitter.com/kf"
    },
    {
      "mentorName": "Jason Stumpf",
      "mentorTitle": "software engineer, game developer and founder - @staunch_games, math enthusiast, hobby gardener, fermented food fan, vegan, athiest. (pronoun: he)",
      "mentorMessage": "I’m not famous, but I’ve used C++ for 20 years, and know some Haskell, linear algebra, and type theory. Ask me thin… ",
      "mentorTwitter": "https://twitter.com/jasonrstumpf"
    },
    {
      "mentorName": "The Cyber Fennel",
      "mentorTitle": "#Privacy obsessed #CyberSecurity consultant @FSecure. Give me a #RawlsianWorld, not #LivingInAPyramidScheme.",
      "mentorMessage": "This, a million times this. @sehurlburt is how all Twitter should be - kindness of strangers reaching out to help.… ",
      "mentorTwitter": "https://twitter.com/FennelAurora"
    },
    {
      "mentorName": "Antoine Leblanc",
      "mentorTitle": "Friendly neighbourhood queer nerd. My cutie mark is a lambda. He / his / him.",
      "mentorMessage": "I can help with C++, Haskell, Python, Linux dev… But most of my followers can do so and better than me. ^^” ",
      "mentorTwitter": "https://twitter.com/nicuveo"
    },
    {
      "mentorName": "lucas卞dicioccio",
      "mentorTitle": "Opinions expressed here are my own. Life is simpler when (A = B) ≈ (A ≈ B).",
      "mentorMessage": "Can give some help about #haskell, #modelling, #distsys, and #postmortems ",
      "mentorTwitter": "https://twitter.com/lucasdicioccio"
    },
    {
      "mentorName": "Steve Klassen 🦄",
      "mentorTitle": "Teaching SolarWinds new tricks since 2007; he/him; husband to @mrsxinu; gopher; polyglot programmer; nice guy. My opinions ≠ employer’s.",
      "mentorMessage": "I’m always happy to help with Go, PowerShell, SolarWinds, Linux, shell scripting, resumes, career advice, and anyth… ",
      "mentorTwitter": "https://twitter.com/mrxinu"
    },
    {
      "mentorName": "Andy Balaam",
      "mentorTitle": " ",
      "mentorMessage": "I love questions about programming, including functional, testing, Lisp, Python, Java, C++!  I have wrong opinions… ",
      "mentorTwitter": "https://twitter.com/andybalaam"
    },
    {
      "mentorName": "Renzo",
      "mentorTitle": " ",
      "mentorMessage": "I’m always happy to help with programming related stuff (Haskell, types, Nix, etc.). ",
      "mentorTwitter": "https://twitter.com/k0001"
    },
    {
      "mentorName": "Elias Daler",
      "mentorTitle": "Programmer and indie game developer. Currently working on Re:creation, top-down action adventure game. (C++, Lua, SFML)",
      "mentorMessage": "Btw, one way to spread your knowledge is to write good articles about things you know. People need them. :) ",
      "mentorTwitter": "https://twitter.com/EliasDaler"
    },
    {
      "mentorName": "Liberty White",
      "mentorTitle": "#DigitalMarketing #Educator #WomenInTech Crushing on: #100SmallBiz #DigitalMedia #Startups. IG: iamliberty go100SmallBiz https://t.co/Fc8OqXzFiB",
      "mentorMessage": "These mentorship tweets by @sehurlburt are everything! Tech or non tech– great job hunting and networking tips.👇🏾 ",
      "mentorTwitter": "https://twitter.com/i_am_liberty"
    },
    {
      "mentorName": "Ben Brunzel",
      "mentorTitle": "Software-Specialist. Full-Stack Developer. DevOps-Engineer. Team coach. Cloud Architecture enthusiast. I also like Functional Programming.",
      "mentorMessage": "If you are looking to get into software development I’m happy to help! Just hit me up. Seriously. ",
      "mentorTwitter": "https://twitter.com/asciijungle"
    },
    {
      "mentorName": "IronicNet",
      "mentorTitle": "Geek - Developer - Game Developer Wannabe - Maker Wannabe :P",
      "mentorMessage": "Not an exceptional developer. But I like to help. .Net developer, gamedev wannabe. I can answer in English or Spani… ",
      "mentorTwitter": "https://twitter.com/ironicnet"
    },
    {
      "mentorName": "Trans. Daneel Olivaw",
      "mentorTitle": "Unfortunately, a writer. Inclusion and social issues in tech, community organizing, intersectional shitposts. Admin @WeAllJS. She/her. #blacklivesmatter",
      "mentorMessage": "Happy to talk about design thinking, UX, community building, diversity and inclusion, gender, intersectionality, an… ",
      "mentorTwitter": "https://twitter.com/adampowers"
    },
    {
      "mentorName": "Lindsay Goldner",
      "mentorTitle": "Branding + design for the unconventional small biz. Feminist as fuck, opinionated as hell. Love musicals, books, tattoos, and furry animals.",
      "mentorMessage": "Pretty drained tonight but my door is open for chats on design, biz, freelance, branding, impostor complex (FEELS!)… ",
      "mentorTwitter": "https://twitter.com/linzlovesyou"
    },
    {
      "mentorName": "Lukas",
      "mentorTitle": "aka eXpl0it3r - CS student, hobby C++ (game) developer, part of the #SFML Team and casual gamer",
      "mentorMessage": "I help develop SFML, create small games in my spare time and also do some web dev. DMs are open if you have questio… ",
      "mentorTwitter": "https://twitter.com/DarkCisum"
    },
    {
      "mentorName": "Gretchen Atwood",
      "mentorTitle": "writer, ux director, queer/butch/gq, author of Lost Champions: Four Men, Two Teams, and the Breaking of Pro football’s Color Line #BlackLivesMatter",
      "mentorMessage": "Am open to talking UX Design to folks interested, esp those who are WOC, queer, etc. ",
      "mentorTwitter": "https://twitter.com/gretchenatwood"
    },
    {
      "mentorName": "Lindsay Brothers",
      "mentorTitle": "@Indeed PM. Passionate about diversity & inclusion, LGBT, dogs.",
      "mentorMessage": "Happy to talk about product management, marketing, getting a job in tech, tech in general. ",
      "mentorTwitter": "https://twitter.com/LindsayBro"
    },
    {
      "mentorName": "suzi",
      "mentorTitle": "Turkish-American 1st gen academic, psych/stat. Promotes open, reproducible science. Stands for and with women in science. Also into cats, nature, photography.",
      "mentorMessage": "Wow best ever thread I have seen on Twitter. Keep scrolling down. All fields should do this! What a way to use soci… ",
      "mentorTwitter": "https://twitter.com/zerdeve"
    },
    {
      "mentorName": "David Bopp",
      "mentorTitle": "Webentwickler | macht KMU online erfolgreich | Interessiert an Politik und Argumenten | Swiss web developer",
      "mentorMessage": "#askmeanything about compelling online presences, web development, christian fundamentalism, long term travelling o… ",
      "mentorTwitter": "https://twitter.com/dboppch"
    },
    {
      "mentorName": "Trent Polack",
      "mentorTitle": "Founder & CEO of @joymachinegames - currently directing, designing, and developing Steel Hunters. Been in games for 10+ years. “Eccentric”.",
      "mentorMessage": "Gameplay/engine/graphics programmer, systems designer, level designer, tech artist, creative director for ~11 years… ",
      "mentorTwitter": "https://twitter.com/mittense"
    },
    {
      "mentorName": "Alanna Linayre",
      "mentorTitle": "(uh-LAH-nuh) (a leanbh) (ありな) | devours video games | #gamedev | #BATIM | 50% of @OurBedroomFloor",
      "mentorMessage": "It has little to do with tech but I have years of experience with acting/voice acting/sound recording, esp on a sho… ",
      "mentorTwitter": "https://twitter.com/Tybawai"
    },
    {
      "mentorName": "Mateusz Zając",
      "mentorTitle": "Liftin’ steel, brewin’ beer, writin’ code for real! #brogrammer",
      "mentorMessage": "I can tell you a thing or two about architecture, functional programming, CI/CD… #AMA ",
      "mentorTwitter": "https://twitter.com/cojoj"
    },
    {
      "mentorName": "Stig Brautaset",
      "mentorTitle": "Husband. Dad. Feminist. Blod donor. Organ donor. Author of SBJson. Basic Income proponent. Immigrant.  KTS ➤ Fotango ➤ MS ➤ Net-a-Porter ➤ LaterPay",
      "mentorMessage": "Oh Hai! I am open to questions :-) ",
      "mentorTwitter": "https://twitter.com/stigbra"
    },
    {
      "mentorName": "Heath Borders",
      "mentorTitle": "#Katie’s Husband; #Ben and #Sam’s Dad; iOS at @Twitch; @strangeloop_stl, @cocoaconf, @midwestio speaker. My tweets don’t represent my employer",
      "mentorMessage": "I’m happy to answer questions about iOS, Java, bash, networking, childrearing, and youth-baseball-coaching. ",
      "mentorTwitter": "https://twitter.com/heathborders"
    },
    {
      "mentorName": "Z",
      "mentorTitle": "“Like a cat but better,” unusually high priestess of the Bird Cult, Code Binch, Matcha Ho Pubkey: https://t.co/aXKN1Sm2S1",
      "mentorMessage": "I have some expertise in web dev, trans issues, and mental health issues; DMs are always open. ",
      "mentorTwitter": "https://twitter.com/Z_Healy"
    },
    {
      "mentorName": "E.S. Ringwald",
      "mentorTitle": "Marketing Director & Content Strategist Elizabeth Schmidt Ringwald gets startups found and connected. @StartItSeattle Producer & Seattle Startup Week Director",
      "mentorMessage": "Wow. This awesome thread is full of all sorts of experts who are willing to mentor and/or answer questions. Thanks… ",
      "mentorTwitter": "https://twitter.com/esringwald"
    },
    {
      "mentorName": "Rachel🦄Nabors",
      "mentorTitle": "Curator: https://t.co/dIkW4wYr4v Founder: https://t.co/HMBCUNHsFs GDE. W3C. Design advocate @MSEdgeDev Tweets my own. Animating the Web forward.",
      "mentorMessage": "All right. I’ll answer your questions for the next half hour or however long this tea lasts. Bring ‘em! ",
      "mentorTwitter": "https://twitter.com/rachelnabors"
    },
    {
      "mentorName": "Johnathan Pagnutti",
      "mentorTitle": "I’m an aspiring generative methods scholar at #UCSC, and plan to bake my way to a Ph.D.  Scholar on @ScholarsPlay (he/him)",
      "mentorMessage": "I have a pretty funny story about mentorship, actually.  Let’s be a dick and do a ‘twitter essay’!  So, I got an em… ",
      "mentorTwitter": "https://twitter.com/jag_pag"
    },
    {
      "mentorName": "Russ Bishop",
      "mentorTitle": "What happens in the Simulator stays in the Simulator.",
      "mentorMessage": "I can answer Simulator questions (about released and beta. cannot discuss future plans) ",
      "mentorTwitter": "https://twitter.com/xenadu02"
    },
    {
      "mentorName": "Jesse Pate",
      "mentorTitle": "Chief Architect/Technical Founder at @NuORDER_. I build complex systems, root for the @Dodgers, & go to @TheCoffeeBean too often. Warning: I get political here.",
      "mentorMessage": "I’m always open to answering questions from new or aspiring developers. Tech ?’s, and can review resumes/provide ad… ",
      "mentorTwitter": "https://twitter.com/jessedpate"
    },
    {
      "mentorName": "Arne Mertz 🌍",
      "mentorTitle": "Software craftsman, geek, occasional speaker - Simplify C++! Blog - about #CleanCode, #cpp, #cplusplus - working at @zuehlke_group. Opinions are my own.",
      "mentorMessage": "DMs are open for questions or just chatting - happy to help with modern C++, got some experience with legacy code b… ",
      "mentorTwitter": "https://twitter.com/arne_mertz"
    },
    {
      "mentorName": "Joe Masilotti",
      "mentorTitle": "Joe is the lead developer for @BeerMenus. He loves clean code, craft beer, and chicken sandwiches. Before getting his beer on he worked at @PivotalLabs.",
      "mentorMessage": "If anyone has UI Test, XCTest or general questions around testing send me a DM or reply! ",
      "mentorTwitter": "https://twitter.com/joemasilotti"
    },
    {
      "mentorName": "Ryan Schmidt",
      "mentorTitle": "Graduated from Autodesk Research, now starting @gradientspace. Invented Autodesk @meshmixer, ShapeShop, other things.",
      "mentorMessage": "Q’s about mesh processing, @meshmixer, 3d printing, 3d user interfaces, shipping 3d tools, other? Fire away. ",
      "mentorTwitter": "https://twitter.com/rms80"
    },
    {
      "mentorName": "Rui Peres",
      "mentorTitle": "Lead iOS Engineer @babylonhealth | OSS & FRP zealot | @ReactiveCocoa member | 🏃🚴 | @elixirlang by night 🌙",
      "mentorMessage": "Will help anyone with FRP in Swift/iOS, MVVM and general iOS questions. Please DM, don’t be shy. ☺️ ",
      "mentorTwitter": "https://twitter.com/peres"
    },
    {
      "mentorName": "Thijs Niks 🇳🇱",
      "mentorTitle": "Product Manager for Cash at @Uber — transportation as reliable as running water, everywhere for everyone. Now in 500+ cities.",
      "mentorMessage": "Hello 👋 Happy to talk about product management, working in an European office of a Silicon Valley tech company, and… ",
      "mentorTwitter": "https://twitter.com/ThijsNiks"
    },
    {
      "mentorName": "whimsy.",
      "mentorTitle": "I’m too Good to be Neutral.  she/her.",
      "mentorMessage": "I’m really good at presenting complex information simply, and using/teaching iOS, macOS, tvOS, and watchOS! ",
      "mentorTwitter": "https://twitter.com/ladywhimsy"
    },
    {
      "mentorName": "Jenny (Key) Nguyen",
      "mentorTitle": "Coder, Weight-Lifter, FFTCG player, メギツネ",
      "mentorMessage": "I’m 7 months in on-and-off in learning Ruby on Rails, Minitest, and Git Desktop/commands on Mac OS. Feel free to DM… ",
      "mentorTwitter": "https://twitter.com/knockycode"
    },
    {
      "mentorName": "K. Louise Medeiros",
      "mentorTitle": "Data scientist. #rcatladies. #NASADatanaut. @ChickTechChi volunteer coordinator. You’re encouraged to tell me about your cat. tweets my own.",
      "mentorMessage": "Always happy to answer questions about biostats, intermediate R, learning resources, and things that have worked fo… ",
      "mentorTwitter": "https://twitter.com/kaelen_medeiros"
    },
    {
      "mentorName": "Marc Gear",
      "mentorTitle": "I was going to start a procrastination club, but couldn’t be bothered.",
      "mentorMessage": "Been paid to write code, and helped others do the same for 15 years. Hired people at all levels and done ‘agile’ in… ",
      "mentorTwitter": "https://twitter.com/marcgear"
    },
    {
      "mentorName": "Michael DeHaan",
      "mentorTitle": "Strategic consulting, photography, synthesizers, video games, computer jokes. Previously created & founded ansible.",
      "mentorMessage": "Have a question about anything?DM’s open. ",
      "mentorTwitter": "https://twitter.com/laserllama"
    },
    {
      "mentorName": "Scott Hirleman,CFA",
      "mentorTitle": "Hella smart and hella awesome financial analyst. I’ve done VC, FP&A, equity research, sales, sales ops, marketing, etc.; all views are mine/right",
      "mentorMessage": "I am always open if anyone wants to talk about whatever. Not an expert in much but have touched on many things ",
      "mentorTwitter": "https://twitter.com/shirleman"
    },
    {
      "mentorName": "jordan santell",
      "mentorTitle": "web VR/AR engineer @google, formerly platform devtools lead @mozilla, metal head, philly expat, cat dad, beard",
      "mentorMessage": "i know some things about web[VR/AR/audio]/js/redux/react and progressive death metal & like being helpful! ",
      "mentorTwitter": "https://twitter.com/jsantell"
    },
    {
      "mentorName": "Javi",
      "mentorTitle": "iOS Engineer 💻 @Twitch. Previously @Twitter, @Fabric, @Pebble📱. Rubik’s Cube speed solver (8.11s)⏱. Student Pilot 🛩. Chess player ♟. Space fan 🛰.",
      "mentorMessage": "👋 My DMs are always open! ",
      "mentorTwitter": "https://twitter.com/Javi"
    },
    {
      "mentorName": "Jess Levith",
      "mentorTitle": "I work with adults and young adults in my psychotherapy practice.                      Jessica Levith MFT# 84268",
      "mentorMessage": "I’m am here for questions about unhealthy attachments! ",
      "mentorTwitter": "https://twitter.com/JessLevithMFT"
    },
    {
      "mentorName": "erynofwaaaaaa 🏳️‍🌈",
      "mentorTitle": "iOS accessibility engineer. Tech, feminism, food, photography, space, calligraphy, and yoga. Queer. Obie ’10. she/her “real cute. v clever.”",
      "mentorMessage": "Happy to answer questions about accessibility on Apple platforms, plus general ObjC/Swift/programming stuff, w/in b… ",
      "mentorTwitter": "https://twitter.com/erynofwales"
    },
    {
      "mentorName": "Josh Ellis",
      "mentorTitle": "MPSE Nominated Sound Person doing VR Sound Design for @TheBodyVR. Fond of nature & science. I Used to keep helicopters flying & rescue people for $.",
      "mentorMessage": "I’m a regular audio dude living in a cyber punk future but if ya got questions on sound design, editing or mixing f… ",
      "mentorTwitter": "https://twitter.com/jealousaudio"
    },
    {
      "mentorName": "⣝⣵⡎⣵⢗⣿⣫⢗⡎⣵",
      "mentorTitle": "will the soundtrack kindly produce a sound",
      "mentorMessage": "pretty much the only question I ever get is “what engine do you use” ",
      "mentorTwitter": "https://twitter.com/zarawesome"
    },
    {
      "mentorName": "pierogi emoji",
      "mentorTitle": "I always wanted to be a librarian, now I do embedded. Zap! research papers/programming history/cooking/cycling/terrible puns/twitter bots/impish glee. he/they.",
      "mentorMessage": "I too am open to questions :) ",
      "mentorTwitter": "https://twitter.com/silentbicycle"
    },
    {
      "mentorName": "Kate Compton",
      "mentorTitle": "Maker of many interesting things.  Geologic choreographer, dance breeder, crafter of twitching generative bots.  Ask me about JavaScript.",
      "mentorMessage": "If you have a PCG or generative question ask.  If you list your constraints or problemspace, I can tell you which t… ",
      "mentorTwitter": "https://twitter.com/GalaxyKate"
    },
    {
      "mentorName": "Joe Fabisevich 🐶🐳™",
      "mentorTitle": "Cereal entrepreneur/iOS consultant. Lizard person who’s just telling like it is. 🐯🦁🐯 @Timehop and @Betaworks alum.  These twets are not endorsements.",
      "mentorMessage": "Been doing iOS since just after the App Store launched, and always happy to answer questions. 👋🏽 ",
      "mentorTwitter": "https://twitter.com/mergesort"
    },
    {
      "mentorName": "David Bishop",
      "mentorTitle": "Imperfect Feminist. Sysadmin. Dead Sexy. However stupid you think I am, I promise you: I’m stupider than that.",
      "mentorMessage": "If you need pointers on continuing to function while also endlessly weeping, my DMs are always open. ",
      "mentorTwitter": "https://twitter.com/gnuconsulting"
    },
    {
      "mentorName": "Brandon Williams",
      "mentorTitle": "Subterranean Homesick Mathematician. Texan. Functional Believer. Previously @Kickstarter. Available for hire: https://t.co/Trl8ZuIOBX",
      "mentorMessage": "Great idea! 👋 feel free to hmu about functional programming, category theory, algebra, topology, and anything here:… ",
      "mentorTwitter": "https://twitter.com/mbrandonw"
    },
    {
      "mentorName": "Alexis Kennedy 🕯️",
      "mentorTitle": "Failbetter founder/Fallen London+Sunless Sea creative director/Dragon Age+Stellaris+Telltale guest writer/CULTIST SIMULATOR dev",
      "mentorMessage": "I am open to questions. ",
      "mentorTwitter": "https://twitter.com/alexiskennedy"
    },
    {
      "mentorName": "Nicholas Laborde",
      "mentorTitle": "Video game business guy at @RaconteurDev. Chair of IGDA Lafayette. Provider of puns. Overly excited human. Making games that mean things.",
      "mentorMessage": "I love production & project management. If you want mentorship in that area, I’m happy to help. :) ",
      "mentorTwitter": "https://twitter.com/ChiefRaconteur"
    },
    {
      "mentorName": "Adam Dymitruk 🇨🇦",
      "mentorTitle": "CEO & Founder https://t.co/cJWWTqh95Q, Co-Host https://t.co/5A4TKvThQ5, distinguished Dev/Architect in #CQRS/ES Stack: #Golang, #Nodejs, C#, #Java OS: @KDENeon",
      "mentorMessage": "Happy to help with #microservices, DDD/CQRS/ES, #git and #linux desktop. Please message me if you need help! ",
      "mentorTwitter": "https://twitter.com/adymitruk"
    },
    {
      "mentorName": "james frewin ✨",
      "mentorTitle": "👨‍💻 Head of Creative @Labstep @Google @CampusLondon ⚡️ Founder @TeamDiscoveryUK 🏅 @Everipedia 30-Under-30 📍 Prev: @YikYakApp @Incuna ✨ @YSYSLondon",
      "mentorMessage": "Open to questions about Product Design, Marketing, App Design, Brand Design, Market Validation, Startups (+🍖🍉⚽️🚙 🎶🎬… ",
      "mentorTwitter": "https://twitter.com/jamesfrewin1"
    },
    {
      "mentorName": "Patima™ 💁🏻✨",
      "mentorTitle": "Creatively directing things @ @bamcreative+@team6Q | Host+Founder @localhostAU | Organiser @mixinconf | @AWIA committee + more, but running out of characters 😂",
      "mentorMessage": "🙋🏻✨ Always happy to help! ✨🙋🏻 ",
      "mentorTwitter": "https://twitter.com/the_patima"
    },
    {
      "mentorName": "Kevin Clark",
      "mentorTitle": "Design Lead, @Shopify. Organizer of the @MTLDesignClub. Co-host of @LayoutFM.",
      "mentorMessage": "If you think I can help you with something, don’t hesitate to ask. I would love to help out! ",
      "mentorTwitter": "https://twitter.com/vernalkick"
    },
    {
      "mentorName": "Jakub Valtar",
      "mentorTitle": "handcoded goodness / generative / interactive / @ProcessingOrg core dev",
      "mentorMessage": "Opened my DMs. Ask me details about Processing, I help develop it. Also interactive installations, math & algos for… ",
      "mentorTwitter": "https://twitter.com/jakubvaltar"
    },
    {
      "mentorName": "Aerospace Socialite",
      "mentorTitle": "Engineer by Day, Goddess by Night. Public Speaker, and Traveling the World. CEO and Co-Founder Intelligent Space @iSpaceIQ and Project Manager @BoldBrillance",
      "mentorMessage": "This is awesome! I love that folks are stepping up to help others! Look through this list and reach out! ",
      "mentorTwitter": "https://twitter.com/Dr_C_Taylor"
    },
    {
      "mentorName": "Edward Venator",
      "mentorTitle": "Hobbies include cooking and robots.",
      "mentorMessage": "If anyone has any questions about robot software or electronics, especially ROS, I can help. Also: C++, Python, CMa… ",
      "mentorTwitter": "https://twitter.com/fourpenguins"
    },
    {
      "mentorName": "vaporstack",
      "mentorTitle": "hand carved icebergs",
      "mentorMessage": "Always down to talk @AdobeAE scripting, C, C++, “creative coding”, python, gamedev, lifedrawing, or life anything ",
      "mentorTwitter": "https://twitter.com/vaporstack"
    },
    {
      "mentorName": "Ross Kaffenberger",
      "mentorTitle": "Father, programmer, triathlete. I break things and put them back together.",
      "mentorMessage": "I can answer questions about web development, esp with JavaScript and Ruby. Former teacher, so I really like this s… ",
      "mentorTwitter": "https://twitter.com/rossta"
    },
    {
      "mentorName": "⚜️ Dave Hogue ⚜️",
      "mentorTitle": "Trivia-filled, Design Lead @Google, Psychologist, Designer, Researcher, Speaker, Professor, https://t.co/g0jDWDF0ls Author, Motorcyclist, Traveler, Laughs a lot",
      "mentorMessage": "I love this idea, and I try to help as much as I can, but I also feel hobbled by doing it on twitter. How about, “S… ",
      "mentorTwitter": "https://twitter.com/DaveHogue"
    },
    {
      "mentorName": "Jurie Horneman",
      "mentorTitle": "Making games since 1991. Into interactive storytelling. Runs https://t.co/1tTISU1hkM. Dutch immigrant in Toronto. Opinions are my own.",
      "mentorMessage": "I’m open for questions about making games, any level. ",
      "mentorTwitter": "https://twitter.com/jurieongames"
    },
    {
      "mentorName": "Marc Edwards",
      "mentorTitle": "Founder and designer at @bjango. Currently building @skala.",
      "mentorMessage": "Always happy to help with design related questions. ",
      "mentorTwitter": "https://twitter.com/marcedwards"
    },
    {
      "mentorName": "PepsiPunk",
      "mentorTitle": "Scottish video game developer @ Rockstar North. Expect tweets about games, comics, football, ufc and general nonsense.",
      "mentorMessage": "If anyone wants advice in getting into games industry, or general help with game dev just ask! ",
      "mentorTwitter": "https://twitter.com/Pepsi_Punk"
    },
    {
      "mentorName": "",
      "mentorTitle": "Front end developer. 🇺🇸 in 🇨🇦. UX Systems @Shopify. Proud dog dad.",
      "mentorMessage": "I’m available to answer questions about front-end development, design systems, apprenticeships, and mentorship:… ",
      "mentorTwitter": "osenthal &#x1F415;](https://twitter.com/danmrosenthal"
    },
    {
      "mentorName": "Scott Vinkle",
      "mentorTitle": "Front end developer @SAteaches, formerly @Shopify • Co-organizer @CodePenOttawa • Chapter co-lead @LearningCodeYGK • Maintainer @A11YProject • #minimalist",
      "mentorMessage": "Always happy to help with front end or #a11y Q’s! DMs open if more comfortable that way. 🙂👋 ",
      "mentorTwitter": "https://twitter.com/svinkle"
    },
    {
      "mentorName": "Chris Matthews",
      "mentorTitle": "Works as a programmer on @IndivisibleRPG and plays Peacock in Skullgirls tournaments. Previously: co-creator of @MissTakeGame, programmer at @LionheadStudios",
      "mentorMessage": "I’m always open for game programming questions: gameplay, tools, or general C/C++ game coding. Ask away! ",
      "mentorTwitter": "https://twitter.com/itsMrPeck"
    },
    {
      "mentorName": "Juhani ʕ◉ᴥ◉ʔ",
      "mentorTitle": "Storyteller, game designer and freelance programmer, doing all that stuff under the name of @otsoi_.",
      "mentorMessage": "Always up for helping out! I don’t offer straight answers, I like giving out better questions & kicking you in the… ",
      "mentorTwitter": "https://twitter.com/argontus_"
    },
    {
      "mentorName": "Johan Thelin",
      "mentorTitle": "Qt maniac, likes embedded Linux, runs foss-north.se .  All opinions are my own.",
      "mentorMessage": "Anything to do with #Qt, embedded # Linux and #C++ - just ask. Also, don’t be afraid to join our #fossgbg meetings… ",
      "mentorTwitter": "https://twitter.com/e8johan"
    },
    {
      "mentorName": "Dominic McPhee",
      "mentorTitle": "Front End Developer Lead @shopify. JavaScript, CSS, Design Systems",
      "mentorMessage": "👋 I’m always happy to answer questions about front-end development or design systems. ",
      "mentorTwitter": "https://twitter.com/dfmcphee"
    },
    {
      "mentorName": "Richard Westenra",
      "mentorTitle": "Front-end dev; interactive #datavis designer; #d3js specialist; @codebar organiser. 🇳🇿 He/him. Views expressed belong to someone probably",
      "mentorMessage": "CSS, d3, dataviz, front-end, SVG, UX, etc. Hit me up! ",
      "mentorTwitter": "https://twitter.com/RichardWestenra"
    },
    {
      "mentorName": "Emiliano",
      "mentorTitle": "first trelewense at @mural  indie gamedev  dueño de https://t.co/52AndkgOAg twitteo para que venga el bondi  opiniones are, of course, my own",
      "mentorMessage": "De todo front-end, algo de back, gamedev, JS-CSS-Webpack (?), empezando FP, no duden en preguntar, pm o reply ",
      "mentorTwitter": "https://twitter.com/elcarmon"
    },
    {
      "mentorName": "Ali Smith",
      "mentorTitle": "Web Developer at @overleaf. Hiking, F1 and Scouting is what I do. Occasional open science & altmetrics nerd",
      "mentorMessage": "This is a cool idea. Open for questions on Javascript, React and front end in general ",
      "mentorTwitter": "https://twitter.com/40_thieves"
    },
    {
      "mentorName": "Nicole Sullivan",
      "mentorTitle": "GEEK!",
      "mentorMessage": "CSS, Front-end, engineering management. Ask-away! :) ",
      "mentorTwitter": "https://twitter.com/stubbornella"
    },
    {
      "mentorName": "Darren Twiss",
      "mentorTitle": "Innovation, Design and Product Development using Mobile and The Internet of Things.",
      "mentorMessage": "Ask away. 17 years tech product development. Nearly 10 years iOS and android exp. Launched saas co, run contract an… ",
      "mentorTwitter": "https://twitter.com/darrentwiss"
    },
    {
      "mentorName": "Mattias Geniar",
      "mentorTitle": "👨🏻‍💻 at @nucleus_hosting, 🎙 at @syscast_online, ✍🏼 at @mattiasrss and @cronweekly, 🗣 at conferences and 🕵️ at @DnsSpy.",
      "mentorMessage": "Always happy to talk #DevOps, #DadOps & #SleepOps - my 3 favorite things in the world. ",
      "mentorTwitter": "https://twitter.com/mattiasgeniar"
    },
    {
      "mentorName": "Joe Goldberg",
      "mentorTitle": "No man is really defeated unless he is discouraged. –Bruce Lee",
      "mentorMessage": "Happy to answer questions about transitioning from engr to management, or anything to do with running a professiona… ",
      "mentorTwitter": "https://twitter.com/tenaciousjoe"
    },
    {
      "mentorName": "PiXL3",
      "mentorTitle": "Designing beautiful sites that are clean and effective across every device. Talk to me.",
      "mentorMessage": "👋 Stephanie.  I’m a badass woman in tech and Web Developer. Happy to help whenever. ps: you’re very inspiring. 👊🏽 ",
      "mentorTwitter": "https://twitter.com/WeArePixl3"
    },
    {
      "mentorName": "Pato Cano",
      "mentorTitle": "Ruby lover, Elixir enthusiast, avid gamer. Sr. Ruby Dev at ReplayGaming. Loves dogs 🐶 https://t.co/bxZEMum3Pa Views are my own.",
      "mentorMessage": "I’m no expert, but I can help with Ruby, Elixir, Git, CI, getting fired, and how to stay motivated while working 10… ",
      "mentorTwitter": "https://twitter.com/suprnova32"
    },
    {
      "mentorName": "Mike Deakin",
      "mentorTitle": "The greatest mind this side of my skull. I make codey things for fun: https://t.co/AMqMIJ7u3m https://t.co/D2uIRAQbU6",
      "mentorMessage": "I’m a Java developer, familiar with some other OO-friendly languages. Quite junior but leaned a lot recently and wi… ",
      "mentorTwitter": "https://twitter.com/Mick_Deak"
    },
    {
      "mentorName": "Damnit! They! (Tako)",
      "mentorTitle": "Furbaby parent. Queer AF. Unicorn. Easily Excited. Perverse DM. #QingOfSigil #IsItWednesdayYet? Commissions: Open!",
      "mentorMessage": "I am a scrub, but I am a scrub with a FEW tricks, and whatever I learn/know, I will share. Also tutorials ",
      "mentorTwitter": "https://twitter.com/octakopus"
    },
    {
      "mentorName": "Morgan",
      "mentorTitle": "Writer, game dev, gamer, pole athlete, mama bear. Freelance Narrative Designer. Former: Halo, Rift, Everquest2, others. NG. Sometimes ENFP, others INFJ",
      "mentorMessage": "Always open to field questions about narrative design. Also motherhood and pole dance if those are your cup o tea. ",
      "mentorTwitter": "https://twitter.com/missdoomcookie"
    },
    {
      "mentorName": "Not Rly Noteworthy",
      "mentorTitle": "Game/Level Designer on Riverbond, Dragon of Legends && Freelance && Allan Please Add Details",
      "mentorMessage": "Always open to chat abt getting started with game dev, being a game dev student or writing stuff! 😁 ",
      "mentorTwitter": "https://twitter.com/Devon_Wiersma"
    },
    {
      "mentorName": "Kale",
      "mentorTitle": "Quarries of Scred (https://t.co/SZtDsaB1ib) and Doktor Kale (https://t.co/cSnKV7chLK) series developer, also an Engineer.  Scope Creep Godlord",
      "mentorMessage": "If people want advice on the various things I discuss let me know. ",
      "mentorTwitter": "https://twitter.com/DarkestKale"
    },
    {
      "mentorName": "Kale",
      "mentorTitle": "Quarries of Scred (https://t.co/SZtDsaB1ib) and Doktor Kale (https://t.co/cSnKV7chLK) series developer, also an Engineer.  Scope Creep Godlord",
      "mentorMessage": "If people want advice on the various things I discuss let me know. ",
      "mentorTwitter": "https://twitter.com/DarkestKale"
    },
    {
      "mentorName": "Leisha @ bitbazaar",
      "mentorTitle": "Creator, Co-writer, Artist on @ProjectSolaceTO • environment development and concept artist • portfolio : https://t.co/VNIDqDV04O •",
      "mentorMessage": "I’ll answer what I can about the animation industry in toronto. ",
      "mentorTwitter": "https://twitter.com/LeishaRiddel"
    },
    {
      "mentorName": "Jen Pattison 🥑",
      "mentorTitle": "2D art on Steam Marines 2 for @Worthless_Bums. Disney’s The Pixelarity, Serena, Quest for Infamy, Havenrise, OotT. Freelance Illustrator https://t.co/WQvejpS37c",
      "mentorMessage": "If you need art feedback, help with Photoshop, or just wanna ask games industry art/freelance related questions, my… ",
      "mentorTwitter": "https://twitter.com/Estirdalin"
    },
    {
      "mentorName": "Mauricio Ruiz",
      "mentorTitle": "Audio maker (SFX - Music) for games and films. Music mixer. SAE NY. Portfolio: https://t.co/4D3Ork51CE | #GameAudio #SoundDesign #Mixing #Composing 🇧🇷🇨🇦",
      "mentorMessage": "I’ve been #mixing #music for 7 yrs now, and I’m glad to help. On the other hand, learning more and more about… ",
      "mentorTwitter": "https://twitter.com/_mauruiz"
    },
    {
      "mentorName": "Brian Okken",
      "mentorTitle": "Host of @TestAndCode (@testpodcast) and @PythonBytes. Lean TDD advocate, Agile heckler. Author of “Python Testing with pytest”",
      "mentorMessage": "I’m open to questions. If I don’t know the answer, I often know who to ask. ",
      "mentorTwitter": "https://twitter.com/brianokken"
    },
    {
      "mentorName": "Itamar T-T",
      "mentorTitle": "My name is actually Itamar Turner-Trauring, but that is too long for Twitter because software is terrible.",
      "mentorMessage": "As a software clown I’ve been writing buggy code for 20 years. Happy to answer anything, esp: productivity, sane wo… ",
      "mentorTwitter": "https://twitter.com/itamarst"
    },
    {
      "mentorName": "Mark @ Quakecon",
      "mentorTitle": "Game Programmer @idSoftware, Full Sail #GameDev alumni, @USNavy veteran, I ♥️ MMA, VR, AI, and you. Something something opinions my own.",
      "mentorMessage": "FWIW willing to help w/ anything Gamedev related, personal specialties: C++/VR/AI. Students, Veterans, Active duty… ",
      "mentorTwitter": "https://twitter.com/Tenacious_Diaz"
    },
    {
      "mentorName": "SuperSonic7CE",
      "mentorTitle": "Hey everyone I’m SuperSonic7CE! I host the game design show, Syntax_Error, and the Talking ‘n’ Drawing Podcast!  supersonic7ce@gmail.com",
      "mentorMessage": "I’m not even slightly well known but if anyone has any questions about game design, YouTube, or anything, let me kn… ",
      "mentorTwitter": "https://twitter.com/SuperSonic7CE"
    },
    {
      "mentorName": "Heidi Olsen",
      "mentorTitle": "#EmailGeek • Creative Coder • Fun Professional •  Senior Developer @eROI.",
      "mentorMessage": "Are your HTML emails not rendering correctly? I’m happy to help you troubleshoot! #EmailGeeks ",
      "mentorTwitter": "https://twitter.com/SwissWebMiss"
    },
    {
      "mentorName": "Xalavier Nelson Jr.",
      "mentorTitle": "Writer. Game Developer. IntroComp Co-Organizer. Christian. Creator of SCREW YOU, BEAR DAD!, Replacement, and other things supposedly too weird to exist.",
      "mentorMessage": "I’m always open to chatting with folks about narrative, writing, pitching, and public speaking.  Also: how awesome… ",
      "mentorTwitter": "https://twitter.com/WritNelson"
    },
    {
      "mentorName": "Manfred Delius Horn",
      "mentorTitle": "6LoWPAN, Dosenbratwurst, Marzipan und Schriftverkehr. | he/him",
      "mentorMessage": "I program embedded systems in C, desktops/servers in C++/Java, browsers in JS. Can provide rubber duck services, 2n… ",
      "mentorTwitter": "https://twitter.com/mandelhorn"
    },
    {
      "mentorName": "Rayna Anderson",
      "mentorTitle": "Narrative Designer/Voice Director @EidosMontreal. Industry speaker and mentor. Unsurprisingly, I tweet about games, writing, future tech, and Montreal.",
      "mentorMessage": "Got questions about the game industry, design, narrative or writing? You can contact me here or anon on… ",
      "mentorTwitter": "https://twitter.com/And_Rayna"
    },
    {
      "mentorName": "ehren aka swampbutt",
      "mentorTitle": "numbers wizard - loves plants - neurodivergent",
      "mentorMessage": "This thread is talking about programming, but if you have questions about plants or gardening or JVM languages or g… ",
      "mentorTwitter": "https://twitter.com/megalonyx_"
    },
    {
      "mentorName": "Brett Douville",
      "mentorTitle": "Former lead programmer at BGS (FO3, Skyrim, FO4) & LucasArts, Shipping Tacoma. Consultant. Must be kept busy.",
      "mentorMessage": "Glad for the reminder – I leave my DMs open for folks who have questions about game programming and development ge… ",
      "mentorTwitter": "https://twitter.com/brett_douville"
    },
    {
      "mentorName": "Mandy",
      "mentorTitle": "marketing for video games |marathon runner | real life cookie monster | random villain on @gamertagradio",
      "mentorMessage": "First, yes. Second, I would absolutely answer questions. Game marketing, PR, being a woman in the industry, how I g… ",
      "mentorTwitter": "https://twitter.com/ladyluck34"
    },
    {
      "mentorName": "Matthew DeLucas",
      "mentorTitle": "Opinions of Matthew DeLucas, lead developer of Battle High 2 A+ for Xbox One:  https://t.co/ZISH53W9kt…",
      "mentorMessage": "Sure, guess I’m open 4 questions shrug ",
      "mentorTwitter": "https://twitter.com/mattrified"
    },
    {
      "mentorName": "Jake Lewis",
      "mentorTitle": "Nerdy ‘n proud. Apprentice software dev whose company makes big swishy things",
      "mentorMessage": "If anyone needs help with getting to grips with DXL (9.2 upwards) I’m happy to help 💻🙂 ",
      "mentorTwitter": "https://twitter.com/zezblit"
    },
    {
      "mentorName": "Stephen Tanksley",
      "mentorTitle": "I’m Stephen! Former opera singer turned composer for #gamedev, #indiedev, #indiegame. I write catchy tunes using broken technology. I dig DMs. Say hello!",
      "mentorMessage": "This sounds like a good thing to be doing. I’m down for questions about audio from composers who are just getting s… ",
      "mentorTwitter": "https://twitter.com/StephenTanksley"
    },
    {
      "mentorName": "Arne Mertz 🌍",
      "mentorTitle": "Software craftsman, geek, #cpp blogger at Simplify C++!, #CleanCode trainer,  occasional speaker about both - working at @zuehlke_group. Opinions are my own.",
      "mentorMessage": "My DMs are open for questions or just chatting - happy to help with modern C++, got some experience with legacy cod… ",
      "mentorTwitter": "https://twitter.com/arne_mertz"
    },
    {
      "mentorName": "Matt Dean",
      "mentorTitle": "Graphics. Unity Technologies.",
      "mentorMessage": "I like this a lot. Willing to help with Unity, shaders, PBR, 3d art, substance, pretty much anything tech art. ",
      "mentorTwitter": "https://twitter.com/MatthewDean3D"
    },
    {
      "mentorName": "Stu Fox",
      "mentorTitle": "Learnings from on-premise",
      "mentorMessage": "Open to questions about Azure.  Also questions about being a proper curmudgeon. ",
      "mentorTwitter": "https://twitter.com/stufox"
    },
    {
      "mentorName": "Patrick Foley",
      "mentorTitle": "Customer support and more for @moraware. Racing dad. API lover. Sometimes blogger and podcaster. Former Microsoft evangelist. Used to play a mean violin",
      "mentorMessage": "Happy to answer questions about supporting APIs effectively (spoiler alert: examples) ",
      "mentorTwitter": "https://twitter.com/PatrickFoley"
    },
    {
      "mentorName": "Richard Busby",
      "mentorTitle": "Frequently outsmarted by chickens.",
      "mentorMessage": "Open to questions on anything AWS related :) ",
      "mentorTwitter": "https://twitter.com/buzzyNZ"
    },
    {
      "mentorName": "George Tsifrikas",
      "mentorTitle": "iOS Software Engineer @ Workable",
      "mentorMessage": "I’m available for answering iOS/Swift related questions! ",
      "mentorTwitter": "https://twitter.com/gtsifrikas"
    },
    {
      "mentorName": "Steaknap Sleepchew",
      "mentorTitle": "Android Tech Lead | Kotlin | Music | Words | Games | Aminals | Discordia | Religious Studies | Food | Bourbon   ||   My opinions are somebody else’s.",
      "mentorMessage": "Android Tech Lead in finance. Bootcamp grad. My degree is not in Computer Science Been using Kotlin in production f… ",
      "mentorTwitter": "https://twitter.com/treelzebub"
    },
    {
      "mentorName": "Steaknap Sleepchew",
      "mentorTitle": "Android Tech Lead | Kotlin | Music | Words | Games | Aminals | Discordia | Religious Studies | Food | Bourbon   ||   My opinions are somebody else’s.",
      "mentorMessage": "Android Tech Lead in finance. Bootcamp grad. My degree is not in Computer Science Been using Kotlin in production f… ",
      "mentorTwitter": "https://twitter.com/treelzebub"
    },
    {
      "mentorName": "Nirmal",
      "mentorTitle": "Software engineer, skater, amateur librarian 📚 \\n clean code, please",
      "mentorMessage": "Written quite a bit of JavaScript/Go/Java/PHP- experienced in webapps, algorithms and systems design. Happy to help… ",
      "mentorTwitter": "https://twitter.com/_nirmzworld"
    },
    {
      "mentorName": "✨ kane ✨",
      "mentorTitle": "avatar by 🤖 • talents: reading code • alt @riking27loud • https://t.co/SRtKnwHxGX • he/him",
      "mentorMessage": "I’ll try this out. Anyone got questions for me? ",
      "mentorTwitter": "https://twitter.com/riking27"
    },
    {
      "mentorName": "Sunjay",
      "mentorTitle": "I build universes in my text editor.",
      "mentorMessage": "Good amount of Rust knowledge, Python, Haskell, also been writing web apps for a decade. DMs are open to any progra… ",
      "mentorTwitter": "https://twitter.com/Sunjay03"
    },
    {
      "mentorName": "Judson",
      "mentorTitle": "Technical generalist, autodidact intellectual, tactfully forthright.  Unpretentious.",
      "mentorMessage": "Open - Web, containers, Ruby, JS, Go, Linux. Many opinions, more weakly informed, about a broader swath. ",
      "mentorTwitter": "https://twitter.com/judsonlester"
    },
    {
      "mentorName": "Maniष Goregaokar",
      "mentorTitle": "Avid reader, programmer, loves physics. Open source aficionado. Repatriate. Working on @ServoDev at Mozilla Research  🔑2843176E718ECB82A968F0393BBF4D3E2EF79F98",
      "mentorMessage": "Rust, random systems stuff, and general open source. Love to get more folks involved in open source! ",
      "mentorTwitter": "https://twitter.com/ManishEarth"
    },
    {
      "mentorName": "Jon Williams",
      "mentorTitle": "Founder at Culture Amp",
      "mentorMessage": "I’ve done a little bit of everything… But love to help with early stage - hiring, culture, product, design and ma… ",
      "mentorTwitter": "https://twitter.com/jonathannen"
    },
    {
      "mentorName": "",
      "mentorTitle": "ガトジイマイケル](https://twitter.com/mgattozzi)",
      "mentorMessage": "I work at @ElsenInc writing Haskell. In my spare time I write a lot of Rust. Studying for the JLPT N5  PGP: ",
      "mentorTwitter": "ae"
    },
    {
      "mentorName": "Stephanie Hurlburt",
      "mentorTitle": "Graphics Engineer & Entrepreneur. At Binomial making Basis, a texture compressor, with @richgel999 Prev Oculus, Unity. VR/C++/graphics https://t.co/tCE6XzZ6Mm",
      "mentorMessage": "@mgattozzi Cool, then quote-tweet or reply to this tweet I’m linking to now: ",
      "mentorTwitter": "https://twitter.com/sehurlburt"
    },
    {
      "mentorName": "Felix Sperling",
      "mentorTitle": "Software Engineer, Expat, Salsero, Sceptic.",
      "mentorMessage": "Happy to help with Linux, Ops, Java, C/C++, Ruby questions ",
      "mentorTwitter": "https://twitter.com/felixsperling"
    },
    {
      "mentorName": "Garrett McCullough",
      "mentorTitle": "Senior mobile engineer at https://t.co/ORVYYElxko and ski instructor",
      "mentorMessage": "I can help with React Native, React, JavaScript and advice for remote workers ",
      "mentorTwitter": "https://twitter.com/gwmccull"
    },
    {
      "mentorName": "Scott Arciszewski",
      "mentorTitle": "Residing at the intersection of PHP, security, cryptography, and open source software. @ParagonIE",
      "mentorMessage": "I’m not anyone of significance, but I am open to questions if anyone has them. DMs are open for this very reason.  ",
      "mentorTwitter": "https://twitter.com/CiPHPerCoder"
    },
    {
      "mentorName": "Jenni Sanders",
      "mentorTitle": "Data Nerd, Alpha Gam, Sooner",
      "mentorMessage": "I’m very, very used to T-SQL. ",
      "mentorTwitter": "https://twitter.com/agdjenn"
    },
    {
      "mentorName": "Nathan",
      "mentorTitle": "sw engr @ bing. love ⚾, 🎵, and 🐱",
      "mentorMessage": "Happy to help with navigating a sftwr eng career in a big org.  Also with  c#, aspnet, js, performance, and ux expe… ",
      "mentorTwitter": "https://twitter.com/natenovs"
    },
    {
      "mentorName": "Martyn Hare 🇬🇧",
      "mentorTitle": "Self-centred centrist who puts pragmatism before politicism. Strong believer in self-determinism. Obviously chaotic good, morality is a question for the moronic",
      "mentorMessage": "Happy to assist with IT support, breakfix, projects and security. If you wanna rant about bad design decisions, go… ",
      "mentorTwitter": "https://twitter.com/MartynHare"
    },
    {
      "mentorName": "Dana Ex Machina",
      "mentorTitle": "Mezzo-soprano and software engineer @NewRelic. Core team member @CucumberBDD. Opinions my own.",
      "mentorMessage": "Ruby engineer at New Relic. I’m here if you have questions! :) ",
      "mentorTwitter": "https://twitter.com/DanaScheider"
    },
    {
      "mentorName": "Ryan Musgrave",
      "mentorTitle": "Software engineer passionate about better ways of working. Love C# and JS. Tweets are my own.",
      "mentorMessage": "Software Engineer with a passion for JS, C# and agile stuff. Happy to help anyone out who has questions. :) ",
      "mentorTwitter": "https://twitter.com/bringer128"
    },
    {
      "mentorName": "pierogi emoji",
      "mentorTitle": "I always wanted to be a librarian, now I do embedded. Zap! research papers/programming history/cooking/cycling/terrible puns/twitter bots/impish glee. he/they.",
      "mentorMessage": "I’m open to ?s about testing, embedded (inc. Arduinos), C, Lua, parsing, compilers, networks, compression. ",
      "mentorTwitter": "https://twitter.com/silentbicycle"
    },
    {
      "mentorName": "Bill Hooker",
      "mentorTitle": "Thinkmonkey for hire.",
      "mentorMessage": "I’m a research manager in biotech; my experience is in diagnostics (both NA and protein based). Ex-academic. Always… ",
      "mentorTwitter": "https://twitter.com/sennoma"
    },
    {
      "mentorName": "Tired Tech Employee",
      "mentorTitle": "Looked for a burning pile of garbage to become my profile picture, but all Google showed me was images of Travis Kalanick.",
      "mentorMessage": "Designer with 7 years leading teams in product design and r&d projrcts. DMs open. ",
      "mentorTwitter": "https://twitter.com/TiredEmployee"
    },
    {
      "mentorName": "Jovalent Studios",
      "mentorTitle": "Small #indiedev studio making #indiegames. #gamedev “You had me at roguelike metroidvania.”",
      "mentorMessage": "DMs open for web dev, JavaScript, TypeScript, C#, node.js automation. Really I’d love to show someone all the new J… ",
      "mentorTwitter": "https://twitter.com/JovalentStudios"
    },
    {
      "mentorName": "Stephanie Hurlburt",
      "mentorTitle": "Graphics Engineer & Entrepreneur. At Binomial making Basis, a texture compressor, with @richgel999 Prev Oculus, Unity. VR/C++/graphics https://t.co/tCE6XzZ6Mm",
      "mentorMessage": "@silentbicycle Yeah, then Ishan’s script will pick it up. Just want to make sure you’re added! :) It’s this one: ",
      "mentorTwitter": "https://twitter.com/sehurlburt"
    },
    {
      "mentorName": "Stephanie Hurlburt",
      "mentorTitle": "Graphics Engineer & Entrepreneur. At Binomial making Basis, a texture compressor, with @richgel999 Prev Oculus, Unity. VR/C++/graphics https://t.co/tCE6XzZ6Mm",
      "mentorMessage": "Quote tweet/reply to this tweet I linked to, not these tweets, to be added to the other lists. Script picks it up. ",
      "mentorTwitter": "https://twitter.com/sehurlburt"
    },
    {
      "mentorName": "Matthew Blewitt",
      "mentorTitle": "Software developer @techspaceco. Performance is a feature. Opinions own.",
      "mentorMessage": "Always happy to receive questions on Ruby/Rails, PostgreSQL, Go, as well as coming from a liberal arts background (… ",
      "mentorTwitter": "https://twitter.com/mashd"
    },
    {
      "mentorName": "Stephanie Hurlburt",
      "mentorTitle": "Graphics Engineer & Entrepreneur. At Binomial making Basis, a texture compressor, with @richgel999 Prev Oculus, Unity. VR/C++/graphics https://t.co/tCE6XzZ6Mm",
      "mentorMessage": "Updated my blog’s Mentor List w more lists! If you want to be added to them, reply to this tweet or quote tweet it.… ",
      "mentorTwitter": "https://twitter.com/sehurlburt"
    },
    {
      "mentorName": "",
      "mentorTitle": "Coder, Weight-Lifter, FFTCG player, メギツネ",
      "mentorMessage": "Happy to answer, if I know it, or refer to resources I personally use regarding coding and weight-lifting.… ",
      "mentorTwitter": " N Nguyen](https://twitter.com/knockycode"
    },
    {
      "mentorName": "thatsBamboro",
      "mentorTitle": "No programming allowed; only kittens https://t.co/Ja0FTvK2pY",
      "mentorMessage": "I’ve got ~10 years of professional front-end web app dev experience. Not sure I’m a mentor but I’d love to answer q… ",
      "mentorTwitter": "https://twitter.com/thatsBamboo"
    },
    {
      "mentorName": "Lasse Diercks",
      "mentorTitle": "Freelance DesignOps right now helping @xing_de, worked for @jimdo, looking for gigs in Q1/2018, #a11y #css #ux #agile #designsystems",
      "mentorMessage": "You can ask me questions about reusable components in design systems, css, commit message format, git and cats ",
      "mentorTwitter": "https://twitter.com/lassediercks"
    },
    {
      "mentorName": "Darryl Daugherty",
      "mentorTitle": "Commercial investigator; founder & MD of VeriThai Investigations Co Ltd @VeriThai : Seamhead/Smart-ass/Second-rate Superhero : The Mencken Of The Mekong",
      "mentorMessage": "I can help you to crush your enemies, see them driven before you, and hear the lamentations of their stakeholders. ",
      "mentorTwitter": "https://twitter.com/DarrylDaugherty"
    },
    {
      "mentorName": "Julien Dorra",
      "mentorTitle": "Creative technologist. I build creative-tech formats & communities: #museomix co-founder • ArtGame weekend • @codinggouter • Fête #codecreatif. ➡️@SavoirsCom1",
      "mentorMessage": "You can ask me anything on organizing tech collaborative events and workshops, building a community around your pro… ",
      "mentorTwitter": "https://twitter.com/juliendorra"
    },
    {
      "mentorName": "Andreas Møller",
      "mentorTitle": " ",
      "mentorMessage": "I’m happy to answer questions on  functional JavaScript, @reasonml  and starting a tech company. ",
      "mentorTwitter": "https://twitter.com/cullophid"
    },
    {
      "mentorName": "Cobra El Diablo",
      "mentorTitle": " ",
      "mentorMessage": "Open to #computing #programming #languages #virtualworlds all rounder I suppose, 35 yrs programming, ZX81 -> Curren… ",
      "mentorTwitter": "https://twitter.com/CobraElDiablo"
    },
    {
      "mentorName": "John Haney",
      "mentorTitle": "iOS App Developer, dad, and husband. Creator of GrammarSnob, Flashlight, @Apps_OuterSpace, & @YearOfSwift. Views and opinions are not representing any company.",
      "mentorMessage": "I’m open to questions. Ask me anything about programming for Apple devices (Swift or Objective-C), or programming/m… ",
      "mentorTwitter": "https://twitter.com/johnhaney"
    },
    {
      "mentorName": "Ross Hendrickson",
      "mentorTitle": " ",
      "mentorMessage": "Open to DMs/Mentoring on GAE, AWS, large distributed consensus, ML (ASR, Semantics, NLP), golang, python, architect… ",
      "mentorTwitter": "https://twitter.com/savorywatt"
    },
    {
      "mentorName": "kiva, yr antifa gf",
      "mentorTitle": "personal account of @HBS_thratchen. ⚧ she/her. nothing here represents HBS.  trans people are now at war; how are you helping the cause?",
      "mentorMessage": "i’m always happy to answer game design questions, if you have any. I can’t imagine anyone wanting my hot takes on d… ",
      "mentorTwitter": "https://twitter.com/persenche"
    },
    {
      "mentorName": "Alison Stanton",
      "mentorTitle": "I solve problems, lead, help, code, & more. Happiest when solving #data puzzles. She/Her/Hers.",
      "mentorMessage": "I am open to questions. ",
      "mentorTwitter": "https://twitter.com/alison985"
    },
    {
      "mentorName": "Kevin Workman",
      "mentorTitle": "The Bob Ross approach to learning how to code.  https://t.co/pStvgr0ZTp",
      "mentorMessage": "I work at Google by day, HappyCoding.io by night. Specialize in Processing, P5.js, and “graduating” to more advance… ",
      "mentorTwitter": "https://twitter.com/KevinAWorkman"
    },
    {
      "mentorName": "Jesse Seymour",
      "mentorTitle": "BI developer / architect (by default as I am only BI person here), and aspiring to be a SQL Server MVP",
      "mentorMessage": "Always happy to help with what I can, namely starting a #pass local group, organizing #sqlsaturday,… ",
      "mentorTwitter": "https://twitter.com/JesseBizInt"
    },
    {
      "mentorName": "Pedro Lamas",
      "mentorTitle": "Software Development Consultant, Microsoft Windows Development MVP, Cimbalino Toolkit author (https://t.co/oSC7NVrX2e) Opinions are my own! #wpdev #uwp 🇵🇹 🇪🇺",
      "mentorMessage": "I can help with C# and UWP questions! Just drop me a message! ☺️ ",
      "mentorTwitter": "https://twitter.com/pedrolamas"
    },
    {
      "mentorName": "Adelbert Chang",
      "mentorTitle": "I like simple things. Sucker for clever names and word play. 函數式編程. My tweets are my own.",
      "mentorMessage": "I’m happy to help with FP, Haskell, Scala, network/graph analysis, and conference-y things (papers, talks, attendin… ",
      "mentorTwitter": "https://twitter.com/adelbertchang"
    },
    {
      "mentorName": "timShallahbim",
      "mentorTitle": "Creative director @motioncorps - Previously 22Cans - Previously Sproing - Animator with a long & varied body - Too orangey for crows - Opinions are my own",
      "mentorMessage": "scrunches eyes shut Artist for 20yrs, 16 as a char. animator, 13 in gamedev. Animation, Maya, rigging, pipelines,… ",
      "mentorTwitter": "https://twitter.com/timShallahbim"
    },
    {
      "mentorName": "Matt Gawarecki",
      "mentorTitle": "Software developer by trade; data science fan, co-parent of two beagles, and incessant tinkerer in my spare time. Bowties are cool.",
      "mentorMessage": "Data-loving software dev, here! Open to thoughtful conversations on team culture, proj mgmt, machine learning, dev… ",
      "mentorTwitter": "https://twitter.com/mattgawarecki"
    },
    {
      "mentorName": "Tim Evko",
      "mentorTitle": "Christ follower. Husband. Weight lifter. Front End Lead @ExecThread. Podcaster. Created https://t.co/GSZCkgy7jI. WordPress core contributor.",
      "mentorMessage": "Love getting questions and helping whenever possible, DMs are always open! ",
      "mentorTwitter": "https://twitter.com/Tevko"
    },
    {
      "mentorName": "Swizzlr",
      "mentorTitle": "Docker dilettante / Swift sorcerer / microservice mischief-maker / citizen of nowhere",
      "mentorMessage": "I am open to questions. I used to be an iOS developer; now I’m a backend Swift dev with a focus on devops. I might… ",
      "mentorTwitter": "https://twitter.com/swizzlr"
    },
    {
      "mentorName": "Swizzlr",
      "mentorTitle": "Docker dilettante / Swift sorcerer / microservice mischief-maker / citizen of nowhere",
      "mentorMessage": "I am open to questions. I used to be an iOS developer; now I’m a backend Swift dev with a focus on devops. I might… ",
      "mentorTwitter": "https://twitter.com/swizzlr"
    },
    {
      "mentorName": "Tracy Kennedy",
      "mentorTitle": "// Sass as a Service https://t.co/qRM6U23KG6",
      "mentorMessage": "I’m available to answer questions on CI/CD with Jenkins, product management, and toolchain trends across industries ",
      "mentorTwitter": "https://twitter.com/Tracy_Kennedy"
    },
    {
      "mentorName": "Dana Fried",
      "mentorTitle": "Technical Infrastructure @Google / Skating for the Rainier Rollergirls as Hydraulic Tess / Co-momming with @vrimj / 🌹🌲",
      "mentorMessage": "Senior tech lead/manager at Google and can give career advice. Prefer to mentor women/LGBTQ/PoC but everyone can as… ",
      "mentorTwitter": "https://twitter.com/leftoblique"
    },
    {
      "mentorName": "Melissa Mesku",
      "mentorTitle": "Developer, writer, entrepreneur, absurdist. Tweets crude markings on cave walls; retweets tattooed on my ass. Editor @NewWorkerMag @thevoidlitmag",
      "mentorMessage": "(1) How to find good-paying meaningful work (2) anything technical re: websites (3) anyone needing a laugh, DMs open ",
      "mentorTwitter": "https://twitter.com/MelissaMesku"
    },
    {
      "mentorName": "Pär Björklund",
      "mentorTitle": "Likes C++, code quality, architecture. Web developer by day, accidental sysadmin.",
      "mentorMessage": "No expert but can help with C++, windows development, debugging tips, code reviews ",
      "mentorTwitter": "https://twitter.com/Paxxi"
    },
    {
      "mentorName": "Oren Novotny",
      "mentorTitle": "Principal Architect at @BlueMetalInc. In to NuGet, .NET Core, Azure, Mobile, Security. Microsoft MVP. Xamarin MVP.",
      "mentorMessage": "I can help with .NET Core, multi-targeting, code signing, and NuGet. Hit me up. ",
      "mentorTwitter": "https://twitter.com/onovotny"
    },
    {
      "mentorName": "Kevin Jones",
      "mentorTitle": "Insomniac. Applied Crypto.",
      "mentorMessage": "I can talk security, specifically application security with cryptography or PCI compliance. ",
      "mentorTwitter": "https://twitter.com/vcsjones"
    },
    {
      "mentorName": "adrienne 🌝",
      "mentorTitle": "designer, artist, mothership. design director at @osso_vr. profile header by @carrot_boi. ❤️🍑💛💚💙💜",
      "mentorMessage": "DMs open! Ask me about immersive design, getting a design job in VR, bridging the gap btwn mid-level & senior, port… ",
      "mentorTwitter": "https://twitter.com/snickersnax"
    },
    {
      "mentorName": "Vince Baumel",
      "mentorTitle": "Father of 3 boys, #dataviz junkie, Tableau Desktop 10 Qualified Associate, musician, wannabe polymath and lover of trail mix",
      "mentorMessage": "Mentors and inspiration comes in all kinds of flavors. You never know when your particular skill set could be just… ",
      "mentorTwitter": "https://twitter.com/quantum_relic"
    },
    {
      "mentorName": "Jan Wildeboer",
      "mentorTitle": "Open Source https://t.co/480xYMbSjO Standards Fundamentalist.Decentralizing whatever exists.Citizen of the first Transnational Republic. #DMentor free mentoring via DM",
      "mentorMessage": "Open source business models? How to create, nurture communities? Need help with public speaking? Want to discuss id… ",
      "mentorTwitter": "https://twitter.com/jwildeboer"
    },
    {
      "mentorName": "Erika @🇳🇱",
      "mentorTitle": "♑ 🇲🇽 ♀️ Freelancing 3D generalist: modeling, rigging, texturing, animation. Open for commissions and any Qs I may be able to help you with :)",
      "mentorMessage": "I’m a 3D generalist and can help with 3D modelling, rigging, texturing, and animating for games in Blender & Maya,… ",
      "mentorTwitter": "https://twitter.com/opponent019"
    },
    {
      "mentorName": "Arti Villa",
      "mentorTitle": "Product Engineer with a penchant for analytics. Building product @workmarket @homesteadrelease, past @newscred @growndswell. Tweets for customer support.",
      "mentorMessage": "Same. Happy to help in with FE ecosystem, code reviews, interviews or someone to bounce ideas of. ¯_(ツ)_/¯ ",
      "mentorTwitter": "https://twitter.com/artivilla"
    },
    {
      "mentorName": "Garth Henson",
      "mentorTitle": "Husband, father, coder, architect, mentor, musician, photographer and all around great guy! Lead engineer at @disney by day, Sith Lord by night.",
      "mentorMessage": "Always open to help with Node.js, JavaScript, WordPress, general architecture or just tech networking. Seldom get i… ",
      "mentorTwitter": "https://twitter.com/guahanweb"
    },
    {
      "mentorName": "Axel Wagner",
      "mentorTitle": "Neurodiverse tech person. Hug Enthusiast. European. All opinions expressed are my own. Pronouns: He/Him (but don’t mind, really)",
      "mentorMessage": "Not that I am very useful: But I am always willing to help with #golang questions/code reviews when I can. You’d be… ",
      "mentorTwitter": "https://twitter.com/TheMerovius"
    },
    {
      "mentorName": "Λdrøn @ ¯_(ツ)_/¯",
      "mentorTitle": "Coder, recon, metal (when I post music, do beware), messenger, cyclist, economist, livability, Urban Cascadian and other viking like characteristics.",
      "mentorMessage": "On this note, finally got into a position to help, the items include the following stream of things; ",
      "mentorTwitter": "https://twitter.com/Adron"
    },
    {
      "mentorName": "ironsauce",
      "mentorTitle": "Software engineer @ Google. Feminist. ML junkie. Armchair archaeologist. Opinions my own, not of anyone who’s paying me. Proud alumna of @brynmawrcollege in CS.",
      "mentorMessage": "I’m available to review resumes, slide decks, give feedback on your presentations and blog posts. DM me or email at… ",
      "mentorTwitter": "https://twitter.com/juliaferraioli"
    },
    {
      "mentorName": "Roy Tang",
      "mentorTitle": "Programmer, engineer, scientist, critic, gamer, dreamer, and kid-at-heart.",
      "mentorMessage": "Why not? Willing to help on Java, Python, Django, Sql, Javascript/node and general software dev stuff, especially f… ",
      "mentorTwitter": "https://twitter.com/roytang"
    },
    {
      "mentorName": "James Cash",
      "mentorTitle": "Computer engineer that loves programming, lifting, and wondering what I’m wrong about.  He/him",
      "mentorMessage": "If anyone needs a hand with Clojure, Clojurescript, shell scripting, vim, emacs, or other, I can probably help (or… ",
      "mentorTwitter": "https://twitter.com/jamesnvc"
    },
    {
      "mentorName": "Baked Sphincter",
      "mentorTitle": "#unreal programmer for @FrontwireGames for Galaxy in Turmoil Speedruns at https://t.co/f9Vkx4Q6p4 Looking for UE4 C++/BP work!",
      "mentorMessage": "Freshly graduated, but I’m happy to help out with C#, MonoGame and Unreal Engine 4 as much as I can! ",
      "mentorTwitter": "https://twitter.com/DarkLight08"
    },
    {
      "mentorName": "dasilva @ LDN🇬🇧",
      "mentorTitle": "I love designing experiences. VR and multiplayer enthusiast. Software Engineer Intern @ImprobableIO. Collaborator at Mocha.js.  Organizer @HackUPC.",
      "mentorMessage": "And huge thanks to @sehurlburt for this excellent thread, and her great stream of daily thoughts/tweets! 😊 ",
      "mentorTwitter": "https://twitter.com/dasilvacontin"
    },
    {
      "mentorName": "Fabian Blechschmidt",
      "mentorTitle": "PHP Coder, Magento-Enthusiast, Visionary Trainee",
      "mentorMessage": "Let’s try this. If you have questions about PHP, Magento, public speaking, Germany, Berlin, @lizardspumpkins or Eco… ",
      "mentorTwitter": "https://twitter.com/Fabian_ikono"
    },
    {
      "mentorName": "Caleb Cochran",
      "mentorTitle": "FUNemployed Software Engineer.  Looking for new opportunities! DMs open. Previously @Starchup. Coffee addict, former Alabamian, and Mother of Dragons.",
      "mentorMessage": "Ask me anything about pizza or nutterbutters. It’s a pretty in depth, field, but I can try! Also, web app architect… ",
      "mentorTwitter": "https://twitter.com/C_Cochran"
    },
    {
      "mentorName": "Mario Zechner",
      "mentorTitle": "Benevolent dictator of libGDX, Beginning Android Games, RoboVM",
      "mentorMessage": "DMs open. Happy to talk about public speaking, writing tech books, compilers, game dev, VR, startups, contracts, hi… ",
      "mentorTwitter": "https://twitter.com/badlogicgames"
    },
    {
      "mentorName": "ericjboyd",
      "mentorTitle": "edu/health apple device enterprise architect & infosec experience proponent. board gamer, craft beer fiend, gadget fanatic.",
      "mentorMessage": "Always happy to help answer questions about managing Apple devices in Healthcare. Got workflow, MDM, DEP & VPP ques… ",
      "mentorTwitter": "https://twitter.com/ericjboyd"
    },
    {
      "mentorName": "Kyle Shevlin",
      "mentorTitle": "Senior Software Engineer at @fastly. Love #JavaScript, focused on #reactjs & #redux applications. https://t.co/n68TFKscyW",
      "mentorMessage": "I’m willing to help out with JavaScript, especially React questions. Just send me a message sometime. ",
      "mentorTwitter": "https://twitter.com/kyleshevlin"
    },
    {
      "mentorName": "Kyle Shevlin",
      "mentorTitle": "Senior Software Engineer at @fastly. Love #JavaScript, focused on #reactjs & #redux applications. https://t.co/n68TFKscyW",
      "mentorMessage": "I’m willing to help out with JavaScript, especially React questions. Just send me a message sometime. ",
      "mentorTwitter": "https://twitter.com/kyleshevlin"
    },
    {
      "mentorName": "Taiki",
      "mentorTitle": "French C/ObjC developer, interested in security and by how things work at the low level. I broke macOS once. Mass Effect fan. Enchanteur de magiciel",
      "mentorMessage": "Welp, feel free to hit me up. Worst case scenario is that I take a few hours to tell you I can’t help you on someth… ",
      "mentorTwitter": "https://twitter.com/Taiki__San"
    },
    {
      "mentorName": "Yaakov",
      "mentorTitle": "Being awful at something is the first step to being good at something.",
      "mentorMessage": "Again: Ask me about C#, .NET, .NET Core, ASP .NET WebAPI, HTTP, MSBuild, Continuous Integration, Git, TFS, TFVC, pr… ",
      "mentorTwitter": "https://twitter.com/yaakov_h"
    },
    {
      "mentorName": "Yawar λmin",
      "mentorTitle": "OpenPGP: 0x12C86554 · some other stuff goes here",
      "mentorMessage": "Ask me anything about statically typed functional programming. At the very least, I can point you in right directio… ",
      "mentorTwitter": "https://twitter.com/yawaramin"
    },
    {
      "mentorName": "Zac Gross",
      "mentorTitle": "Meeple in disguise as a Gameplay Programmer at NetherRealm Studios. I just want to make games.",
      "mentorMessage": "Game Dev by day. Send me any C++ questions you have. I’m friendly 🙋 ",
      "mentorTwitter": "https://twitter.com/Brickman1444"
    },
    {
      "mentorName": "Mr. Turkey",
      "mentorTitle": "Inscrutable at times who cares - what is YOUR measure of success? largely tease fellow #infosec ppl & others & passionate f4 human Adoption From Foster Care ama",
      "mentorMessage": "#HurricaineIrma prep expert :) ",
      "mentorTwitter": "https://twitter.com/MrTurkey"
    },
    {
      "mentorName": "Mlle Licious",
      "mentorTitle": "customer support|training|translation|SE|online privacy and security|WISP volunteer|addicted to espresso martini|gifted with dark,Brit humor|🦄powers for good😈",
      "mentorMessage": "This is a great thread from @sehurlburt - SO MANY people offering help/advice/mentoring. This community is the best. ",
      "mentorTwitter": "https://twitter.com/MlleLicious"
    },
    {
      "mentorName": "Caroline",
      "mentorTitle": "Software Engineer @PivotalCF. Bibliophile. Jew. Queer. Artist. My opinions are my own. Name is pronounced ‘Care-o-lynn’. they/them",
      "mentorMessage": "I’m usually happy to chat or answer questions. Esp ?s on starting in tech, git, deploying distributed systems, tdd,… ",
      "mentorTwitter": "https://twitter.com/CarolineTaymor"
    },
    {
      "mentorName": "Joseph Kohlmann",
      "mentorTitle": "Dev+design+HCI+UX+listening @nytimes @TBrandStudio. House music, feminism, diversity/inclusion, #BlackLivesMatter, journalism, politics, empathy, broken systems",
      "mentorMessage": "Reminder: you can DM me about front-end web stuff (lately: React, Sass, Webpack). Also my official statement is: in… ",
      "mentorTwitter": "https://twitter.com/jkohlmann"
    },
    {
      "mentorName": "Bosco Publicus",
      "mentorTitle": "Loser and Hater. Bad Hombre. I’m generally about 14 hours behind. If I @ you and don’t make sense, I’m probably on pain meds.",
      "mentorMessage": "I’m out of practice, but Linux admin, bash, python, nagios, admin stuff ",
      "mentorTwitter": "https://twitter.com/bpub"
    },
    {
      "mentorName": "Kelly",
      "mentorTitle": "Breakfast, computers and networks, the outdoors.",
      "mentorMessage": "I’m always happy to nerd out on Scala, systems engineering, networks, and cooking 😊 ",
      "mentorTwitter": "https://twitter.com/kaoudis"
    },
    {
      "mentorName": "The Techie",
      "mentorTitle": "Nerd. Musician. Developer. Producer. Just out here trying to get into a little bit of everything.",
      "mentorMessage": "I can help with college stuff like picking a major, differences in engineering fields, picking schools, android bas… ",
      "mentorTwitter": "https://twitter.com/The_Mystery_One"
    },
    {
      "mentorName": "Jowanza Joseph",
      "mentorTitle": "Senior Data Engineer and author of The Apache Spark Field Book.",
      "mentorMessage": "Happy to take questions about Apache Spark and Data Engineering anytime. ",
      "mentorTwitter": "https://twitter.com/Jowanza"
    },
    {
      "mentorName": "Lorxus Writes Math🌹",
      "mentorTitle": "Official tweets from Korean Crown & only guru of Monster Truck Buddhism. Fluffy red fox, Terran, Simic researcher, knot theorist, DemSoc, Lojbanist.",
      "mentorMessage": "THIS! Please ask! Literally all of math. Most science, too. Korean, French, Old Greek, mental health. AD for what s… ",
      "mentorTwitter": "https://twitter.com/CoronaCoreanici"
    },
    {
      "mentorName": "🌞🏜 eevee 🏜🌞",
      "mentorTitle": "hi! i do computers, make games, write, draw, and love my cat. (check my website!) all my tweets are sarcastic.  she/🦊. secret weird smut account: 🔞 @squishfox",
      "mentorMessage": "i can definitely help you out with, um checks clipboard robotic, acs, and gbz80 assembly.  granted that last one… ",
      "mentorTwitter": "https://twitter.com/eevee"
    },
    {
      "mentorName": "Jeff O’Leary",
      "mentorTitle": "Mobile Dev",
      "mentorMessage": "iOS developer for 5 years, team lead/manager at @WayfairEng.  Always up for chatting about swift, objc, career deve… ",
      "mentorTwitter": "https://twitter.com/jepecito"
    },
    {
      "mentorName": "Rob Tougher",
      "mentorTitle": "Dev/dataviz/perf @Microsoft (Exchange Online Protection). Volunteer @tealsk12org. Hubby. Dad. Disneyland and Star Wars nerd. Tweets are my own.",
      "mentorMessage": "I’m open to questions. Programming, performance engineering, careers, data viz, Microsoft, TEALS teaching, compsci,… ",
      "mentorTwitter": "https://twitter.com/robtougher"
    },
    {
      "mentorName": "giles",
      "mentorTitle": "the crack of doom on the hydrogen jukebox. RTs are postmodern reverberations in a perpetual decontextualization machine",
      "mentorMessage": "open to questions re rails, javascript, react, algorithmic music, shell scripting, git, clojure, node, even perl. ",
      "mentorTwitter": "https://twitter.com/gilesgoatboy"
    },
    {
      "mentorName": "carrie 🐶😻😻😻😻",
      "mentorTitle": "instructor @_CodeCrew. web dev. dog/cat mom. lifelong student. let’s learn something together.",
      "mentorMessage": "Are you a woman in a non-tech career looking to get into a developer role? DM me. Let’s chat. #WITpayitforward ",
      "mentorTwitter": "https://twitter.com/carriecoxwell"
    },
    {
      "mentorName": "Joseph D. Marhee",
      "mentorTitle": "systems engineer. historian. record collector.",
      "mentorMessage": "Totally open to questions/chit-chat about systems, devops, infrastructure, etc. ",
      "mentorTwitter": "https://twitter.com/jmarhee"
    },
    {
      "mentorName": "Ben M. Strozykowski",
      "mentorTitle": "Certified Ethical Hacker. DevOps guy. Author of horrible things. My better half is @ixix82. Our kids speak Mandarin. Opinions expressed are my own.",
      "mentorMessage": "Open to questions about being a recovering addict and staying clean & sober in a tech career. DMs welcome, anonymit… ",
      "mentorTwitter": "https://twitter.com/stroz"
    },
    {
      "mentorName": "",
      "mentorTitle": "masking](https://twitter.com/__biancat)",
      "mentorMessage": "software engineer: *nix, Node.js, infra. immigrant. collector of tech socks. 🐦 adhd, cats, doggos, bad jokes, programming, rants. views: mine onl",
      "mentorTwitter": ""
    },
    {
      "mentorName": "Jeremy Tregunna",
      "mentorTitle": "VP of Engineering @metismachine. My bikeshed is blue. Separate church and state. Functional programmer, dad jokes, hockey. My opinions, they be my own and stuff",
      "mentorMessage": "Periodic reminder I’m approachable. Can help with info I wish I knew when I broke in, platforms like erlang/elixir,… ",
      "mentorTwitter": "https://twitter.com/jtregunna"
    },
    {
      "mentorName": "Leigh Taylforth",
      "mentorTitle": "When I eat sushi I ask for two sets of chopsticks so I can pretend it’s not all for me…   🐷 🍣",
      "mentorMessage": "Entrepreneurship, international business, derivatives theory, venture capital, company valuations.  Shoot me anythi… ",
      "mentorTwitter": "https://twitter.com/leightaylforth"
    },
    {
      "mentorName": "Alex Flores",
      "mentorTitle": "Whatever you are, be a good one. Software Engineering Resident @Google. Esperantisto.",
      "mentorMessage": "Im not expert at anything but love to chat about functional programming, math, algs, compilers, basic AI. Or, hey,… ",
      "mentorTwitter": "https://twitter.com/_Venko"
    },
    {
      "mentorName": "Jaycie@FlameCon L118",
      "mentorTitle": "They/Them. Web developer, programmer, cutie, writer. Can’t get enough of Ruby and JavaScript. Play my game: https://t.co/b3L3D3YhUb. Avatar: @hedgemom.",
      "mentorMessage": "Ruby, JavaScript, software architecture. ",
      "mentorTwitter": "https://twitter.com/thirdtruck"
    },
    {
      "mentorName": "Jaycie@FlameCon L118",
      "mentorTitle": "They/Them. Web developer, programmer, cutie, writer. Can’t get enough of Ruby and JavaScript. Play my game: https://t.co/b3L3D3YhUb. Avatar: @hedgemom.",
      "mentorMessage": "Ruby, JavaScript, software architecture. ",
      "mentorTwitter": "https://twitter.com/thirdtruck"
    },
    {
      "mentorName": "Conrad Spots",
      "mentorTitle": "Othello! Ex-@silvermink. 🏳️‍🌈 poly furry DJ, feminist, 🐈 owner, coder, liker of 🏍, 📷, 🔫, 🕹. He/him. 🎧 @djgedm, 🍆 @rawcelot, 😘 @Messy_Muse #BLM #NaziFursFuckOff",
      "mentorMessage": "I’m generally open to questions about programming (I do mostly Java and React) and any of the interests on my profi… ",
      "mentorTwitter": "https://twitter.com/pawcelot"
    },
    {
      "mentorName": "Sanket Nadhani",
      "mentorTitle": "New products @Wingify. Previously @FusionCharts. Books, tech, movies, TV series, food, beer, travel. And Internet funnies. Mostly Internet funnies.",
      "mentorMessage": "B2B products, marketing, hiring, strategy. ",
      "mentorTwitter": "https://twitter.com/sanketnadhani"
    },
    {
      "mentorName": "Greg Wilson",
      "mentorTitle": "RIP Heather Heyer: “If you’re not outraged, you’re not paying attention.”",
      "mentorMessage": "I’m open to questions about mixing academic and industrial careers, and am happy to chat with people who have ‘em. ",
      "mentorTwitter": "https://twitter.com/gvwilson"
    },
    {
      "mentorName": "innanetmatt",
      "mentorTitle": "Programming Is Easy. I love helping people be happier & more productive through tech.",
      "mentorMessage": "Web development, agency life, freelancing/consulting. Automated testing/TDD/clean code… Hit me up! I’m always dow… ",
      "mentorTwitter": "https://twitter.com/mchandleraz"
    },
    {
      "mentorName": "Corey Quinn",
      "mentorTitle": "Public Speaker, Cloud Economist, and snappy dresser. Father to @QuinnyPiglet. Writes https://t.co/EPbRRMqxAp.",
      "mentorMessage": "I’m thrilled to talk about anything that touches AWS, cloud TCO, DevOps, git, consulting, public speaking, and/or c… ",
      "mentorTwitter": "https://twitter.com/QuinnyPig"
    },
    {
      "mentorName": "Rob Nelson",
      "mentorTitle": "vInfrastructure and Security Engineer | Full Stack Human | Blogger | vExpert ‘14-‘17 | VCP6-DCV | PCP 2016 | My opinions are my own | my hair is long",
      "mentorMessage": "I am good at Puppet and Operations and have 18 years of war stories. Here to help any way I can. ",
      "mentorTwitter": "https://twitter.com/rnelson0"
    },
    {
      "mentorName": "Bridget Reed",
      "mentorTitle": "south philly resident // front-end developer // designer, organizer, & instructor at @gdiphilly // @temple_fb fan ✨All opinions are my own✨",
      "mentorMessage": "If you have any questions about making the leap from design to front-end development, especially as a woman in tech… ",
      "mentorTwitter": "https://twitter.com/BridgetCReed"
    },
    {
      "mentorName": "Joachim Coste",
      "mentorTitle": "Marketing Strategy in Montreal. Pay attention / get mad. I really wish I could just study history though.",
      "mentorMessage": "Branding, customer experience. ",
      "mentorTwitter": "https://twitter.com/jcoste"
    },
    {
      "mentorName": "b a knowles",
      "mentorTitle": "socio-techical system design, feedback loops, and self-expression ♊📧 send me broken sidewalk pics or whatever press@snotskie.com 🤷 https://t.co/AVwiXXqpRn",
      "mentorMessage": "AMA, my focus bounces between CompSci and English, meaning a lot of epistemiology, statistics, graph theory, ethics… ",
      "mentorTwitter": "https://twitter.com/snotskie"
    },
    {
      "mentorName": "Quiet boops",
      "mentorTitle": "Horizontal, data, math, healthcare, & other things. #100DaysofDS #100DaysofCode",
      "mentorMessage": "Not sure if anyone will need my help, but I have SME in medicine & surgery. I also have some substance abuse experi… ",
      "mentorTwitter": "https://twitter.com/tbdlmtd"
    },
    {
      "mentorName": "conlin",
      "mentorTitle": "front-end engineer @mimirhq ▴ aspiring polymath / traveler ▴ art+tech+community",
      "mentorMessage": "If you need help with Javascript/React, basics for functional programming in JS, or dev career advice, I’d love to… ",
      "mentorTwitter": "https://twitter.com/CallMeWuz"
    },
    {
      "mentorName": "Jennifer Manganello",
      "mentorTitle": "public health professor @UAlbanySPH | alum @JohnsHopkinsSPH & @BUSPH | helping people communicate @ health | tweeting #healthliteracy & all things health comm",
      "mentorMessage": "I am always happy to chat with people about #healthcomm and #healthliteracy! ",
      "mentorTwitter": "https://twitter.com/healthcommphd"
    },
    {
      "mentorName": "Joshua Mauldin",
      "mentorTitle": "Designer. Usually thinking about typography, prototyping an app, or petting a dog.",
      "mentorMessage": "I’d gladly help with designing apps, prototyping, or dealing with conflict ",
      "mentorTwitter": "https://twitter.com/joshuamauldin"
    },
    {
      "mentorName": "NASA peepo",
      "mentorTitle": "dazed and confused but trying to continue",
      "mentorMessage": "I’m pretty good at debugging C code, troubleshooting electronics and general systems/low-level stuff as well as int… ",
      "mentorTwitter": "https://twitter.com/grievre"
    },
    {
      "mentorName": "Greggawatt",
      "mentorTitle": "Security, Web Development, Contemporary Art, Sound Art, #ruby #rails #javascript",
      "mentorMessage": "If you’re starting out with ruby, rails or javascript and need some guidance, I’m very down to help you out! ",
      "mentorTwitter": "https://twitter.com/greggawatt"
    },
    {
      "mentorName": "Robin Kunde",
      "mentorTitle": "iOS/backend engineer. Occasional Swift compiler contributor. I got joke’s too. They’re bad though.",
      "mentorMessage": "I can help with Swift, ObjC, iOS, and backend dev. Also, general consulting advice. ",
      "mentorTwitter": "https://twitter.com/robinkunde"
    },
    {
      "mentorName": "Christopher Anderson",
      "mentorTitle": "┗(-_- )┓ OS hackerish person. Fuchsia @ Google. I care about social empathy. Nurru in games.",
      "mentorMessage": "I’m happy to chat / help with general CS concepts, C, C++, OS design, embedded dev, hardware/drivers.  I wish my ni… ",
      "mentorTwitter": "https://twitter.com/nvll"
    },
    {
      "mentorName": "Terry Cabeen",
      "mentorTitle": "I like data almost as much as I like people. Live on Coffee, Puns, and Hugs. Based on a true story. Resist Trump.",
      "mentorMessage": "I will mentor you with SQL, Perl, and general concepts (data acquisition/management, documentation, career manageme… ",
      "mentorTwitter": "https://twitter.com/tcabeen"
    },
    {
      "mentorName": "Joe Radak ⛄",
      "mentorTitle": "(VR)Level Designer for hire, King of the Snowgoons, UE4 Game dev. CoFound @eeriebeargames Make VR games. Available for Contract work! Run @leveldesign_jpg",
      "mentorMessage": "As always - will help out new level designers, and will always do my best to give feedback on any pics/layouts/et… ",
      "mentorTwitter": "https://twitter.com/Fr0z3nR"
    },
    {
      "mentorName": "John Rockefeller",
      "mentorTitle": "Ｖｉｒｔｕａｌ Ｒｅａｌｉｔｙ __ Ｇａｍｅ Ｄｅｖｅｌｏｐｅｒ",
      "mentorMessage": "If you have any questions about Atari, Unity3d, Linux, or git, I’m always down to help out. ",
      "mentorTwitter": "https://twitter.com/Rocky1138"
    },
    {
      "mentorName": "Andrew",
      "mentorTitle": "Bye, see you never.",
      "mentorMessage": "Happy to answer anything about iOS development, uiux design, or Architecture. 😊👍 ",
      "mentorTwitter": "https://twitter.com/andrewgierke"
    },
    {
      "mentorName": "Andrew Harvey",
      "mentorTitle": "Shouts at computers. Drinks whisky.",
      "mentorMessage": "Need help with Ruby, Elixir, system design, architecture, devops, iOS, watchOS, tvOS? My DMs are open. ",
      "mentorTwitter": "https://twitter.com/mootpointer"
    },
    {
      "mentorName": "Jess Telford",
      "mentorTitle": "Frontend lead @DomainComAu | Developer Drinkups & @ReactSydney meetups founder | Javascript instructor | Speaker | OSS Enthusiast | Opinions == mine",
      "mentorMessage": "Send me your JS Q’s!  I’m sometimes slow to respond, but I taught JS professionally & love to help. I’ll make the t… ",
      "mentorTwitter": "https://twitter.com/jesstelford"
    },
    {
      "mentorName": "Renaissance Grrrl",
      "mentorTitle": "The off-hours rants of a Linguistical Mathematician ❀ type theory, morphosemantics, resistance ❀ ⚢♿☸☭✊",
      "mentorMessage": "I’m always open to questions about type-, proof-, automata-, category theories, grammar formalisms, morphology, sem… ",
      "mentorTwitter": "https://twitter.com/wrengr"
    },
    {
      "mentorName": "Renaissance Grrrl",
      "mentorTitle": "The off-hours rants of a Linguistical Mathematician ❀ type theory, morphosemantics, resistance ❀ ⚢♿☸☭✊",
      "mentorMessage": "I’m always open to questions about type-, proof-, automata-, category theories, grammar formalisms, morphology, sem… ",
      "mentorTwitter": "https://twitter.com/wrengr"
    },
    {
      "mentorName": "Disco Daniel",
      "mentorTitle": "Tortillas are awesome! (he/him)",
      "mentorMessage": "Aight   If you have questions about python, swift, git or GitHub, software project mgmt, or KSP, @ me ",
      "mentorTwitter": "https://twitter.com/breakthesystem"
    },
    {
      "mentorName": "Tom",
      "mentorTitle": "Just a Broadcast Engineer for the Discovery Channel",
      "mentorMessage": "Ask me about complex TV Signals and Systems, Win2000-16, maintaining obsolete systems.   Newbie to Python and C#, b… ",
      "mentorTwitter": "https://twitter.com/tomglover24"
    },
    {
      "mentorName": "Teddy V",
      "mentorTitle": "Some coding schmuck. “I’m a Russian Intelligence Officer” badge available upon request. he/him",
      "mentorMessage": "I’ve been working with Perl for about 6 years, and am more than happy to help however I can with either ",
      "mentorTwitter": "https://twitter.com/echophantom"
    },
    {
      "mentorName": "Andreas Jörgensen",
      "mentorTitle": "25-year old 3D artist from Sweden. My middle name is literally Danger. Freelancing and currently available for hire!",
      "mentorMessage": "hey sure if you have any questions about 3d art i guess i can help out ",
      "mentorTwitter": "https://twitter.com/hideous_"
    },
    {
      "mentorName": "Nicolas Guillemot",
      "mentorTitle": "Gamedev, Rendering, GL, DX, C++. Graphics @ University of Victoria.",
      "mentorMessage": "Ask a question in the /r/GraphicsProgramming discord and I’ll likely get nerdsniped. Always glad to help people at… ",
      "mentorTwitter": "https://twitter.com/nlguillemot"
    },
    {
      "mentorName": "Tzetze",
      "mentorTitle": "Goo guru. Synthetic psephology expert. Infuriatingly amphichiral cybernetics buff. Professional alife geek. Vertical. Mother. Mother. Mother. Mother. Mother.",
      "mentorMessage": "dunno what i know but if you ever wanna ask me shit go for it i guess ",
      "mentorTwitter": "https://twitter.com/mnxmnkmnd"
    },
    {
      "mentorName": "M Duhamel",
      "mentorTitle": "writer, and multimedia artist. Living and working aboard a van studio || 📐, he/him",
      "mentorMessage": "Ask me about van life and feelings and writing  if you wish ",
      "mentorTwitter": "https://twitter.com/dualhammers"
    },
    {
      "mentorName": "Justin Duke",
      "mentorTitle": "code and prose, @tenantbase • previously @williamandmary, @amazon",
      "mentorMessage": "👋 ask me about python, front-end development (react and vue), web scraping, consulting, and poetry  ",
      "mentorTwitter": "https://twitter.com/justinmduke"
    },
    {
      "mentorName": "/Alёx",
      "mentorTitle": "aka Lorin. Software developer. Web, .net, js. Art & rpg lover. Hard on Trimethylxanthine. Tweets in german, russian, english. https://t.co/kjjac7k7uz for pics",
      "mentorMessage": "Can help with translation to/from german, russian, softwaredeveloperian ",
      "mentorTwitter": "https://twitter.com/ostelaymetaule"
    },
    {
      "mentorName": "Mark Lyon",
      "mentorTitle": "I provide eDiscovery advice and supervision.",
      "mentorMessage": "Reminder that I’m open to helping those looking to get into eDiscovery. ",
      "mentorTwitter": "https://twitter.com/markhlyon"
    },
    {
      "mentorName": "Aaron L Marks",
      "mentorTitle": "Developer, Grad Student, Educator, Political Junkie, Liberal, Realist, Feminist, Queer, Ally, Accidental YouTuber, Comms @bullitt_dems. Views = Mine. He/Him.",
      "mentorMessage": "Ask me about C# - or just anything you need help with. If I can’t give you the answer, I’ll find someone who can. ",
      "mentorTwitter": "https://twitter.com/amdev83"
    },
    {
      "mentorName": "raven",
      "mentorTitle": "I like to pet dogs AND I write code at MailChimp. Carefree Black Girl. A fan of hip hop, whiskey, cigars, and sports. I ain’t sorry.",
      "mentorMessage": "The best I have to offer is advice on being new to software development, finding a job, feeling confident in your n… ",
      "mentorTwitter": "https://twitter.com/_raven_io"
    },
    {
      "mentorName": "Bilbo Vader",
      "mentorTitle": "Project Analyst, Technology, Linux enthusiast, XONE, SNES, OpenSource, English, Astronomy, 功夫",
      "mentorMessage": "ask me about Python, Java, Linux and Project management. In English or Portuguese :D ",
      "mentorTwitter": "https://twitter.com/bilbovader"
    },
    {
      "mentorName": "⣝⣵⡎⣵⢗⣿⣫⢗⡎⣵",
      "mentorTitle": "it is the nineties and there is time for klax",
      "mentorMessage": "uhh sure? I’m a super genericist so no idea what i could answer that other people couldn’t ",
      "mentorTwitter": "https://twitter.com/zarawesome"
    },
    {
      "mentorName": "M",
      "mentorTitle": "🐍Python developer🐍 I tweet about software, games and more (🇪🇸🇬🇧)",
      "mentorMessage": "Reminder that I will gladly help with Python, gamedev, Emacs & Linux/Ubuntu 😉 ",
      "mentorTwitter": "https://twitter.com/prizetyping"
    },
    {
      "mentorName": "Skylar MacDonald",
      "mentorTitle": "You know, from that thing. I do stuff in telly and radio at @wearetinykettle and @londonlive. I used to do internet things for a very fast car. 🇪🇺🏳️‍🌈❤ [Mx]",
      "mentorMessage": "This is popular rn and I’m not the best person for your tech questions but if you’ve ever wondered literally anythi… ",
      "mentorTwitter": "https://twitter.com/helloiamskylar"
    },
    {
      "mentorName": "Pat ꩜ Home",
      "mentorTitle": "Developer. He/Him",
      "mentorMessage": "I’m happy to help folks with Obj-C, Swift, Mac/iOS dev and navigating Apple’s interfaces for publishing apps&podcas… ",
      "mentorTwitter": "https://twitter.com/Tekgo"
    },
    {
      "mentorName": "candle 🕯️",
      "mentorTitle": "i am not a content creator // nb willennial // they/them // https://t.co/Xzoc7TvVql",
      "mentorMessage": "ask me about C#, unity, tool design, shitposts, getting into casual gamedev ",
      "mentorTwitter": "https://twitter.com/ragzouken"
    },
    {
      "mentorName": "summer 🌸",
      "mentorTitle": "coding and codeine. not yr gf. i ♥ @alfiepates",
      "mentorMessage": "so, ask me about drugs, linguistics, writing, programming, or direct action any time ",
      "mentorTwitter": "https://twitter.com/velartrill"
    },
    {
      "mentorName": "Alyssa Ross 👩‍💻",
      "mentorTitle": "@MacHomebrew and @Linuxbrew maintainer. I build from source so you don’t have to. Cypherpunk. [she/her] 🏳️‍🌈🏴 https://t.co/nN7WRSDlD1 ED0AE8D0A913FDC2",
      "mentorMessage": "hmu with your Homebrew/Linuxbrew/Ruby questions and I’ll do my best to help :) ",
      "mentorTwitter": "https://twitter.com/qyliss"
    },
    {
      "mentorName": "Demi",
      "mentorTitle": "quiet code witch | ⚧ ⚢ | unapologetic trans | hacker | (she/her)",
      "mentorMessage": "hey folks,  so if you want to ask me stuff about xcode, build systems, c, objc, nim, python, os x, and various thin… ",
      "mentorTwitter": "https://twitter.com/queersorceress"
    },
    {
      "mentorName": "Dan@home",
      "mentorTitle": "Will make snarky comments for food. eSports rule everything around me. Avatar by @DJMSPaint",
      "mentorMessage": "I am happy to answer any and all questions related to UX and Front-End Web Development (HTML, CSS, JS) ",
      "mentorTwitter": "https://twitter.com/giantrobotbee"
    },
    {
      "mentorName": "mcc",
      "mentorTitle": "glitch girl – current avatar by @egypturnash",
      "mentorMessage": "OK, sure  If you need help with Python, Lua, C, ObjC, OCaml, C#, general gamedev, generative audio, or Mono AOT mod… ",
      "mentorTwitter": "https://twitter.com/mcclure111"
    },
    {
      "mentorName": "Marie Helene",
      "mentorTitle": "Squishing bugs, one at a time. 🐛🐦 ZFS guru, FreeBSD contributor, self-proclaimed security 👼daemon👼, and hobby photographer.",
      "mentorMessage": "I can help with #FreeBSD, #ZFS, networking (switches, vlan, isolation etc), #csharp, .NET and more. ",
      "mentorTwitter": "https://twitter.com/Savagedlight"
    },
    {
      "mentorName": "PiXL3",
      "mentorTitle": "Designing beautiful sites that are clean and effective across every device. Talk to me.",
      "mentorMessage": "I can help with HTML, CSS, Javascript, DNS, S3, HTML5 Video. 😀 ",
      "mentorTwitter": "https://twitter.com/WeArePixl3"
    },
    {
      "mentorName": "Jeremy Diamond",
      "mentorTitle": "Immersive Tech + Media + Politics + Crosswords | Lapsed TV producer | Feminist buzzkill | All about @DanielleMohlman",
      "mentorMessage": "I know lots about tech, media, marketing, negotiations, strategy, pricing, finance, fundraising, and pitching. Also… ",
      "mentorTwitter": "https://twitter.com/Jer_Diamond"
    },
    {
      "mentorName": "nick peihl",
      "mentorTitle": "JavaScript developer, islander, husband, adopted by a cat and two greyhounds. Curses freely (sorry, mom).  Equity 📢 is 📢 more 📢 important 📢 than 📢 equality!",
      "mentorMessage": "Local government GIS, offline web mapping, progressive web apps, starting ballet in your 30s. I’m open to ❓s. ",
      "mentorTwitter": "https://twitter.com/nickpeihl"
    },
    {
      "mentorName": "Michal Migurski",
      "mentorTitle": "Oakland/SF Bay Area technology & open source GIS person. @Remix, previously at @mapzen, @codeforamerica, and @stamen. Frequent attendee at @geobreakfast.",
      "mentorMessage": "Python, geo stuff, demographic data, maps. If you’re into that sort of thing. ",
      "mentorTwitter": "https://twitter.com/michalmigurski"
    },
    {
      "mentorName": "Matt Hoffman",
      "mentorTitle": "Programmer. Doing AR/VR and a little bit of everything else. Lots of UE4 and Unity knowledge.",
      "mentorMessage": "Happy to chat with anyone about Unity, Unreal or using Jenkins for building and deploying projects automatically! ",
      "mentorTwitter": "https://twitter.com/LordNed"
    },
    {
      "mentorName": "Emma Brillhart",
      "mentorTitle": "React and shenanigans @FormidableLabs | Lead Organizer @SeattleJS | I know eyerolls, I have the best eyerolls",
      "mentorMessage": "React, GraphQL, general JavaScript, communication with non-tech stakeholders, F•R•I•E•N•D•S trivia ",
      "mentorTwitter": "https://twitter.com/emmabrillhart"
    },
    {
      "mentorName": "Jerry Chen",
      "mentorTitle": "VP of Engineering at @UnionMetrics. Previously: @RockstarGames, @IllinoisCS/@EngineeringAtIL, the Northeast, 台灣. Followed by @cjdphr.",
      "mentorMessage": "ops, ruby, java, cool tweets, barely made it through compsci academia, red sox, will work for favs. ask away ",
      "mentorTwitter": "https://twitter.com/jcsalterego"
    },
    {
      "mentorName": "~-Colin-Curtin____",
      "mentorTitle": "Engineering Manager, @captain401, co-creator @rhetoriccoffee, I’m gonna hire you and make you coffee.  15-1134.00 Dance Technician",
      "mentorMessage": "@robjloranger @nicolefv @OldCrowEW @jessfraz @jilljubs There are lots of people on @sehurlburt’s mentor list who wo… ",
      "mentorTwitter": "https://twitter.com/perplexes"
    },
    {
      "mentorName": "Tierney Cyren",
      "mentorTitle": "⬡.js - Developer Advocate at @NodeSource. Node.js Community Committee & Evangelism WG. @pacabites, my boo. Want to talk? Happy to DM.",
      "mentorMessage": "Saw this on July 23. I posted on Aug 8 offering help w/ @nodejs. 10 people reached out. One of them landed their fi… ",
      "mentorTwitter": "https://twitter.com/bitandbang"
    }
  ]
};


// WEBPACK FOOTER //
// ./src/misc/db.js